
let obj = {}
obj.CN = {
    auth: {
        back: "反面",
        finish: "已認證",
        front: "正面",
        id_number: "護照/證件號",
        input_id_num: "請輸入護照/證件號",
        input_info: "請完善個人訊息",
        input_name: "請輸入您的姓名",
        name: "姓名",
        upload_back: "上傳護照/證件反面",
        upload_front: "上傳護照/證件正面",
        upload_idcard: "請上傳護照/證件的正反面",
        waiting: "審核中"
    },
    bank: {
        SWIFT: "SWIFT",
        account: "收款人帳戶",
        address: "銀行地址",
        coin_type: "收款貨幣",
        name: "銀行名稱",
        remark: "備註",
        swift_text: "SWIFT",
        username: "收款人"
    },
    financial: {
        bank: "銀行卡",
        bank_charge: "電匯",
        charge_amount: "充幣數量",
        charge_coin: "充幣",
        charge_history: "入金記錄",
        charge_num: "充值金額",
        coin: "數字貨幣",
        collect_coin_type: "收款貨幣",
        copy_address: "複製地址",
        financial_records: "財務記錄",
        input_charge_amount: "请输入充幣數量",
        input_charge_num: "请输入充值金額",
        isfinish: "已完成",
        isreject: "已拒絕",
        link_charge: "鏈上充值",
        select_network: "選擇網絡",
        uncheck: "未審核",
        unuseful: "無效",
        wallet_address: "錢包地址"
    },
    forgot: {
        input_sms_code: "請輸入驗證碼",
        reset: "重置密碼",
        send: "發送",
        sms_code: "驗證碼"
    },
    func: {
        billing_detail: "帳單詳情",
        charge_coin: "入金",
        invite_friend: "邀請好友",
        lang: "語言",
        real_auth: "實名認證",
        reset_password: "修改密碼",
        setting: "設置",
        wallet: "錢包",
        withdraw_coin: "出金",
        loan: "信用借款",
        buy_coin: "銀行卡買幣",
        video_desc: "視訊簡介",
        more: "更多",
        transfer: "劃轉",
        contract: "合約",
        future: "期限"
    },
    order: {
        all_caution_money: "當前保證金",
        balance: "餘額",
        bond_fee: "保證金",
        buy_in: "買入",
        calc_bond_fee: "預估保證金",
        calc_handle_fee: "預估手續費",
        can_use: "可用預付款",
        cancel: "撤單",
        close: "平倉",
        close_price: "平倉價",
        confrim_close_order: "是否平倉",
        currency: "交易對",
        current_price: "當前價",
        dealing: "掛單",
        detail: "訂單詳情",
        hand_num: "手數",
        handle_fee: "手續費",
        hazard_rate: "風險率",
        history: "歷史",
        holding: "持倉",
        income: "收益",
        market_price: "市價",
        open_time: "開倉時間",
        order_id: "訂單號",
        order_price: "下單價",
        order_type: "方向",
        page: "手",
        pay_rate: "預付款比",
        profit: "盈虧",
        sell_out: "賣出",
        set_stop_price: "修改止盈止損",
        stop_loss: "止損",
        stop_profit: "止盈",
        times: "倍數",
        total: "淨值",
        total_ol: "總盈虧",
        trade_amount: "買入數量",
        trading: "開倉",
        un_deal_order: "掛單",
        unit: "每手"
    },
    public: {
        add: "添加",
        cancel: "取消",
        chat: "聯繫客服",
        coming_soon: "敬請期待~",
        confirm: "確認",
        confirm_del: "確定刪除嗎？",
        copy: "複製",
        copy_success: "複製成功",
        delete: "刪除",
        freeze: "凍結",
        history: "記錄",
        input_full: "請填寫完整",
        last_price: "最新價",
        market: "趨勢",
        name: "名稱",
        no_data: "暫無數據",
        no_more: "沒有更多了",
        number: "數量",
        other: "其它",
        password_not_equal: "密碼不一致",
        product_list: "產品列表",
        quotation: "漲跌幅",
        set: "修改",
        setting: "設置",
        status: "狀態",
        submit: "提交",
        submit_order: "下單",
        tip: "提示",
        upload_pic: "上傳憑證",
        use: "可用",
        today: "今日",
        my_assets: "我的資產",
        total_assets: "總帳戶資產折合",
        invite_tip: "掃上面的二維碼圖案或輸入邀請碼，確認註冊",
        record: "記錄",
        all: "全部",
        please_input: "請輸入",
        close: "關閉",
        clear: "清空",
        test: "僅用於測試"
    },
    trade: {
        balance: "餘額",
        best_price: "以當前最優價格交易",
        buy: "買入",
        buy_low: "做空",
        buy_price: "價格",
        buy_up: "做多",
        close_order: "平倉",
        closed: "休市",
        current_entrust: "當前委託",
        enter_price: "請輸入價格",
        high: "高",
        last_price: "市價",
        low: "低",
        no_mult: "暫無倍數",
        no_mult_config: "未配置槓桿,暫時無法下單",
        open: "开",
        operate: "操作",
        order: "訂單",
        order_confirm: "您的訂單已確認",
        order_page: "訂單頁面",
        price: "單價",
        sell: "賣出",
        time: "時間",
        trade_amount: "交易手數",
        trade_price: "交易額",
        type: "類型",
        volume: "總量"
    },
    user: {
        account_detail: "賬戶詳情",
        announ: "公告",
        announ_text: "由於政策原因，不向朝鮮，以色列，中國，瓦努阿圖，古巴提供服務。",
        area_code: "區號",
        can_use_asset: "可用資產",
        com_email: "投訴郵箱",
        confirm_logout: "是否退出登錄",
        confirm_reset: "是否重置",
        copy_invite_link: "複製邀請鏈接",
        dh: "電話",
        email: "郵箱",
        forgot_password: "忘記密碼",
        h_accept: "接受",
        h_second: "秒",
        h_timer: "倒計時",
        h_welc: "歡迎使用",
        input_email: "請輸入您的郵箱",
        input_invite_code: "請輸入邀請碼",
        input_old_password: "請輸入舊密碼",
        input_password: "請輸入密碼",
        input_phone: "請輸入您的手機號碼",
        invite_code: "邀請碼",
        join_us: "立即加入",
        login: "登錄",
        login_email: "郵箱登錄",
        login_phone: "手機登錄",
        logout: "退出登錄",
        logout_success: "退出成功",
        mock_account: "模擬帳戶",
        mock_login: "無需開戶，立即創建模擬賬戶進行交易！",
        new_paw: "New password",
        new_user: "新用戶？",
        only_true_account: "請註冊或者登入真實帳戶",
        password: "密碼",
        please_login: "請登錄",
        qh: "區號",
        qh_dh: "區號/電話",
        re_input_pass: "再次輸入密碼",
        register: "註冊",
        register_email: "郵箱註冊",
        register_phone: "手機註冊",
        reset_mock_account: "重置模擬賬戶",
        trade_account: "交易帳戶",
        useful_balance: "可用資金",
        user_center: "個人中心",
        welcome_login: "歡迎登錄",
        welcome_register: "歡迎註冊"
    },
    wallet: {
        bind: "綁定",
        bind_bank_card: "綁定銀行卡",
        bind_coin_address: "綁定數字貨幣地址",
        not_bind: "請先設置收款賬戶",
        save: "保存",
        change_account: "資金帳戶",
        micro_account: "期權帳戶",
        forex_account: "合約帳戶"
    },
    withdraw: {
        amount: "數量",
        calc_get: "預計到賬數量",
        no_pay_way: "該法幣賬戶暫無支付渠道",
        record: "提幣記錄",
        select_withdraw_address: "请选择提幣地址",
        send_amount: "到賬數量",
        symbol: "貨幣",
        unit: "單位",
        withdraw_address: "提幣地址",
        withdraw_coin: "提幣"
    },
    follow: {
        apply_guide: "申請須知",
        auto_open_positions: "自動開倉手數",
        closed_follow_order: "已平倉跟隨單",
        commission_rate: "抽成費率",
        copy_profit: "跟單獲利",
        cover_time: "平倉時間",
        follow: "跟隨",
        follow_master: "跟隨交易員",
        followed: "已跟隨",
        follower: "跟隨者",
        follower_num: "跟隨人數",
        follower_sum: "跟隨者總數",
        following_order: "進行中的跟隨單",
        history_order: "歷史訂單",
        i_agree: "我已閱讀並同意",
        lever: "倍數",
        limit_price: "限價",
        margin: "保證金",
        master_trader: "交易員",
        max_following: "最大跟隨",
        my_follower: "我的跟隨者",
        rate_of_return: "收益率",
        size: "規模",
        start_ordering_now: "立即開始首單",
        submit_apply: "提交申請",
        total_documentary_amount: "總跟單金額",
        total_profit: "總收益",
        total_revenue: "總收益",
        unfollow: "取消跟隨",
        view_follow_earnings: "查看跟隨收益",
        will_pay_profit: "待結算收益",
        auto_follow: "每次交易專家開倉產品，我都會自動跟隨開倉",
        be_master: "成為高手",
        follow_now: "立即跟隨",
        follower_setting: "跟單設定",
        submit_multiple: "下單倍率",
        max_follow_bond: "每單最大跟隨保證金",
        be_trader: "成為交易員",
        cancel_follow_tip: "未平倉訂單不會再繼續跟隨平倉,可能導致錯過最佳平倉時機,確定要取消嗎",
        confirm_cancel_follow: "取消跟隨訂單",
        trader_list: "交易員列表"
    },
    micro: {
        statistics: "統計",
        high: "高",
        low: "低",
        "24h_volume": "24H量",
        open: "開",
        close: "收",
        buy_up: "買漲",
        buy_down: "買跌",
        trading_pairs: "交易對",
        direction: "方向",
        select_trade_time: "選擇到期時間",
        calc_profit_rate: "預計收益率",
        trade_num: "交易數量",
        input_trade_num: "請輸入交易數量",
        calc_income: "預期收益",
        profit_rate: "收益率",
        open_time: "開倉時間",
        close_time: "平倉時間",
        in_transaction: "交易中",
        closed_position: "已平倉",
        trade_time: "時長",
        predict_profit: "預計盈虧",
        profit: "盈虧"
    },
    loan: {
        loan: "貸款",
        verify: "開始驗證",
        last_name: "名稱",
        input_last_name: "請輸入名稱",
        first_name: "姓氏",
        input_first_name: "請輸入姓氏",
        sex: "性別",
        male: "男",
        female: "女",
        birthday: "出生日期",
        country: "國家",
        input_country: "請輸入國家",
        mobile: "手機號碼",
        input_mobile: "請輸入手機號碼",
        identify_card: "證件",
        id_card: "身份證",
        passport: "護照",
        hand_pic: "手持證件照片",
        auth_waiting: "待稽核",
        auth_success: "審核通過",
        auth_reject: "稽核駁回",
        select_day: "請選擇日期",
        please_waiting: "感謝您提交KYC檔案。 我們的團隊將在48小時內稽核您的資訊。 請耐心等待稽核結果。",
        please_sign: "請簽名",
        sign: "簽名",
        resign: "重新簽名",
        start_loan: "開始享受我們的借貸服務",
        amount: "金額",
        input_amount: "請輸入金額",
        max: "最大",
        loan_time: "貸款期限",
        day: "天",
        day_rate: "日利率",
        total_profit: "總利息",
        free_day: "免息天數",
        verified: "已驗證",
        loan_now: "現在借款",
        loan_order: "貸款訂單",
        loaning: "您正在申請貸款",
        need_repay: "需還款",
        penalty_amount: "違約金",
        reviewed_at: "準予時間",
        repayment_time: "還款日期",
        agreement: "協定",
        repay: "現在還款",
        is_repay: "已還款",
        confirm_repay: "還款確認",
        confirm_repay_tip: "請確認您的還款資訊",
        transfer_address: "轉帳地址",
        copy_address: "複製地址",
        upload_credit: "上傳憑證",
        to_repayment: "去還款",
        is_rejected: "已駁回",
        repayment_check: "還款稽核中",
        confirm_repayment: "確認還款"
    },
    transfer: {
        number: "劃轉數量",
        input_number: "請輸入劃轉數量",
        history: "劃轉記錄",
        from: "從",
        to: "至"
    },
    mining: {
        mining: "理財",
        doing: "進行中",
        finished: "已結束",
        refunded: "已退款",
        refunding: "申請退款中",
        pay: "支付",
        expected_profit: "預計日產",
        input_lock_num: "請輸入鎖倉數量",
        interest: "利息",
        machine_rent: "礦機租金",
        max_subscribe: "最大申購",
        mining_time: "挖礦期限",
        pay_penal_sum_redemption: "違約金申請提前贖回",
        product_desc: "產品介紹",
        profit_list: "收益列表",
        redemption: "違約贖回",
        subscribe: "申購",
        subscribe_list: "申購列表",
        subscribe_num: "申購數量",
        subscribe_time: "申購時間",
        watch_profit_list: "查看收益列表",
        better1: "隨存隨取",
        better2: "每日下發",
        better3: "挖礦週期",
        better4: "隨時空投",
        name: "名稱",
        product_better: "產品優勢",
        product_content: "雲挖礦是通過USDT託管給平臺超算力礦機在AI超智能平臺的礦池中進行搬磚挖礦收益",
        machine_list: "礦機列表",
        my_subscribe: "我的申購",
        coin_type: "幣種",
        operate: "操作",
        day_profit: "預計日產",
        sum_profit: "預計總收益"
    }
}
obj.en = {
    public: {
        name: "Name",
        last_price: "Last Price",
        market: "Trend",
        quotation: "24H Change",
        no_data: "No data yet",
        no_more: "No more",
        confirm: "confirmation",
        use: "Available",
        freeze: "Freeze",
        number: "Quantity",
        history: "Record",
        other: "Other",
        tip: "Prompt",
        copy_success: "Copied successfully",
        upload_pic: "Uploading Certificate",
        submit: "Submit",
        status: "Status",
        set: "Set ",
        chat: "Online Service",
        copy: "Copy",
        delete: "delete",
        confirm_del: "Are you sure to delete?",
        add: "Add",
        input_full: "Please complete",
        password_not_equal: "Password inconsistency",
        coming_soon: "Coming soon~",
        cancel: "Cancel",
        setting: "Setting",
        product_list: "Product List",
        submit_order: "Submit Order",
        all: "All",
        clear: "Clear",
        close: "Closure",
        invite_tip: "Scan the QR code pattern above or enter the invitation code to confirm registration.",
        my_assets: "My assets",
        please_input: "Please enter",
        record: "Record",
        test: "Just for testing",
        today: "Today",
        total_assets: "Total account asset conversion"
    },
    user: {
        h_second: "second",
        h_timer: "countdown",
        h_accept: "Accept",
        h_welc: "Welcome to use",
        announ_text: "Due to policy reasons, services are not provided to North Korea, Israel, China, Vanuatu, and Cuba.",
        announ: "announcement",
        com_email: "Complaint email",
        dh: "telephone",
        qh: "area code",
        qh_dh: "area code/telephone",
        user_center: "Mine",
        login_email: "Enter your Email",
        login_phone: "Mobile Login",
        input_email: "Please enter your email address",
        input_phone: "Please enter your cell phone number",
        password: "Password",
        new_paw: "New password",
        input_password: "Please enter your password",
        re_input_pass: "Re-type the password",
        input_old_password: "Please enter your old password",
        new_user: "New User?",
        join_us: "Join Now",
        forgot_password: "Forgot password",
        login: "Login",
        area_code: "Area Code",
        register: "Register",
        register_email: "Enter your Email",
        register_phone: "Mobile Registration",
        can_use_asset: "Available Assets",
        logout: "Logout",
        confirm_logout: "Whether to withdraw from the register",
        logout_success: "Successful exit",
        mock_login: "No need to open an account, create a demo account to trade now!",
        account_detail: "Account Details",
        mock_account: "Simulation Account",
        invite_code: "Invitation Code",
        input_invite_code: "Please enter the invitation code",
        copy_invite_link: "Copy Invitation Link",
        trade_account: "Trading account",
        only_true_account: "Please register or log in to a real hard account",
        reset_mock_account: "Return simulated account",
        confirm_reset: "Whether to return it",
        email: "Email",
        welcome_login: "Welcome to login",
        welcome_register: "Welcome to register",
        useful_balance: "Available funds",
        please_login: "Please log in"
    },
    forgot: {
        sms_code: "Verification Code",
        input_sms_code: "Please enter the verification code",
        send: "Send",
        reset: "Reset Password"
    },
    trade: {
        buy: "Buy",
        sell: "Sell",
        last_price: "Market Price",
        best_price: "Trading at the best current price",
        buy_price: "Price",
        enter_price: "Please enter the price",
        trade_amount: "Trading lot size",
        balance: "Balance",
        buy_up: "go long",
        buy_low: "Shorting",
        current_entrust: "Prior Commissioning",
        type: "Type",
        time: "Date",
        price: "price",
        trade_price: "Transaction amount",
        operate: "Operation",
        close_order: "Close position",
        high: "High",
        open: "Open",
        low: "Low",
        volume: "Total volume",
        order: "Orders",
        closed: "Closed",
        order_confirm: "Your order has been confirmed",
        order_page: "Order Page",
        no_mult: "No multiple",
        no_mult_config: "No lever configured, unable to place an order temporarily"
    },
    order: {
        current_price: "Current price",
        total_ol: "total profit and loss",
        holding: "Position holding",
        market_price: "Market Price",
        un_deal_order: "Pending Orders",
        history: "History",
        hand_num: "Lots",
        stop_loss: "Set Loss",
        stop_profit: "Set Profit",
        times: "Multiplier",
        handle_fee: "Handling fee",
        bond_fee: "Margin",
        balance: "Balance",
        buy_in: "Buy",
        sell_out: "Sell",
        trading: "Positions",
        dealing: "Pending Orders",
        profit: "Profit and Loss",
        total: "Net value",
        pay_rate: "Prepayment Ratio",
        can_use: "Prepayment available",
        trade_amount: "Lots",
        unit: "Each Lots",
        page: " Lots",
        hazard_rate: "Risk Rate",
        all_caution_money: "Current Margin",
        detail: "Order Details",
        close: "Close position",
        cancel: "Cancel order",
        calc_handle_fee: "Estimated Handling Fee",
        calc_bond_fee: "Estimated Margin",
        set_stop_price: "Save",
        currency: "Transaction pairs",
        order_id: "Reservation number",
        order_type: "direction",
        order_price: "Lower unit price",
        close_price: "Cheap warehouse price",
        income: "profit",
        confrim_close_order: "Whether to close the position",
        open_time: "Open time"
    },
    func: {
        charge_coin: "Deposit",
        withdraw_coin: "Withdrawal",
        billing_detail: "Billing Details",
        real_auth: "Real Name Verification",
        invite_friend: "Invite Friends",
        reset_password: "Change Password",
        setting: "establishment",
        lang: "Language",
        wallet: "Wallet",
        loan: "Loan",
        more: "More",
        transfer: "Transfer",
        video_desc: "Video",
        contract: "Contract",
        future: "Future",
        buy_coin: "Buy coins with bank card"
    },
    financial: {
        financial_records: "Financial Records",
        link_charge: "Recharge on the chain",
        bank_charge: "telegraph wire",
        charge_coin: "Coins",
        wallet_address: "Wallet Address",
        copy_address: "Copy Address",
        charge_amount: "Number of coins",
        input_charge_amount: "Please enter the number of coins to be charged",
        collect_coin_type: "Receipt Currency",
        coin: "Digital Currency",
        bank: "Bank Card",
        select_network: "Select Network",
        charge_num: "Recharge amount",
        input_charge_num: "Please enter the recharge amount",
        charge_history: "Deposit record",
        uncheck: "Unchecked",
        isfinish: "Completed",
        isreject: "Rejected",
        unuseful: "Invalid"
    },
    bank: {
        swift_text: "SWIFT",
        coin_type: "Beneficiary Currency",
        name: "Bank Name",
        address: "Bank Address",
        SWIFT: "SWIFT",
        username: "Payee",
        account: "Payee Account",
        remark: "Remark"
    },
    auth: {
        upload_idcard: "Please upload the front and back of your passport/ID",
        front: "Front",
        upload_front: "Upload the front of your passport/certificate",
        back: "Reverse side",
        upload_back: "Upload the reverse side of your passport/certificate",
        input_info: "Please complete your personal information",
        name: "Name",
        input_name: "Please enter your name",
        id_number: "Passport/ID number",
        input_id_num: "Please enter your passport/ID number",
        waiting: "Audit",
        finish: "Certified"
    },
    withdraw: {
        amount: "Amount",
        symbol: "Currency",
        withdraw_coin: "Submit withdrawal",
        no_pay_way: "There is no payment channel for the French currency account.",
        calc_get: "It is expected that",
        record: "Coin withdrawal record",
        send_amount: "Number of Receipts",
        withdraw_address: "Address for coin withdrawals",
        unit: "Unit",
        select_withdraw_address: "Please select an address to call"
    },
    wallet: {
        bind_bank_card: "Bind bank card",
        bind_coin_address: "Bind digital currency address",
        bind: "binding",
        save: "preservation",
        not_bind: "Please set up a collection account first",
        change_account: "Funding Account",
        forex_account: "Contract account",
        micro_account: "Future account"
    },
    follow: {
        apply_guide: "Application instructions",
        auto_open_positions: "Automatic opening of lots",
        be_master: "Become a master",
        closed_follow_order: "Closed position following order",
        commission_rate: "commission rate",
        copy_profit: "Profit from new orders",
        cover_time: "Closing time",
        follow: "Copy",
        follow_master: "Follow the master",
        followed: "followed",
        follower: "follower",
        follower_num: "Number of followers",
        follower_sum: "Total number of followers",
        following_order: "Follow-up orders in progress",
        history_order: "Historical orders",
        i_agree: "I have read and agree",
        lever: "multiple",
        limit_price: "price limit",
        margin: "margin",
        master_trader: "Trading master",
        max_following: "maximum follow",
        my_follower: "my followers",
        rate_of_return: "rate of return",
        size: "scale",
        start_ordering_now: "Start your first order now",
        submit_apply: "submit application",
        total_documentary_amount: "Total order amount",
        total_profit: "Total revenue",
        total_revenue: "Total revenue",
        unfollow: "Unfollow",
        view_follow_earnings: "View following income",
        will_pay_profit: "Proceeds to be settled",
        auto_follow: "Every time a trading expert opens a position on a product, I will automatically open the position accordingly.",
        follow_now: "Follow now",
        follower_setting: "Follow-up settings",
        submit_multiple: "Order multiple",
        be_trader: "become a trader",
        cancel_follow_tip: "Open orders will no longer follow the closing order, which may result in missing the best closing opportunity. Are you sure you want to cancel?",
        confirm_cancel_follow: "Cancel following order",
        max_follow_bond: "Maximum following margin per order",
        trader_list: "Trader list"
    },
    micro: {
        statistics: "Statistics",
        high: "High",
        low: "Low",
        "24h_volume": "24H Volume",
        open: "Open",
        close: "Close",
        buy_up: "Buy up",
        buy_down: "Buy down",
        trading_pairs: "Trading pairs",
        direction: "Direction",
        select_trade_time: "Select expiration date",
        calc_profit_rate: "Expected rate of return",
        trade_num: "Quantity",
        input_trade_num: "Please enter quantity",
        calc_income: "Expected income",
        profit_rate: "Profit rate",
        open_time: "Open time",
        close_time: "Closed time",
        in_transaction: "In positions",
        closed_position: "Closed positions",
        trade_time: "Duration",
        predict_profit: "Expect profit",
        profit: "Profit"
    },
    loan: {
        agreement: "Agreement",
        amount: "Amount",
        auth_reject: "Audit rejection",
        auth_success: "Approved by review",
        auth_waiting: "Pending audit",
        birthday: "Date of Birth:",
        confirm_repay: "Repayment Confirmation",
        confirm_repay_tip: "Please confirm your repayment information",
        confirm_repayment: "Confirm repayment",
        copy_address: "Copy address",
        country: "Country",
        day: "Day",
        day_rate: "Daily interest rate",
        female: "Female",
        first_name: "Surname",
        free_day: "Interest free days",
        hand_pic: "Handheld ID photo",
        id_card: "ID",
        identify_card: "Certificates",
        input_amount: "Please enter the amount",
        input_country: "Please enter the country",
        input_first_name: "Please enter last name",
        input_last_name: "Please enter a name",
        input_mobile: "Please enter your phone number",
        is_rejected: "Rejected",
        is_repay: "Repaired",
        last_name: "Name",
        loan: "Loan",
        loan_now: "Borrowing now",
        loan_order: "Loan order",
        loan_time: "Loan term",
        loaning: "You are applying for a loan",
        male: "Male",
        max: "Maximum",
        mobile: "Phone number",
        need_repay: "Repayment required",
        passport: "Passport",
        penalty_amount: "Penalty for breach of contract",
        please_sign: "Please sign your name.",
        please_waiting: "Thank you for submitting the KYC file. Our team will audit your information within 48 hours. Please be patient and wait for the audit results.",
        repay: "Repay now",
        repayment_check: "Repayment audit in progress",
        repayment_time: "Repayment date",
        resign: "Re sign",
        reviewed_at: "Allow time",
        select_day: "Please select a date",
        sex: "Gender",
        sign: "Autograph",
        start_loan: "Start enjoying our lending services",
        to_repayment: "Go ahead and repay",
        total_profit: "Total interest",
        transfer_address: "Transfer address",
        upload_credit: "Upload credentials",
        verified: "Verified",
        verify: "Start verification"
    },
    transfer: {
        from: "From",
        history: "Transfer record",
        input_number: "Please enter the transfer quantity",
        number: "Transfer quantity",
        to: "To"
    },
    mining: {
        better1: "Deposit and withdraw at any time",
        better2: "Issued daily",
        better3: "Mining cycle",
        better4: "Airdrop anytime",
        coin_type: "Currency",
        day_profit: "Expected Nissan",
        doing: "in progress",
        expected_profit: "Expected Nissan",
        finished: "over",
        input_lock_num: "Please enter the lock amount",
        interest: "Interest",
        machine_list: "Mining machine list",
        machine_rent: "Mining machine rental",
        max_subscribe: "Maximum subscription",
        mining: "Financial",
        mining_time: "Mining period",
        my_subscribe: "My subscription",
        name: "name",
        operate: "operate",
        pay: "pay",
        pay_penal_sum_redemption: "Application for early redemption of liquidated damages",
        product_better: "Product advantages",
        product_content: "Cloud mining is to use USDT to be entrusted to the platform's super-computing power mining machine to mine the profits in the mining pool of the AI ​​​​super-intelligent platform.",
        product_desc: "product description",
        profit_list: "Benefit list",
        redemption: "default redemption",
        refunded: "refunded",
        refunding: "Applying for refund",
        subscribe: "Subscription",
        subscribe_list: "Subscription list",
        subscribe_num: "Subscription quantity",
        subscribe_time: "Subscription time",
        sum_profit: "Estimated total revenue",
        watch_profit_list: "View benefit list"
    }
}
obj.Japanese = {
    public: {
        name: "の名前をあげる",
        last_price: "最終価格",
        market: "傾向",
        quotation: "24 H変更",
        no_data: "まだデータがありません",
        no_more: "もう二度と",
        confirm: "確認書",
        use: "入手可能",
        freeze: "とうけつ",
        number: "はかる",
        history: "レコード破り",
        other: "さらに",
        tip: "プロンプト",
        copy_success: "コピー成功",
        upload_pic: "証明書をアップロード中",
        submit: "送信",
        status: "ポジション",
        set: "設定＃セッテイ＃",
        chat: "オンラインサービス",
        copy: "レプリケーション",
        delete: "削除",
        confirm_del: "本当に削除しますか。",
        add: "追加",
        input_full: "記入してください",
        password_not_equal: "パスワードが一致しません",
        coming_soon: "近日発売～",
        cancel: "キャンセル",
        setting: "背景",
        product_list: "製品リスト",
        submit_order: "発注の発行",
        all: "全て",
        clear: "クリア",
        close: "閉鎖",
        invite_tip: "上の QR コード パターンをスキャンするか、招待コードを入力して登録を確認します。",
        my_assets: "私の資産",
        please_input: "入力してください",
        record: "記録",
        test: "テストのためだけに",
        today: "今日",
        total_assets: "総勘定資産換算"
    },
    user: {
        h_second: "秒",
        h_timer: "カウントダウン",
        h_accept: "受け入れる",
        h_welc: "ようこそ使用",
        announ_text: "政策上の理由により、北朝鮮、イスラエル、中国、バヌアツ、キューバにはサービスは提供されません。",
        announ: "発表",
        com_email: "苦情メール",
        dh: "電話",
        qh: "市外局番",
        qh_dh: "市外局番/電話番号",
        user_center: "こう",
        login_email: "電子メールを入力",
        login_phone: "携帯電話ログイン",
        input_email: "電子メールアドレスを入力してください",
        input_phone: "携帯番号を入力してください",
        password: "ひそかに言う",
        new_paw: "新しいパスワード",
        input_password: "パスワードを入力してください",
        re_input_pass: "パスワードの再入力",
        input_old_password: "古いパスワードを入力してください",
        new_user: "新しいユーザー？",
        join_us: "今すぐ参加",
        forgot_password: "パスワードを忘れる",
        login: "ログイン＃ログイン＃",
        area_code: "地域コード",
        register: "登録",
        register_email: "電子メールを入力",
        register_phone: "携帯電話の登録",
        can_use_asset: "利用可能な資産",
        logout: "ログアウト",
        confirm_logout: "登録を終了するかどうか",
        logout_success: "終了に成功しました",
        mock_login: "アカウントを開設する必要はなく、シミュレーションアカウントを作成すれば取引ができます！",
        account_detail: "アカウントの詳細",
        mock_account: "アナログ勘定科目",
        invite_code: "招待コード",
        input_invite_code: "招待コードを入力してください",
        copy_invite_link: "招待状リンクのコピー",
        trade_account: "取引口座",
        only_true_account: "真のハードアカウントを登録またはログインしてください",
        reset_mock_account: "シミュレーション勘定科目を戻す",
        confirm_reset: "返品の有無",
        email: "郵便ポスト",
        welcome_login: "ログインへようこそ",
        welcome_register: "登録へようこそ",
        useful_balance: "使用可能な資金",
        please_login: "ログインしてください"
    },
    forgot: {
        sms_code: "認証コード",
        input_sms_code: "認証コードを入力してください",
        send: "郵便で送る",
        reset: "パスワードをリセット"
    },
    trade: {
        buy: "購入する",
        sell: "売る",
        last_price: "市場価格",
        best_price: "現在の最適価格で取引",
        buy_price: "価格",
        enter_price: "価格を入力してください",
        trade_amount: "トランザクションバッチサイズ",
        balance: "バランス",
        buy_up: "たくさん作る",
        buy_low: "たんらく",
        current_entrust: "事前デバッグ",
        type: "を選択してオプションを設定します。",
        time: "日付",
        price: "価格",
        trade_price: "取引金額",
        operate: "アクティビティ",
        close_order: "オフ位置",
        high: "高い",
        open: "開く",
        low: "低い",
        volume: "そうたいせき",
        order: "オーダー",
        closed: "閉じる",
        order_confirm: "ご注文の確認",
        order_page: "「受注」ページ",
        no_mult: "倍数なし",
        no_mult_config: "レバーが設定されておらず、しばらく注文できません"
    },
    order: {
        current_price: "現在の価格",
        total_ol: "損益総額",
        holding: "持倉",
        market_price: "市場価格",
        un_deal_order: "未処理オーダー",
        history: "履歴",
        hand_num: "ルーツ",
        stop_loss: "せっていそんしつ",
        stop_profit: "利益の設定",
        times: "じょうすう",
        handle_fee: "手数料",
        bond_fee: "エッジ",
        balance: "バランス",
        buy_in: "購入する",
        sell_out: "売る",
        trading: "位置",
        dealing: "未処理オーダー",
        profit: "損益",
        total: "ネット",
        pay_rate: "前払金比率",
        can_use: "繰上げ返済可能",
        trade_amount: "ルーツ",
        unit: "各紙",
        page: "シーツ",
        hazard_rate: "リスク率",
        all_caution_money: "現在の保証金",
        detail: "オーダー詳細",
        close: "オフ位置",
        cancel: "注文の取消",
        calc_handle_fee: "予定手数料",
        calc_bond_fee: "予想利潤",
        set_stop_price: "に救援物資を送る",
        currency: "取引ペア",
        order_id: "購読番号",
        order_type: "方向",
        order_price: "単価が低い",
        close_price: "倉庫価格が安い",
        income: "利潤",
        confrim_close_order: "これは安い倉庫ですか。",
        open_time: "オープン時間"
    },
    func: {
        charge_coin: "入金",
        withdraw_coin: "出金",
        billing_detail: "請求書詳細",
        real_auth: "実名認証",
        invite_friend: "友人を招く",
        reset_password: "パスワードの変更",
        setting: "きこう",
        lang: "言語",
        wallet: "財布",
        buy_coin: "銀行カードでコインを購入する",
        contract: "契約",
        future: "未来",
        loan: "ローン",
        more: "もっと",
        transfer: "移行",
        video_desc: "ビデオ"
    },
    financial: {
        financial_records: "財務記録",
        link_charge: "チェーンに充電する",
        bank_charge: "でんしんせん",
        charge_coin: "コイン枚",
        wallet_address: "ウォレットアドレス",
        copy_address: "アドレスのコピー",
        charge_amount: "コインの数",
        input_charge_amount: "チャージするコインの数を入力してください",
        collect_coin_type: "入金通貨",
        coin: "デジタル通貨",
        bank: "銀行カード",
        select_network: "ネットワークの選択",
        charge_num: "チャージ金額",
        input_charge_num: "チャージ金額を入力してください",
        charge_history: "預金記録",
        uncheck: "選択されていません",
        isfinish: "完了",
        isreject: "拒否されました",
        unuseful: "無効な"
    },
    bank: {
        swift_text: "すばやい",
        coin_type: "入金通貨",
        name: "銀行名",
        address: "銀行住所",
        SWIFT: "すばやい",
        username: "受取人",
        account: "受取人口座",
        remark: "コメント"
    },
    auth: {
        upload_idcard: "パスポート/身分証明書の表と裏をアップロードしてください",
        front: "前面",
        upload_front: "パスポート/証明書の前面をアップロード",
        back: "裏面",
        upload_back: "パスポート/証明書の裏面をアップロード",
        input_info: "個人情報を入力してください",
        name: "の名前をあげる",
        input_name: "お名前を入力してください",
        id_number: "パスポート/身分証明書番号",
        input_id_num: "パスポート/身分証明書番号を入力してください",
        waiting: "監査",
        finish: "かくにん"
    },
    withdraw: {
        amount: "数量",
        symbol: "通貨",
        withdraw_coin: "引き出しの提出",
        no_pay_way: "外貨口座には支払ルートがありません。",
        calc_get: "見込み",
        record: "貨幣受取記録",
        send_amount: "領収書数量",
        withdraw_address: "貨幣受取先",
        unit: "ユニット",
        select_withdraw_address: "呼び出す住所を選択してください"
    },
    wallet: {
        bind_bank_card: "銀行カードのバインド",
        bind_coin_address: "バインドされたデジタル通貨アドレス",
        bind: "けつごう",
        save: "保護",
        not_bind: "先に入金口座を設定してください",
        change_account: "資金口座",
        forex_account: "契約口座",
        micro_account: "将来のアカウント"
    },
    follow: {
        apply_guide: "アプリケーションの説明",
        auto_follow: "トレーディングエキスパートが商品に対してポジションをオープンするたびに、私もそれに応じて自動的にポジションをオープンします。",
        auto_open_positions: "ロットの自動オープン",
        be_master: "マスターになる",
        closed_follow_order: "注文後のクローズポジション",
        commission_rate: "手数料率",
        copy_profit: "新規注文による利益",
        cover_time: "閉店時間",
        follow: "フォローする",
        follow_master: "マスターに従ってください",
        follow_now: "今すぐフォローしてください",
        followed: "フォローしました",
        follower: "フォロワー",
        follower_num: "フォロワー数",
        follower_setting: "フォローアップ設定",
        follower_sum: "総フォロワー数",
        following_order: "フォローアップ注文が進行中です",
        history_order: "歴史的な注文",
        i_agree: "読んで同意します",
        lever: "複数",
        limit_price: "価格制限",
        margin: "マージン",
        master_trader: "トレーディングマスター",
        max_following: "最大限のフォロー",
        my_follower: "私のフォロワー達",
        rate_of_return: "利益率",
        size: "規模",
        start_ordering_now: "今すぐ最初の注文を始めてください",
        submit_apply: "申請書を提出する",
        submit_multiple: "複数注文",
        total_documentary_amount: "注文総額",
        total_profit: "総収入",
        total_revenue: "総収入",
        unfollow: "フォローを解除する",
        view_follow_earnings: "次の収入を見る",
        will_pay_profit: "決済される収益",
        be_trader: "トレーダーになる",
        cancel_follow_tip: "未決済注文は決済注文に従わなくなり、最良の決済機会を逃す可能性があります。\n本当にキャンセルしてもよろしいですか?",
        confirm_cancel_follow: "次の注文をキャンセルする",
        max_follow_bond: "注文ごとの最大フォローマージン",
        trader_list: "トレーダーリスト"
    },
    loan: {
        agreement: "合意",
        amount: "額",
        auth_reject: "監査の拒否",
        auth_success: "審査により承認されました",
        auth_waiting: "監査保留中",
        birthday: "生年月日：",
        confirm_repay: "返済確認",
        confirm_repay_tip: "返済情報をご確認ください",
        confirm_repayment: "返済の確認",
        copy_address: "アドレスをコピーする",
        country: "国",
        day: "日",
        day_rate: "日利率",
        female: "女性",
        first_name: "姓",
        free_day: "無利息日",
        hand_pic: "手持ち証明写真",
        id_card: "ID",
        identify_card: "証明書",
        input_amount: "金額を入力してください",
        input_country: "国を入力してください",
        input_first_name: "姓を入力してください",
        input_last_name: "名前を入力してください",
        input_mobile: "電話番号を入力してください",
        is_rejected: "拒否されました",
        is_repay: "修理済み",
        last_name: "名前",
        loan: "ローン",
        loan_now: "今すぐ借りる",
        loan_order: "ローン注文",
        loan_time: "融資期間",
        loaning: "ローンを申請中です",
        male: "男",
        max: "最大",
        mobile: "電話番号",
        need_repay: "返済が必要です",
        passport: "パスポート",
        penalty_amount: "契約違反に対する罰則",
        please_sign: "あなたの名前を署名してください。",
        please_waiting: "KYC ファイルを送信していただきありがとうございます。\n私たちのチームは 48 時間以内にあなたの情報を監査します。\n監査結果が出るまで今しばらくお待ちください。",
        repay: "今すぐ返済してください",
        repayment_check: "返済監査中",
        repayment_time: "返済日",
        resign: "辞任する",
        reviewed_at: "時間を許す",
        select_day: "日付を選択してください",
        sex: "性別",
        sign: "サイン",
        start_loan: "レンディングサービスを始めましょう",
        to_repayment: "さあ、返済してください",
        total_profit: "利息総額",
        transfer_address: "転送先アドレス",
        upload_credit: "認証情報のアップロード",
        verified: "確認済み",
        verify: "検証を開始する"
    },
    micro: {
        "24h_volume": "24時間のボリューム",
        buy_down: "買い下げる",
        buy_up: "買い占め",
        calc_income: "期待収入",
        calc_profit_rate: "期待収益率",
        close: "近い",
        close_time: "閉店時間",
        closed_position: "クローズされたポジション",
        direction: "方向",
        high: "高い",
        in_transaction: "ポジション内",
        input_trade_num: "数量を入力してください",
        low: "低い",
        open: "開ける",
        open_time: "開館時間",
        predict_profit: "利益が期待できる",
        profit: "利益",
        profit_rate: "利益率",
        select_trade_time: "有効期限を選択してください",
        statistics: "統計",
        trade_num: "量",
        trade_time: "間隔",
        trading_pairs: "取引ペア"
    },
    mining: {
        better1: "いつでも入金・出金可能",
        better2: "毎日発行",
        better3: "マイニングサイクル",
        better4: "いつでもエアドロップ",
        coin_type: "通貨",
        day_profit: "期待される日産",
        doing: "進行中",
        expected_profit: "期待される日産",
        finished: "以上",
        input_lock_num: "ロック量を入力してください",
        interest: "興味",
        machine_list: "マイニングマシン一覧",
        machine_rent: "マイニングマシンのレンタル",
        max_subscribe: "最大サブスクリプション",
        mining: "財務管理",
        mining_time: "採掘期間",
        my_subscribe: "私のサブスクリプション",
        name: "名前",
        pay: "支払う",
        pay_penal_sum_redemption: "賠償金の早期償還の申請",
        product_better: "製品の利点",
        product_content: "クラウドマイニングは、USDTを使用してプラットフォームのスーパーコンピューティングパワーマイニングマシンに委託し、AI超インテリジェントプラットフォームのマイニングプール内の利益をマイニングすることです。",
        product_desc: "製品説明",
        profit_list: "特典一覧",
        redemption: "デフォルトの償還",
        refunded: "返金された",
        refunding: "払い戻しの申請",
        subscribe: "サブスクリプション",
        subscribe_list: "購読リスト",
        subscribe_num: "購読数量",
        subscribe_time: "購読時間",
        sum_profit: "推定総収益",
        watch_profit_list: "特典リストを見る",
        operate: "操作する"
    },
    transfer: {
        from: "から",
        history: "譲渡記録",
        input_number: "転送数量を入力してください",
        number: "転送量",
        to: "に"
    }
}
obj.Korean = {
    public: {
        name: "이름",
        last_price: "마지막 가격",
        market: "추세",
        quotation: "24H 변경 내용",
        no_data: "데이터가 없습니다.",
        no_more: "더 이상",
        confirm: "확인서",
        use: "획득 가능",
        freeze: "동결",
        number: "재다",
        history: "기록",
        other: "또한",
        tip: "재촉",
        copy_success: "복제 성공",
        upload_pic: "인증서 업로드 중",
        submit: "제출",
        status: "지위",
        set: "설치",
        chat: "온라인 서비스",
        copy: "복제",
        delete: "삭제",
        confirm_del: "삭제하시겠습니까?",
        add: "추가",
        input_full: "기입해 주십시오",
        password_not_equal: "암호 불일치",
        coming_soon: "출시 예정 ~",
        cancel: "취소",
        setting: "배경",
        product_list: "제품 목록",
        submit_order: "주문 전송",
        all: "모두",
        clear: "분명한",
        close: "폐쇄",
        invite_tip: "위의 QR 코드 패턴을 스캔하거나 초대 코드를 입력하여 등록을 확인하세요.",
        my_assets: "내 자산",
        please_input: "입력해주세요",
        record: "기록",
        test: "그냥 테스트용",
        today: "오늘",
        total_assets: "총 계정 자산 환산"
    },
    user: {
        h_second: "초",
        h_timer: "카운트다운",
        h_accept: "수락",
        h_welc: "사용을 환영합니다",
        announ_text: "정책상의 이유로 북한, 이스라엘, 중국, 바누아투, 쿠바에는 서비스가 제공되지 않습니다.",
        announ: "공지",
        com_email: "불만 이메일",
        dh: "전화",
        qh: "지역번호",
        qh_dh: "지역번호/전화",
        user_center: "광산",
        login_email: "이메일 입력",
        login_phone: "휴대폰 로그인",
        input_email: "이메일 주소를 입력하십시오.",
        input_phone: "휴대폰 번호를 입력하십시오.",
        password: "은어",
        new_paw: "새 암호",
        input_password: "암호를 입력하십시오.",
        re_input_pass: "암호 다시 입력",
        input_old_password: "이전 암호를 입력하십시오.",
        new_user: "새 사용자?",
        join_us: "지금 가입",
        forgot_password: "암호를 잊었습니다.",
        login: "로그인",
        area_code: "지역 코드",
        register: "등록",
        register_email: "이메일 입력",
        register_phone: "휴대폰 등록",
        can_use_asset: "가용 자산",
        logout: "로그아웃",
        confirm_logout: "등록 종료 여부",
        logout_success: "종료 성공",
        mock_login: "계좌를 개설할 필요 없이 모의 계좌를 만들면 거래를 진행할 수 있습니다!",
        account_detail: "계정 세부 정보",
        mock_account: "아날로그 계정",
        invite_code: "초대 코드",
        input_invite_code: "초대 코드를 입력하십시오.",
        copy_invite_link: "초대 링크 복사",
        trade_account: "거래 계좌",
        only_true_account: "실제 하드 계정을 등록하거나 로그인하십시오.",
        reset_mock_account: "아날로그 계정으로 돌아가기",
        confirm_reset: "반품 여부",
        email: "우편함",
        welcome_login: "로그인 시작",
        welcome_register: "등록 시작",
        useful_balance: "가용 자금",
        please_login: "로그인"
    },
    forgot: {
        sms_code: "인증 코드",
        input_sms_code: "인증 코드를 입력하십시오.",
        send: "우송",
        reset: "비밀번호 재설정"
    },
    trade: {
        buy: "구매",
        sell: "팔다",
        last_price: "시장 가격",
        best_price: "현재 최고의 가격으로 거래",
        buy_price: "가격",
        enter_price: "가격을 입력하십시오.",
        trade_amount: "거래 대량 크기",
        balance: "균형",
        buy_up: "많이 하다",
        buy_low: "합선",
        current_entrust: "사전 디버깅",
        type: "유형",
        time: "날짜",
        price: "가격",
        trade_price: "거래 금액",
        operate: "활동",
        close_order: "위치 닫기",
        high: "높음",
        open: "열기",
        low: "낮음",
        volume: "전체 볼륨",
        order: "주문",
        closed: "닫기",
        order_confirm: "주문 확인",
        order_page: "주문 페이지",
        no_mult: "배수가 없다",
        no_mult_config: "레버가 구성되지 않아 일시적으로 주문할 수 없음"
    },
    order: {
        current_price: "현재 가격",
        total_ol: "손익 총액",
        holding: "창고 보유",
        market_price: "시장 가격",
        un_deal_order: "보류 중인 주문",
        history: "역사",
        hand_num: "로츠",
        stop_loss: "손실 설정",
        stop_profit: "이익 설정",
        times: "승수",
        handle_fee: "수수료",
        bond_fee: "가장자리",
        balance: "균형",
        buy_in: "구매",
        sell_out: "팔다",
        trading: "위치",
        dealing: "보류 중인 주문",
        profit: "손익",
        total: "순가치",
        pay_rate: "선불 비율",
        can_use: "조기 상환 가능",
        trade_amount: "로츠",
        unit: "종이마다",
        page: "시트",
        hazard_rate: "위험률",
        all_caution_money: "현재 보증금",
        detail: "주문 상세 정보",
        close: "위치 닫기",
        cancel: "주문 취소",
        calc_handle_fee: "예상 수수료",
        calc_bond_fee: "예상 이익",
        set_stop_price: "구원",
        currency: "트랜잭션 쌍",
        order_id: "가입 번호",
        order_type: "방향",
        order_price: "단가가 낮다",
        close_price: "창고 가격이 싸다",
        income: "이익",
        confrim_close_order: "이것은 싼 창고입니까?",
        open_time: "개방 시간"
    },
    func: {
        charge_coin: "보증금",
        withdraw_coin: "철회",
        billing_detail: "청구 내역",
        real_auth: "실명제 검증",
        invite_friend: "친구 초대",
        reset_password: "암호 수정",
        setting: "메커니즘",
        lang: "언어",
        wallet: "지갑",
        buy_coin: "은행 카드로 동전 구매",
        contract: "계약",
        future: "미래",
        loan: "대출",
        more: "더",
        transfer: "옮기다",
        video_desc: "동영상"
    },
    financial: {
        financial_records: "재무 기록",
        link_charge: "체인에 충전",
        bank_charge: "전신선",
        charge_coin: "동전",
        wallet_address: "지갑 주소",
        copy_address: "주소 복사",
        charge_amount: "동전 수량",
        input_charge_amount: "충전할 동전의 수량을 입력하세요",
        collect_coin_type: "수금 화폐",
        coin: "디지털 화폐",
        bank: "은행카드",
        select_network: "네트워크 선택",
        charge_num: "충전 금액",
        input_charge_num: "충전 금액을 입력하세요",
        charge_history: "예금 기록",
        uncheck: "선택되지 않음",
        isfinish: "완료됨",
        isreject: "거부됨",
        unuseful: "잘못된"
    },
    bank: {
        swift_text: "신속했어",
        coin_type: "수금 화폐",
        name: "은행명",
        address: "은행 주소",
        SWIFT: "신속했어",
        username: "수취인",
        account: "수취인 계좌",
        remark: "코멘트"
    },
    auth: {
        upload_idcard: "여권/신분증의 앞면과 뒷면을 올려주십시오",
        front: "정면",
        upload_front: "여권 / 인증서 정면 업로드",
        back: "뒷면",
        upload_back: "여권/증서의 뒷면을 업로드합니다",
        input_info: "개인 정보를 입력하십시오.",
        name: "이름",
        input_name: "이름을 입력하십시오.",
        id_number: "여권/주민등록번호",
        input_id_num: "여권/주민등록번호를 입력하십시오.",
        waiting: "감사",
        finish: "확인"
    },
    withdraw: {
        amount: "수량",
        symbol: "통화",
        withdraw_coin: "인출금을 제출하다",
        no_pay_way: "법화 계좌에는 지불 경로가 없다.",
        calc_get: "예상",
        record: "코인 레코드",
        send_amount: "영수증 수량",
        withdraw_address: "코인 주소",
        unit: "유닛",
        select_withdraw_address: "호출할 주소를 선택하십시오."
    },
    wallet: {
        bind_bank_card: "바인딩 카드",
        bind_coin_address: "바인딩 디지털 화폐 주소",
        bind: "결합",
        save: "보호",
        not_bind: "먼저 수금 계좌를 설정하세요.",
        change_account: "자금 계좌",
        forex_account: "계약계좌",
        micro_account: "미래 계정"
    },
    follow: {
        apply_guide: "신청방법",
        auto_follow: "거래 전문가가 상품에 대한 포지션을 오픈할 때마다 자동으로 그에 따라 포지션이 오픈됩니다.",
        auto_open_positions: "로트 자동 개설",
        be_master: "마스터가 되세요",
        closed_follow_order: "주문에 따른 포지션 마감",
        commission_rate: "수수료율",
        copy_profit: "신규수주 이익",
        cover_time: "폐관시간",
        follow: "따르다",
        follow_master: "스승을 따르라",
        follow_now: "지금 팔로우하세요",
        followed: "팔로우함",
        follower: "수행원",
        follower_num: "팔로어 수",
        follower_setting: "후속 설정",
        follower_sum: "총 팔로어 수",
        following_order: "후속 주문 진행 중",
        history_order: "역사적 명령",
        i_agree: "읽었으며 이에 동의합니다.",
        lever: "다수의",
        limit_price: "가격 제한",
        margin: "여유",
        master_trader: "트레이딩 마스터",
        max_following: "최대 팔로우",
        my_follower: "내 팔로워들",
        rate_of_return: "수익률",
        size: "규모",
        start_ordering_now: "지금 첫 주문을 시작해 보세요",
        submit_apply: "지원서 제출",
        submit_multiple: "여러 개 주문",
        total_documentary_amount: "총 주문 금액",
        total_profit: "총 수익",
        total_revenue: "총 수익",
        unfollow: "언팔로우",
        view_follow_earnings: "다음 수입 보기",
        will_pay_profit: "결제가 진행됩니다.",
        be_trader: "상인이 되다",
        cancel_follow_tip: "미결 주문은 더 이상 마감 주문을 따르지 않으므로 최고의 마감 기회를 놓칠 수 있습니다. \n취소하시겠습니까?",
        confirm_cancel_follow: "다음 주문 취소",
        max_follow_bond: "주문당 최대 추종 마진",
        trader_list: "거래자 목록"
    },
    loan: {
        agreement: "합의",
        amount: "양",
        auth_reject: "감사 거부",
        auth_success: "검토를 통해 승인됨",
        auth_waiting: "감사 대기 중",
        birthday: "생일:",
        confirm_repay: "상환 확인",
        confirm_repay_tip: "상환정보를 확인해 주세요.",
        confirm_repayment: "상환 확인",
        copy_address: "주소 복사",
        country: "국가",
        day: "낮",
        day_rate: "일일 이자율",
        female: "여성",
        first_name: "성",
        free_day: "무이자 일수",
        hand_pic: "휴대용 신분증 사진",
        id_card: "ID",
        identify_card: "인증서",
        input_amount: "금액을 입력해주세요.",
        input_country: "해당 국가를 입력해주세요.",
        input_first_name: "성을 입력하세요.",
        input_last_name: "이름을 입력하세요",
        input_mobile: "전화번호를 입력해주세요",
        is_rejected: "거부됨",
        is_repay: "수리됨",
        last_name: "이름",
        loan: "대출",
        loan_now: "지금 빌리는 중",
        loan_order: "대출주문",
        loan_time: "대출기간",
        loaning: "대출을 신청하고 계십니다",
        male: "남성",
        max: "최고",
        mobile: "전화 번호",
        need_repay: "상환 필요",
        passport: "여권",
        penalty_amount: "계약 위반에 대한 처벌",
        please_sign: "귀하의 이름을 서명해 주십시오.",
        please_waiting: "KYC 파일을 제출해 주셔서 감사합니다. \n우리 팀은 48시간 이내에 귀하의 정보를 감사할 것입니다. \n인내심을 갖고 감사 결과를 기다려 주십시오.",
        repay: "지금 상환하세요",
        repayment_check: "상환 감사 진행 중",
        repayment_time: "상환일",
        resign: "사직하다",
        reviewed_at: "시간을 허용",
        select_day: "날짜를 선택하세요.",
        sex: "성별",
        sign: "자필",
        start_loan: "대출 서비스를 즐겨보세요",
        to_repayment: "가서 갚으세요",
        total_profit: "총이자",
        transfer_address: "송금 주소",
        upload_credit: "자격 증명 업로드",
        verified: "확인됨",
        verify: "인증 시작"
    },
    micro: {
        "24h_volume": "24시간 거래량",
        buy_down: "아래로 구매",
        buy_up: "구매",
        calc_income: "기대소득",
        calc_profit_rate: "기대수익률",
        close: "닫다",
        close_time: "휴관시간",
        closed_position: "마감된 포지션",
        direction: "방향",
        high: "높은",
        in_transaction: "위치에",
        input_trade_num: "수량을 입력해주세요",
        low: "낮은",
        open: "열려 있는",
        open_time: "오픈 시간",
        predict_profit: "이익을 기대하다",
        profit: "이익",
        profit_rate: "이익률",
        select_trade_time: "만료일 선택",
        statistics: "통계",
        trade_num: "수량",
        trade_time: "지속",
        trading_pairs: "거래쌍"
    },
    mining: {
        better1: "언제든지 입금하고 출금하세요",
        better2: "매일 발행",
        better3: "채굴주기",
        better4: "언제든지 에어드롭",
        coin_type: "통화",
        day_profit: "예상되는 닛산",
        doing: "진행 중",
        expected_profit: "예상되는 닛산",
        finished: "~ 위에",
        input_lock_num: "잠금 금액을 입력하세요.",
        interest: "관심",
        machine_list: "채굴기 목록",
        machine_rent: "광산 기계 대여",
        max_subscribe: "최대 구독",
        mining: "재무 관리",
        mining_time: "채굴기간",
        my_subscribe: "내 구독",
        name: "이름",
        operate: "작동하다",
        pay: "지불하다",
        pay_penal_sum_redemption: "지체상금 조기상환 신청",
        product_better: "제품 장점",
        product_content: "클라우드 마이닝은 USDT를 플랫폼의 슈퍼컴퓨팅 파워 마이닝 머신에 맡겨 AI 슈퍼지능 플랫폼의 마이닝 풀에서 수익을 채굴하는 것입니다.",
        product_desc: "제품 설명",
        profit_list: "혜택 목록",
        redemption: "기본 상환",
        refunded: "환불됨",
        refunding: "환불 신청 중",
        subscribe: "신청",
        subscribe_list: "구독 목록",
        subscribe_num: "구독 수량",
        subscribe_time: "구독 시간",
        sum_profit: "예상 총 수익",
        watch_profit_list: "혜택 목록 보기"
    },
    transfer: {
        from: "에서",
        history: "이체기록",
        input_number: "이체 수량을 입력해주세요",
        number: "이체 수량",
        to: "에게"
    }
}
obj.th = {
    public: {
        name: "ชื่อ",
        last_price: "ราคาล่าสุด",
        market: "แนวโน้ม",
        quotation: "24H เปลี่ยน",
        no_data: "ยังไม่มีข้อมูล",
        no_more: "ไม่มีอีกต่อไป",
        confirm: "การยืนยัน",
        use: "ใช้ได้",
        freeze: "แช่แข็ง",
        number: "ปริมาณ",
        history: "บันทึก",
        other: "เพิ่มเติม",
        tip: "กระตุ้น",
        copy_success: "คัดลอกสำเร็จ",
        upload_pic: "กำลังอัปโหลดใบรับรอง",
        submit: "ส่ง",
        status: "สถานะ",
        set: "การตั้งค่า",
        chat: "บริการออนไลน์",
        copy: "คัดลอก",
        delete: "ลบ",
        confirm_del: "คุณแน่ใจนะว่าต้องการลบ?",
        add: "เพิ่ม",
        input_full: "กรุณากรอก",
        password_not_equal: "รหัสผ่านไม่สอดคล้องกัน",
        coming_soon: "เร็ว ๆ นี้ ~",
        cancel: "การยกเลิก",
        setting: "พื้นหลัง",
        product_list: "รายการสินค้า",
        submit_order: "ส่งคำสั่งซื้อ",
        all: "ทั้งหมด",
        clear: "ชัดเจน",
        close: "ปิด",
        invite_tip: "สแกนรูปแบบรหัส QR ด้านบนหรือป้อนรหัสเชิญเพื่อยืนยันการลงทะเบียน",
        my_assets: "ทรัพย์สินของฉัน",
        please_input: "กรุณาเข้า",
        record: "บันทึก",
        test: "เพียงเพื่อการทดสอบ",
        today: "วันนี้",
        total_assets: "การแปลงสินทรัพย์บัญชีทั้งหมด"
    },
    user: {
        h_second: "วินาที",
        h_timer: "นับถอยหลัง",
        h_accept: "ยอมรับ",
        h_welc: "ยินดีต้อนรับสู่การใช้งาน",
        announ_text: "เนื่องจากเหตุผลด้านนโยบาย จึงไม่มีการให้บริการแก่เกาหลีเหนือ อิสราเอล จีน วานูอาตู และคิวบา",
        announ: "ประกาศ",
        com_email: "กล่องรับเรื่องร้องทุกข์",
        dh: "โทรศัพท์",
        qh: "รหัสพื้นที่",
        qh_dh: "รหัสพื้นที่/โทรศัพท์",
        user_center: "เหมือง",
        login_email: "ป้อนอีเมลของคุณ",
        login_phone: "เข้าสู่ระบบโทรศัพท์มือถือ",
        input_email: "โปรดป้อนที่อยู่อีเมลของคุณ",
        input_phone: "กรุณากรอกหมายเลขโทรศัพท์มือถือ",
        password: "รหัสลับ",
        new_paw: "รหัสผ่านใหม่",
        input_password: "กรุณากรอกรหัสผ่าน",
        re_input_pass: "พิมพ์รหัสผ่านใหม่",
        input_old_password: "กรุณาใส่รหัสผ่านเก่าของคุณ",
        new_user: "ผู้ใช้ใหม่?",
        join_us: "เข้าร่วมตอนนี้",
        forgot_password: "ลืมรหัสผ่าน",
        login: "เข้าสู่ระบบ",
        area_code: "รหัสอำเภอ",
        register: "ลงทะเบียน",
        register_email: "ป้อนอีเมลของคุณ",
        register_phone: "ลงทะเบียนโทรศัพท์มือถือ",
        can_use_asset: "สินทรัพย์ที่มีอยู่",
        logout: "ออกจากระบบ",
        confirm_logout: "ไม่ว่าจะเป็นการออกจากการลงทะเบียน",
        logout_success: "ถอนตัวได้สำเร็จ",
        mock_login: "ไม่จำเป็นต้องเปิดบัญชี สร้างบัญชีทดลองเพื่อการเทรด!",
        account_detail: "รายละเอียดบัญชี",
        mock_account: "บัญชีทดลอง",
        invite_code: "รหัสเชิญ",
        input_invite_code: "กรุณากรอกรหัสเชิญ",
        copy_invite_link: "คัดลอกลิงก์เชิญ",
        trade_account: "บัญชีเทรด",
        only_true_account: "กรุณาลงทะเบียนหรือเข้าสู่ระบบบัญชี True Hard",
        reset_mock_account: "กลับไปที่บัญชีทดลอง",
        confirm_reset: "ไม่ว่าจะเป็นการคืนสินค้า",
        email: "ตู้ไปรษณีย์",
        welcome_login: "ยินดีต้อนรับเข้าสู่ระบบ",
        welcome_register: "ยินดีต้อนรับสู่การลงทะเบียน",
        useful_balance: "เงินทุนที่มีอยู่",
        please_login: "กรุณาเข้าสู่ระบบ"
    },
    forgot: {
        sms_code: "รหัสยืนยัน",
        input_sms_code: "กรุณากรอกรหัสยืนยัน",
        send: "ไปรษณีย์",
        reset: "รีเซ็ตรหัสผ่าน"
    },
    trade: {
        buy: "ซื้อ",
        sell: "ขาย",
        last_price: "ราคาตลาด",
        best_price: "เทรดด้วยราคาที่ดีที่สุดในปัจจุบัน",
        buy_price: "ราคา",
        enter_price: "กรุณากรอกราคา",
        trade_amount: "ขนาดล็อตการเทรด",
        balance: "สมดุล",
        buy_up: "ทำ Long",
        buy_low: "ลัดวงจร",
        current_entrust: "การว่าจ้างล่วงหน้า",
        type: "ประเภท",
        time: "วันที่",
        price: "ราคา",
        trade_price: "จำนวนธุรกรรม",
        operate: "กิจกรรม",
        close_order: "ปิดสถานที่",
        high: "สูง",
        open: "เปิด",
        low: "ต่ำ",
        volume: "ปริมาณรวม",
        order: "การสั่งซื้อ",
        closed: "ปิด",
        order_confirm: "คำสั่งซื้อของคุณได้รับการยืนยันแล้ว",
        order_page: "หน้าสั่งซื้อ",
        no_mult: "ไม่มีทวีคูณ",
        no_mult_config: "ไม่มีการกำหนดค่าเลเวอเรจและไม่สามารถวางคำสั่งได้ชั่วคราว"
    },
    order: {
        current_price: "ราคาปัจจุบัน",
        total_ol: "กำไรและขาดทุนทั้งหมด",
        holding: "เปิดสถานะ",
        market_price: "ราคาตลาด",
        un_deal_order: "คำสั่งซื้อที่รอดำเนินการ",
        history: "ประวัติความเป็นมา",
        hand_num: "โลทส์",
        stop_loss: "ตั้งค่าการสูญเสีย",
        stop_profit: "ตั้งค่ากำไร",
        times: "ตัวคูณ",
        handle_fee: "ค่าธรรมเนียมการจัดการ",
        bond_fee: "ขอบ",
        balance: "สมดุล",
        buy_in: "ซื้อ",
        sell_out: "ขาย",
        trading: "สถานที่ตั้ง",
        dealing: "คำสั่งซื้อที่รอดำเนินการ",
        profit: "กำไรและขาดทุน",
        total: "มูลค่าสุทธิ",
        pay_rate: "อัตราการชำระเงินล่วงหน้า",
        can_use: "สามารถชำระหนี้ล่วงหน้าได้",
        trade_amount: "โลทส์",
        unit: "กระดาษแต่ละแผ่น",
        page: "ผ้าปูที่นอน",
        hazard_rate: "อัตราความเสี่ยง",
        all_caution_money: "มาร์จิ้นปัจจุบัน",
        detail: "รายละเอียดการสั่งซื้อ",
        close: "ปิดสถานที่",
        cancel: "การยกเลิกคำสั่งซื้อ",
        calc_handle_fee: "ค่าธรรมเนียมการดำเนินการโดยประมาณ",
        calc_bond_fee: "กำไรที่คาดการณ์ไว้",
        set_stop_price: "ความรอด",
        currency: "การประมวลผลธุรกรรมคู่",
        order_id: "หมายเลขการจอง",
        order_type: "ทิศทาง",
        order_price: "ราคาต่อหน่วยต่ำกว่า",
        close_price: "คลังสินค้าราคาถูก",
        income: "กำไร",
        confrim_close_order: "คลังสินค้าราคาถูก",
        open_time: "เวลาเปิดทำการ"
    },
    func: {
        charge_coin: "เงินฝาก",
        withdraw_coin: "การถอนเงิน",
        billing_detail: "รายละเอียดบิล",
        real_auth: "การตรวจสอบระบบชื่อจริง",
        invite_friend: "เชิญเพื่อน",
        reset_password: "แก้ไขรหัสผ่าน",
        setting: "สถาบัน",
        lang: "ภาษา",
        wallet: "กระเป๋าสตางค์",
        buy_coin: "ซื้อเหรียญด้วยบัตรธนาคาร",
        contract: "สัญญา",
        future: "อนาคต",
        loan: "เงินกู้",
        more: "มากกว่า",
        transfer: "โอนย้าย",
        video_desc: "วีดีโอ"
    },
    financial: {
        financial_records: "บันทึกทางการเงิน",
        link_charge: "การชาร์จไฟบนโซ่",
        bank_charge: "สายโทรเลข",
        charge_coin: "เหรียญ",
        wallet_address: "ที่อยู่กระเป๋าสตางค์",
        copy_address: "คัดลอกที่อยู่",
        charge_amount: "จำนวนเหรียญ",
        input_charge_amount: "กรุณาใส่จำนวนเหรียญที่ต้องการเติมเงิน",
        collect_coin_type: "สกุลเงินที่รับ",
        coin: "สกุลเงินดิจิตอล",
        bank: "บัตรธนาคาร",
        select_network: "เลือกเครือข่าย",
        charge_num: "จำนวนเงินที่เติมเงิน",
        input_charge_num: "กรุณาใส่จำนวนเงินที่เติมเงิน",
        charge_history: "บันทึกการฝากเงิน",
        uncheck: "ไม่ถูกเลือก",
        isfinish: "เสร็จสมบูรณ์",
        isreject: "ถูกปฏิเสธ",
        unuseful: "ไม่ถูกต้อง"
    },
    bank: {
        swift_text: "รวดเร็ว",
        coin_type: "สกุลเงินที่รับ",
        name: "ชื่อธนาคาร",
        address: "ที่อยู่ธนาคาร",
        SWIFT: "รวดเร็ว",
        username: "ผู้รับเงิน",
        account: "บัญชีผู้รับเงิน",
        remark: "รีวิว"
    },
    auth: {
        upload_idcard: "กรุณาอัพโหลดหนังสือเดินทาง / บัตรประชาชนด้านหน้าและด้านหลัง",
        front: "ด้านหน้า",
        upload_front: "อัปโหลดหนังสือเดินทาง / ใบรับรองของคุณ",
        back: "กลับด้าน",
        upload_back: "อัปโหลดตรงข้ามหนังสือเดินทาง / ใบรับรองของคุณ",
        input_info: "กรุณากรอกข้อมูลส่วนตัว",
        name: "ชื่อ",
        input_name: "กรุณาใส่ชื่อของคุณ",
        id_number: "หมายเลขหนังสือเดินทาง / บัตรประชาชน",
        input_id_num: "กรุณากรอกหมายเลขหนังสือเดินทาง/บัตรประชาชน",
        waiting: "การตรวจสอบบัญชี",
        finish: "ยืนยัน"
    },
    withdraw: {
        amount: "ปริมาณ",
        symbol: "สกุลเงิน",
        withdraw_coin: "ส่งถอนเงิน",
        no_pay_way: "บัญชีสกุลเงินฝรั่งเศสไม่มีช่องทางการชำระเงิน",
        calc_get: "คาดว่า",
        record: "บันทึกการรับเงิน",
        send_amount: "จำนวนใบเสร็จรับเงิน",
        withdraw_address: "ที่อยู่รับเงิน",
        unit: "หน่วย",
        select_withdraw_address: "โปรดเลือกที่อยู่ที่คุณต้องการโทร"
    },
    wallet: {
        bind_bank_card: "ผูกบัตรธนาคาร",
        bind_coin_address: "ผูกที่อยู่สกุลเงินดิจิตอล",
        bind: "รวม",
        save: "การป้องกัน",
        not_bind: "โปรดตั้งบัญชีรับเงินก่อน",
        change_account: "บัญชีเงินทุน",
        forex_account: "บัญชีสัญญา",
        micro_account: "บัญชีในอนาคต"
    },
    follow: {
        apply_guide: "คำแนะนำในการสมัคร",
        auto_follow: "ทุกครั้งที่ผู้เชี่ยวชาญด้านการซื้อขายเปิดสถานะในผลิตภัณฑ์ ฉันจะเปิดสถานะโดยอัตโนมัติตามนั้น",
        auto_open_positions: "การเปิดล็อตอัตโนมัติ",
        be_master: "มาเป็นผู้เชี่ยวชาญ",
        closed_follow_order: "ตำแหน่งปิดตามคำสั่ง",
        commission_rate: "อัตราค่าคอมมิชชัน",
        copy_profit: "กำไรจากการสั่งซื้อใหม่",
        cover_time: "เวลาปิด",
        follow: "ติดตาม",
        follow_master: "ทำตามท่านอาจารย์",
        follow_now: "ติดตามเลย",
        followed: "ตามมา",
        follower: "ผู้ติดตาม",
        follower_num: "จำนวนผู้ติดตาม",
        follower_setting: "การตั้งค่าติดตามผล",
        follower_sum: "จำนวนผู้ติดตามทั้งหมด",
        following_order: "อยู่ระหว่างดำเนินการตามคำสั่ง",
        history_order: "คำสั่งทางประวัติศาสตร์",
        i_agree: "ฉันได้อ่านและเห็นด้วย",
        lever: "หลายรายการ",
        limit_price: "ขีด จำกัด ราคา",
        margin: "ระยะขอบ",
        master_trader: "ต้นแบบการค้าขาย",
        max_following: "ติดตามสูงสุด",
        my_follower: "ผู้ติดตามของฉัน",
        rate_of_return: "อัตราผลตอบแทน",
        size: "มาตราส่วน",
        start_ordering_now: "เริ่มการสั่งซื้อครั้งแรกของคุณตอนนี้",
        submit_apply: "ส่งใบสมัคร",
        submit_multiple: "สั่งหลายอัน",
        total_documentary_amount: "ยอดสั่งซื้อทั้งหมด",
        total_profit: "รายได้รวม",
        total_revenue: "รายได้รวม",
        unfollow: "เลิกติดตาม",
        view_follow_earnings: "ดูรายได้ต่อไปนี้",
        will_pay_profit: "รายได้ที่จะได้รับการชำระบัญชี",
        be_trader: "กลายเป็นผู้ค้า",
        cancel_follow_tip: "คำสั่งที่เปิดจะไม่เป็นไปตามคำสั่งปิดอีกต่อไป ซึ่งอาจส่งผลให้พลาดโอกาสในการปิดที่ดีที่สุด \nคุณแน่ใจหรือไม่ว่าต้องการยกเลิก",
        confirm_cancel_follow: "ยกเลิกคำสั่งต่อไปนี้",
        max_follow_bond: "มาร์จิ้นต่อไปนี้สูงสุดต่อคำสั่งซื้อ",
        trader_list: "รายชื่อผู้ค้า"
    },
    loan: {
        agreement: "ข้อตกลง",
        amount: "จำนวน",
        auth_reject: "การปฏิเสธการตรวจสอบ",
        auth_success: "ได้รับการอนุมัติจากการทบทวน",
        auth_waiting: "อยู่ระหว่างการตรวจสอบ",
        birthday: "วันเกิด:",
        confirm_repay: "การยืนยันการชำระคืน",
        confirm_repay_tip: "กรุณายืนยันข้อมูลการชำระหนี้ของคุณ",
        confirm_repayment: "ยืนยันการชำระคืน",
        copy_address: "คัดลอกที่อยู่",
        country: "ประเทศ",
        day: "วัน",
        day_rate: "อัตราดอกเบี้ยรายวัน",
        female: "หญิง",
        first_name: "นามสกุล",
        free_day: "วันปลอดดอกเบี้ย",
        hand_pic: "ภาพถ่ายติดบัตรประจำตัว",
        id_card: "บัตรประจำตัวประชาชน",
        identify_card: "ใบรับรอง",
        input_amount: "กรุณากรอกจำนวนเงิน",
        input_country: "กรุณากรอกประเทศ",
        input_first_name: "กรุณากรอกนามสกุล",
        input_last_name: "กรุณากรอกชื่อ",
        input_mobile: "กรุณากรอกหมายเลขโทรศัพท์ของคุณ",
        is_rejected: "ถูกปฏิเสธ",
        is_repay: "ซ่อมแซมแล้ว",
        last_name: "ชื่อ",
        loan: "เงินกู้",
        loan_now: "ยืมแล้ว",
        loan_order: "สั่งสินเชื่อ",
        loan_time: "ระยะเวลาเงินกู้",
        loaning: "คุณกำลังสมัครขอสินเชื่อ",
        male: "ชาย",
        max: "สูงสุด",
        mobile: "หมายเลขโทรศัพท์",
        need_repay: "จำเป็นต้องชำระคืน",
        passport: "หนังสือเดินทาง",
        penalty_amount: "บทลงโทษสำหรับการผิดสัญญา",
        please_sign: "กรุณาลงชื่อของคุณ.",
        please_waiting: "ขอขอบคุณที่ส่งไฟล์ KYC \nทีมงานของเราจะตรวจสอบข้อมูลของคุณภายใน 48 ชั่วโมง \nกรุณาอดทนรอผลการตรวจสอบ",
        repay: "ชำระคืนตอนนี้",
        repayment_check: "อยู่ระหว่างการตรวจสอบการชำระคืน",
        repayment_time: "วันชำระหนี้",
        resign: "ลงชื่ออีกครั้ง",
        reviewed_at: "ให้เวลา",
        select_day: "โปรดเลือกวันที่",
        sex: "เพศ",
        sign: "ลายเซ็นต์",
        start_loan: "เริ่มเพลิดเพลินกับบริการสินเชื่อของเรา",
        to_repayment: "ไปข้างหน้าและตอบแทน",
        total_profit: "ดอกเบี้ยรวม",
        transfer_address: "ที่อยู่โอน",
        upload_credit: "อัปโหลดข้อมูลรับรอง",
        verified: "ตรวจสอบแล้ว",
        verify: "เริ่มการยืนยัน"
    },
    micro: {
        "24h_volume": "ปริมาณ 24 ชม",
        buy_down: "ซื้อลง",
        buy_up: "ซื้อขึ้น",
        calc_income: "รายได้ที่คาดหวัง",
        calc_profit_rate: "อัตราผลตอบแทนที่คาดหวัง",
        close: "ปิด",
        close_time: "เวลาปิด",
        closed_position: "ตำแหน่งที่ปิด",
        direction: "ทิศทาง",
        high: "สูง",
        in_transaction: "ในตำแหน่ง",
        input_trade_num: "กรุณากรอกจำนวน",
        low: "ต่ำ",
        open: "เปิด",
        open_time: "เวลาเปิด",
        predict_profit: "คาดหวังกำไร",
        profit: "กำไร",
        profit_rate: "อัตรากำไร",
        select_trade_time: "เลือกวันหมดอายุ",
        statistics: "สถิติ",
        trade_num: "ปริมาณ",
        trade_time: "ระยะเวลา",
        trading_pairs: "คู่การซื้อขาย"
    },
    mining: {
        better1: "ฝากและถอนได้ตลอดเวลา",
        better2: "ออกให้ทุกวัน",
        better3: "วงจรการขุด",
        better4: "แอร์ดรอปได้ตลอดเวลา",
        coin_type: "สกุลเงิน",
        day_profit: "คาดว่านิสสัน",
        doing: "อยู่ระหว่างดำเนินการ",
        expected_profit: "คาดว่านิสสัน",
        finished: "เกิน",
        input_lock_num: "กรุณากรอกจำนวนเงินล็อค",
        interest: "ความสนใจ",
        machine_list: "รายการเครื่องขุด",
        machine_rent: "ให้เช่าเครื่องขุด",
        max_subscribe: "การสมัครสมาชิกสูงสุด",
        mining: "การจัดการทางการเงิน",
        mining_time: "ช่วงการขุด",
        my_subscribe: "การสมัครของฉัน",
        name: "ชื่อ",
        operate: "ดำเนินงาน",
        pay: "จ่าย",
        pay_penal_sum_redemption: "การขอไถ่ถอนความเสียหายที่ชำระบัญชีก่อนกำหนด",
        product_better: "ข้อดีของผลิตภัณฑ์",
        product_content: "การขุดบนคลาวด์คือการใช้ USDT เพื่อมอบความไว้วางใจให้กับเครื่องขุดพลังการประมวลผลระดับซูเปอร์คอมพิวเตอร์ของแพลตฟอร์ม เพื่อขุดผลกำไรในกลุ่มการขุดของแพลตฟอร์มอัจฉริยะ AI ขั้นสูง",
        product_desc: "รายละเอียดสินค้า",
        profit_list: "รายการสิทธิประโยชน์",
        redemption: "การไถ่ถอนเริ่มต้น",
        refunded: "คืนเงินแล้ว",
        refunding: "การสมัครขอคืนเงิน",
        subscribe: "สมัครสมาชิก",
        subscribe_list: "รายการสมัครสมาชิก",
        subscribe_num: "ปริมาณการสมัครสมาชิก",
        subscribe_time: "เวลาสมัครสมาชิก",
        sum_profit: "รายได้รวมโดยประมาณ",
        watch_profit_list: "ดูรายการสิทธิประโยชน์"
    },
    transfer: {
        from: "จาก",
        history: "บันทึกการโอน",
        input_number: "กรุณาระบุจำนวนการโอนเงิน",
        number: "ปริมาณการโอน",
        to: "ถึง"
    }
}
obj.vi = {
    public: {
        name: "Tên",
        last_price: "Giá cuối cùng",
        market: "Xu hướng",
        quotation: "24H thay đổi",
        no_data: "Chưa có dữ liệu",
        no_more: "Không còn nữa.",
        confirm: "Xác nhận",
        use: "Có sẵn",
        freeze: "Đóng băng",
        number: "Số lượng",
        history: "Hồ sơ",
        other: "Thêm",
        tip: "Khuyến mãi",
        copy_success: "Sao chép thành công",
        upload_pic: "Đang tải giấy chứng nhận lên",
        submit: "Giới thiệu",
        status: "Địa vị",
        set: "Thiết lập",
        chat: "Dịch vụ trực tuyến",
        copy: "Sao chép",
        delete: "Xóa",
        confirm_del: "Bạn có chắc chắn muốn xóa nó?",
        add: "Thêm",
        input_full: "Vui lòng điền",
        password_not_equal: "Mật khẩu không phù hợp",
        coming_soon: "Sắp ra mắt~",
        cancel: "Hủy bỏ",
        setting: "Nền",
        product_list: "Danh sách sản phẩm",
        submit_order: "Gửi đơn đặt hàng",
        all: "Tất cả",
        clear: "Thông thoáng",
        close: "Đóng cửa",
        invite_tip: "Quét mẫu mã QR bên trên hoặc nhập mã mời để xác nhận đăng ký.",
        my_assets: "Tài sản của tôi",
        please_input: "Vui lòng nhập",
        record: "Ghi",
        test: "Chỉ để thử nghiệm",
        today: "Hôm nay",
        total_assets: "Chuyển đổi tổng tài sản tài khoản"
    },
    user: {
        h_second: "giây",
        h_timer: "đếm ngược",
        h_accept: "Chấp nhận",
        h_welc: "Chào mừng bạn sử dụng",
        announ_text: "Vì lý do chính sách, dịch vụ không được cung cấp cho Bắc Triều Tiên, Israel, Trung Quốc, Vanuatu và Cuba.",
        announ: "thông báo",
        com_email: "Email khiếu nại",
        dh: "điện thoại",
        qh: "mã vùng",
        qh_dh: "mã vùng/điện thoại",
        user_center: "mỏ",
        login_email: "Nhập email của bạn",
        login_phone: "Đăng nhập di động",
        input_email: "Vui lòng nhập địa chỉ email của bạn",
        input_phone: "Vui lòng nhập số điện thoại di động của bạn",
        password: "Mật ngữ",
        new_paw: "Mật khẩu mới",
        input_password: "Vui lòng nhập mật khẩu",
        re_input_pass: "Nhập lại mật khẩu",
        input_old_password: "Vui lòng nhập mật khẩu cũ của bạn",
        new_user: "Người dùng mới?",
        join_us: "Tham gia ngay",
        forgot_password: "Quên mật khẩu",
        login: "Đăng nhập",
        area_code: "Mã vùng",
        register: "Đăng ký",
        register_email: "Nhập email của bạn",
        register_phone: "Đăng ký di động",
        can_use_asset: "Tài sản có sẵn",
        logout: "Đăng xuất",
        confirm_logout: "Đăng ký hay không",
        logout_success: "Thoát thành công",
        mock_login: "Không cần mở tài khoản, hãy tạo tài khoản demo để giao dịch!",
        account_detail: "Chi tiết tài khoản",
        mock_account: "Tài khoản Demo",
        invite_code: "Mã mời",
        input_invite_code: "Vui lòng nhập mã mời",
        copy_invite_link: "Sao chép liên kết mời",
        trade_account: "Tài khoản giao dịch",
        only_true_account: "Vui lòng đăng ký hoặc đăng nhập vào tài khoản Real Hard",
        reset_mock_account: "Quay lại tài khoản demo",
        confirm_reset: "Trả lại hàng",
        email: "Hộp thư",
        welcome_login: "Chào mừng đăng nhập",
        welcome_register: "Chào mừng đăng ký",
        useful_balance: "Tiền có sẵn",
        please_login: "Đăng nhập"
    },
    forgot: {
        sms_code: "Mã xác nhận",
        input_sms_code: "Vui lòng nhập CAPTCHA",
        send: "Thư điện tử",
        reset: "Đặt lại mật khẩu"
    },
    trade: {
        buy: "Mua hàng",
        sell: "Bán hàng",
        last_price: "Giá thị trường",
        best_price: "Giao dịch với giá tốt nhất hiện tại",
        buy_price: "Giá cả",
        enter_price: "Vui lòng nhập giá",
        trade_amount: "Kích thước lô giao dịch",
        balance: "Cân bằng",
        buy_up: "Làm nhiều",
        buy_low: "Ngắn mạch",
        current_entrust: "Sửa lỗi trước",
        type: "Loại",
        time: "Ngày",
        price: "Giá cả",
        trade_price: "Số tiền giao dịch",
        operate: "Hoạt động",
        close_order: "Đóng vị trí",
        high: "Cao",
        open: "Mở",
        low: "Thấp",
        volume: "Tổng khối lượng",
        order: "Đặt hàng",
        closed: "Đóng cửa",
        order_confirm: "Đơn hàng của bạn đã được xác nhận",
        order_page: "Trang đặt hàng",
        no_mult: "Không có Multiple",
        no_mult_config: "Đòn bẩy chưa được cấu hình, không thể đặt lệnh tạm thời"
    },
    order: {
        current_price: "Giá hiện tại",
        total_ol: "Tổng lợi nhuận và thua lỗ",
        holding: "Giữ vị trí",
        market_price: "Giá thị trường",
        un_deal_order: "Lệnh chờ xử lý",
        history: "Lịch sử",
        hand_num: "Trang chủ",
        stop_loss: "Đặt tổn thất",
        stop_profit: "Thiết lập lợi nhuận",
        times: "Nhân",
        handle_fee: "Phí xử lý",
        bond_fee: "Cạnh",
        balance: "Cân bằng",
        buy_in: "Mua hàng",
        sell_out: "Bán hàng",
        trading: "Địa điểm",
        dealing: "Lệnh chờ xử lý",
        profit: "Lợi nhuận",
        total: "Giá trị ròng",
        pay_rate: "Tỷ lệ trả trước",
        can_use: "Có thể trả trước",
        trade_amount: "Trang chủ",
        unit: "Mỗi tờ giấy",
        page: "Khăn trải giường",
        hazard_rate: "Tỷ lệ rủi ro",
        all_caution_money: "Ký quỹ hiện tại",
        detail: "Chi tiết đặt hàng",
        close: "Đóng vị trí",
        cancel: "Hủy đặt hàng",
        calc_handle_fee: "Phí xử lý dự kiến",
        calc_bond_fee: "Lợi nhuận dự kiến",
        set_stop_price: "Giải cứu",
        currency: "Xử lý giao dịch đúng",
        order_id: "Số đặt phòng",
        order_type: "Hướng dẫn",
        order_price: "Đơn giá thấp hơn",
        close_price: "Kho giá rẻ",
        income: "Lợi nhuận",
        confrim_close_order: "Đây có phải là một nhà kho giá rẻ?",
        open_time: "Giờ mở cửa"
    },
    func: {
        charge_coin: "Đặt cọc",
        withdraw_coin: "Rút tiền",
        billing_detail: "Chi tiết hóa đơn",
        real_auth: "Xác minh tên thật",
        invite_friend: "Mời bạn bè",
        reset_password: "Thay đổi mật khẩu",
        setting: "Cơ quan",
        lang: "Ngôn ngữ",
        wallet: "Ví tiền",
        buy_coin: "Mua xu bằng thẻ ngân hàng",
        future: "Tương lai",
        loan: "Khoản vay",
        more: "Hơn",
        transfer: "Chuyển khoản",
        video_desc: "Băng hình",
        contract: "Hợp đồng"
    },
    financial: {
        financial_records: "Hồ sơ tài chính",
        link_charge: "Sạc trên chuỗi",
        bank_charge: "Điện tín",
        charge_coin: "Tiền xu",
        wallet_address: "Địa chỉ ví",
        copy_address: "Sao chép địa chỉ",
        charge_amount: "Số lượng coin",
        input_charge_amount: "Vui lòng nhập số tiền bạn muốn nạp",
        collect_coin_type: "Thu tiền",
        coin: "Tiền điện tử",
        bank: "Thẻ ngân hàng",
        select_network: "Chọn Network",
        charge_num: "Số tiền nạp",
        input_charge_num: "Vui lòng nhập số tiền nạp",
        charge_history: "Hồ sơ tiền gửi",
        uncheck: "Chưa chọn",
        isfinish: "Đã hoàn thành",
        isreject: "Bị từ chối",
        unuseful: "Không hợp lệ"
    },
    bank: {
        swift_text: "nhanh chóng",
        coin_type: "Thu tiền",
        name: "Tên ngân hàng",
        address: "Địa chỉ ngân hàng",
        SWIFT: "nhanh chóng",
        username: "Người nhận tiền",
        account: "Tài khoản người nhận",
        remark: "Bình luận"
    },
    auth: {
        upload_idcard: "Vui lòng tải lên mặt trước và mặt sau của hộ chiếu/ID của bạn",
        front: "Mặt trước",
        upload_front: "Tải lên mặt trước của hộ chiếu/chứng chỉ của bạn",
        back: "Trái ngược",
        upload_back: "Tải lên mặt trái của hộ chiếu/giấy chứng nhận của bạn",
        input_info: "Vui lòng điền thông tin cá nhân của bạn",
        name: "Tên",
        input_name: "Vui lòng nhập tên của bạn",
        id_number: "Số hộ chiếu/ID",
        input_id_num: "Vui lòng nhập số hộ chiếu/ID của bạn",
        waiting: "Kiểm toán",
        finish: "Xác nhận"
    },
    withdraw: {
        amount: "Số lượng",
        symbol: "Tiền tệ",
        withdraw_coin: "Gửi rút tiền",
        no_pay_way: "Tài khoản fiat không có kênh thanh toán.",
        calc_get: "Dự kiến",
        record: "Hồ sơ rút tiền",
        send_amount: "Số lượng Receipt",
        withdraw_address: "Địa chỉ rút tiền",
        unit: "Đơn vị",
        select_withdraw_address: "Vui lòng chọn địa chỉ bạn muốn gọi"
    },
    wallet: {
        bind_bank_card: "Thẻ ngân hàng ràng buộc",
        bind_coin_address: "Địa chỉ Digital Currency",
        bind: "Liên kết",
        save: "Bảo vệ",
        not_bind: "Vui lòng thiết lập tài khoản nhận tiền trước",
        change_account: "Tài khoản cấp vốn",
        forex_account: "Tài khoản hợp đồng",
        micro_account: "Tài khoản tương lai"
    },
    follow: {
        apply_guide: "Hướng dẫn ứng dụng",
        auto_follow: "Mỗi khi chuyên gia giao dịch mở một vị thế trên một sản phẩm, tôi sẽ tự động mở vị thế tương ứng.",
        auto_open_positions: "Tự động mở lô",
        be_master: "Trở thành bậc thầy",
        closed_follow_order: "Vị thế đóng theo lệnh",
        commission_rate: "tỷ lệ hoa hồng",
        copy_profit: "Lợi nhuận từ đơn đặt hàng mới",
        cover_time: "Thời gian đóng cửa",
        follow: "theo",
        follow_master: "Đi theo chủ nhân",
        follow_now: "Theo giờ",
        followed: "đã theo dõi",
        follower: "người theo sau",
        follower_num: "Số lượng người theo dõi",
        follower_setting: "Cài đặt theo dõi",
        follower_sum: "Tổng số người theo dõi",
        following_order: "Các đơn hàng tiếp theo đang được thực hiện",
        history_order: "Lệnh lịch sử",
        i_agree: "tôi đã đọc và đồng ý",
        lever: "nhiều",
        limit_price: "giới hạn giá",
        margin: "lề",
        master_trader: "Bậc thầy giao dịch",
        max_following: "theo dõi tối đa",
        my_follower: "những người theo dõi tôi",
        rate_of_return: "tỷ lệ lợi nhuận",
        size: "tỉ lệ",
        start_ordering_now: "Bắt đầu đơn hàng đầu tiên của bạn bây giờ",
        submit_apply: "nộp đơn",
        submit_multiple: "Đặt hàng nhiều",
        total_documentary_amount: "Tổng số tiền đặt hàng",
        total_profit: "Tổng doanh thu",
        total_revenue: "Tổng doanh thu",
        unfollow: "Hủy theo dõi",
        view_follow_earnings: "Xem thu nhập sau đây",
        will_pay_profit: "Tiền thu được giải quyết",
        be_trader: "trở thành một thương nhân",
        cancel_follow_tip: "Lệnh mở sẽ không còn tuân theo lệnh đóng, điều này có thể dẫn đến việc bỏ lỡ cơ hội đóng lệnh tốt nhất. \nBạn có chắc chắn muốn hủy không?",
        confirm_cancel_follow: "Hủy đơn hàng sau",
        max_follow_bond: "Số tiền ký quỹ sau tối đa cho mỗi lệnh",
        trader_list: "Danh sách người giao dịch"
    },
    loan: {
        agreement: "Hiệp định",
        amount: "Số lượng",
        auth_reject: "Từ chối kiểm toán",
        auth_success: "Đã được phê duyệt qua xem xét",
        auth_waiting: "Đang chờ kiểm tra",
        birthday: "Ngày sinh:",
        confirm_repay: "Xác nhận hoàn trả",
        confirm_repay_tip: "Vui lòng xác nhận thông tin trả nợ của bạn",
        confirm_repayment: "Xác nhận hoàn trả",
        copy_address: "Sao chép địa chỉ",
        country: "Quốc gia",
        day: "Ngày",
        day_rate: "Lãi suất hàng ngày",
        female: "Nữ giới",
        first_name: "Họ",
        free_day: "Ngày miễn lãi",
        hand_pic: "Ảnh ID cầm tay",
        id_card: "NHẬN DẠNG",
        identify_card: "Chứng chỉ",
        input_amount: "Vui lòng nhập số tiền",
        input_country: "Vui lòng nhập quốc gia",
        input_first_name: "Vui lòng nhập họ",
        input_last_name: "Vui lòng nhập tên",
        input_mobile: "Vui lòng nhập số điện thoại của bạn",
        is_rejected: "Vật bị loại bỏ",
        is_repay: "Sửa chữa",
        last_name: "Tên",
        loan: "Khoản vay",
        loan_now: "Vay ngay bây giờ",
        loan_order: "Lệnh vay",
        loan_time: "Thời hạn vay",
        loaning: "Bạn đang đăng ký một khoản vay",
        male: "Nam giới",
        max: "Tối đa",
        mobile: "Số điện thoại",
        need_repay: "Yêu cầu hoàn trả",
        passport: "Hộ chiếu",
        penalty_amount: "Mức phạt vi phạm hợp đồng",
        please_sign: "Xin vui lòng ký tên của bạn.",
        please_waiting: "Cảm ơn bạn đã gửi tệp KYC. \nNhóm của chúng tôi sẽ kiểm tra thông tin của bạn trong vòng 48 giờ. \nHãy kiên nhẫn và chờ đợi kết quả kiểm toán.",
        repay: "Trả nợ ngay bây giờ",
        repayment_check: "Đang tiến hành kiểm tra trả nợ",
        repayment_time: "Ngày trả nợ",
        resign: "Từ chức",
        reviewed_at: "Cho phép thời gian",
        select_day: "Vui lòng chọn một ngày",
        sex: "Giới tính",
        sign: "chữ ký",
        start_loan: "Bắt đầu tận hưởng dịch vụ cho vay của chúng tôi",
        to_repayment: "Hãy tiếp tục và trả nợ",
        total_profit: "Tổng lãi",
        transfer_address: "Địa chỉ chuyển",
        upload_credit: "Tải thông tin xác thực lên",
        verified: "Đã xác minh",
        verify: "Bắt đầu xác minh"
    },
    micro: {
        "24h_volume": "Âm lượng 24 giờ",
        buy_down: "Mua xuống",
        buy_up: "mua lên",
        calc_income: "Thu nhập dự kiến",
        calc_profit_rate: "Tỷ suất lợi nhuận kỳ vọng",
        close: "Đóng",
        close_time: "Giờ đóng cửa",
        closed_position: "Vị thế đã đóng",
        direction: "Phương hướng",
        high: "Cao",
        in_transaction: "Ở các vị trí",
        input_trade_num: "Vui lòng nhập số lượng",
        low: "Thấp",
        open: "Mở",
        open_time: "Thời gian mở cửa",
        predict_profit: "Kỳ vọng lợi nhuận",
        profit: "Lợi nhuận",
        profit_rate: "Tỷ suất lợi nhuận",
        select_trade_time: "Chọn ngày hết hạn",
        statistics: "Thống kê",
        trade_num: "Số lượng",
        trade_time: "Khoảng thời gian",
        trading_pairs: "Cặp giao dịch"
    },
    mining: {
        better1: "Gửi tiền và rút tiền bất cứ lúc nào",
        better2: "Phát hành hàng ngày",
        better3: "Chu kỳ khai thác",
        better4: "Airdrop bất cứ lúc nào",
        coin_type: "Tiền tệ",
        day_profit: "Nissan dự kiến",
        doing: "đang tiến hành",
        expected_profit: "Nissan dự kiến",
        finished: "qua",
        input_lock_num: "Vui lòng nhập số tiền khóa",
        interest: "Quan tâm",
        machine_list: "Danh sách máy khai thác",
        machine_rent: "Cho thuê máy khai thác mỏ",
        max_subscribe: "Đăng ký tối đa",
        mining: "Quản lý tài chính",
        mining_time: "Thời kỳ khai thác",
        my_subscribe: "Đăng ký của tôi",
        name: "tên",
        operate: "vận hành",
        pay: "chi trả",
        pay_penal_sum_redemption: "Đơn yêu cầu bồi thường trước hạn số tiền bồi thường thiệt hại",
        product_better: "Ưu điểm sản phẩm",
        product_content: "Khai thác trên nền tảng đám mây là sử dụng USDT để giao cho máy khai thác sức mạnh siêu tính toán của nền tảng nhằm khai thác lợi nhuận trong nhóm khai thác của nền tảng siêu thông minh AI.",
        product_desc: "mô tả sản phẩm",
        profit_list: "Danh sách lợi ích",
        redemption: "đổi trả mặc định",
        refunded: "được hoàn lại tiền",
        refunding: "Nộp đơn xin hoàn tiền",
        subscribe: "Đăng ký",
        subscribe_list: "Danh sách đăng ký",
        subscribe_num: "Số lượng đăng ký",
        subscribe_time: "Thời gian đăng ký",
        sum_profit: "Tổng doanh thu ước tính",
        watch_profit_list: "Xem danh sách lợi ích"
    },
    transfer: {
        from: "Từ",
        history: "Hồ sơ chuyển nhượng",
        input_number: "Vui lòng nhập số lượng chuyển khoản",
        number: "Số lượng chuyển",
        to: "ĐẾN"
    }
}
obj.fr = {
    public: {
        name: "Le nom",
        last_price: "Dernier prix",
        market: "Les tendances",
        quotation: "24h changement",
        no_data: "Pas encore de données",
        no_more: "N'est plus",
        confirm: "Confirmation",
        use: "Disponible",
        freeze: "Congelé",
        number: "Quantité",
        history: "Enregistrement",
        other: "En outre",
        tip: "Provoquer",
        copy_success: "Copie réussie",
        upload_pic: "Téléchargement du certificat",
        submit: "Soumettre",
        status: "Statut",
        set: "Paramètres",
        chat: "Services en ligne",
        copy: "Copier",
        delete: "Supprimer",
        confirm_del: "Êtes - vous sûr de vouloir supprimer?",
        add: "Ajouter",
        input_full: "Veuillez remplir",
        password_not_equal: "Incohérence du mot de passe",
        coming_soon: "Bientôt disponible ~",
        cancel: "Annulation",
        setting: "Contexte",
        product_list: "Liste des produits",
        submit_order: "Soumettre une commande",
        all: "Tous",
        clear: "Clair",
        close: "Fermeture",
        invite_tip: "Scannez le modèle de code QR ci-dessus ou saisissez le code d'invitation pour confirmer l'inscription.",
        my_assets: "Mes atouts",
        please_input: "Veuillez entrer",
        record: "Enregistrer",
        test: "Juste pour tester",
        today: "Aujourd'hui",
        total_assets: "Conversion totale des actifs du compte"
    },
    user: {
        h_second: "seconde",
        h_timer: "compte à rebours",
        h_accept: "Accepter",
        h_welc: "Bienvenue dans l'utilisation",
        announ_text: "Pour des raisons politiques, les services ne sont pas fournis à la Corée du Nord, à Israël, à la Chine, au Vanuatu et à Cuba.",
        announ: "annonce",
        com_email: "Boîte aux lettres de réclamation",
        dh: "téléphone",
        qh: "indicatif régional",
        qh_dh: "indicatif régional/téléphone",
        user_center: "La mine",
        login_email: "Entrez votre email",
        login_phone: "Connexion mobile",
        input_email: "Veuillez entrer votre adresse e - mail",
        input_phone: "Veuillez entrer votre numéro de téléphone portable",
        password: "La langue sombre",
        new_paw: "Nouveau mot de passe",
        input_password: "Veuillez entrer votre mot de passe",
        re_input_pass: "Retaper le mot de passe",
        input_old_password: "Veuillez entrer votre ancien mot de passe",
        new_user: "Un nouvel utilisateur?",
        join_us: "Inscrivez - vous maintenant",
        forgot_password: "Mot de passe oublié",
        login: "Se connecter",
        area_code: "Code de la région",
        register: "Enregistrement",
        register_email: "Entrez votre email",
        register_phone: "Enregistrement mobile",
        can_use_asset: "Actifs disponibles",
        logout: "Déconnexion",
        confirm_logout: "Se retirer de l'enregistrement ou non",
        logout_success: "Sortie réussie",
        mock_login: "Pas besoin d'ouvrir un compte, créez un compte démo pour Trader!",
        account_detail: "Détails du compte",
        mock_account: "Compte de simulation",
        invite_code: "Code d'invitation",
        input_invite_code: "Veuillez entrer le Code d'invitation",
        copy_invite_link: "Copier le lien d'invitation",
        trade_account: "Compte de Trading",
        only_true_account: "Veuillez vous inscrire ou vous connecter à Real hard account",
        reset_mock_account: "Retour au compte de simulation",
        confirm_reset: "Retours ou non",
        email: "Boîte postale",
        welcome_login: "Bienvenue login",
        welcome_register: "Inscription bienvenue",
        useful_balance: "Fonds disponibles",
        please_login: "Veuillez vous connecter"
    },
    forgot: {
        sms_code: "Code de vérification",
        input_sms_code: "Veuillez entrer le Code de vérification",
        send: "Par courrier",
        reset: "Réinitialiser le mot de passe"
    },
    trade: {
        buy: "Acheter",
        sell: "Vendre",
        last_price: "Prix du marché",
        best_price: "Tradez au meilleur prix actuel",
        buy_price: "Prix",
        enter_price: "Veuillez entrer le prix",
        trade_amount: "Taille du lot de transactions",
        balance: "Équilibre",
        buy_up: "Faire long",
        buy_low: "Court - circuit",
        current_entrust: "Pré - débogage",
        type: "Type",
        time: "Date",
        price: "Prix",
        trade_price: "Montant de la transaction",
        operate: "Activités",
        close_order: "Position fermée",
        high: "Haute",
        open: "Ouvrir",
        low: "Faible",
        volume: "Volume total",
        order: "Commandes",
        closed: "Fermé",
        order_confirm: "Votre commande est confirmée",
        order_page: "Page de commande",
        no_mult: "Pas de multiples",
        no_mult_config: "Levier non configuré, impossible temporairement de passer une commande"
    },
    order: {
        current_price: "Prix actuel",
        total_ol: "Total des profits et pertes",
        holding: "Ouverture des positions",
        market_price: "Prix du marché",
        un_deal_order: "Commandes en attente de traitement",
        history: "Historique",
        hand_num: "Lotz",
        stop_loss: "Définir les pertes",
        stop_profit: "Fixer les bénéfices",
        times: "Multiplicateur",
        handle_fee: "Frais de traitement",
        bond_fee: "Le bord",
        balance: "Équilibre",
        buy_in: "Acheter",
        sell_out: "Vendre",
        trading: "Localisation",
        dealing: "Commandes en attente de traitement",
        profit: "Gains et pertes",
        total: "Valeur nette",
        pay_rate: "Taux de paiement anticipé",
        can_use: "Remboursement anticipé possible",
        trade_amount: "Lotz",
        unit: "Chaque feuille de papier",
        page: "Linge de lit",
        hazard_rate: "Taux de risque",
        all_caution_money: "Marge actuelle",
        detail: "Détails de la commande",
        close: "Position fermée",
        cancel: "Annuler une commande",
        calc_handle_fee: "Frais de traitement estimés",
        calc_bond_fee: "Bénéfices attendus",
        set_stop_price: "Sauver",
        currency: "Traitement des transactions",
        order_id: "Numéro de réservation",
        order_type: "Direction",
        order_price: "Prix unitaire inférieur",
        close_price: "Entrepôt prix pas cher",
        income: "Bénéfices",
        confrim_close_order: "Est - ce un entrepôt bon marché?",
        open_time: "Heures d'ouverture"
    },
    func: {
        charge_coin: "Dépôt",
        withdraw_coin: "Retrait",
        billing_detail: "Détails de facturation",
        real_auth: "Vérification du vrai nom",
        invite_friend: "Inviter un ami",
        reset_password: "Modifier le mot de passe",
        setting: "Institutions",
        lang: "Langue",
        wallet: "Portefeuille",
        buy_coin: "Acheter des pièces avec une carte bancaire",
        contract: "Contracter",
        future: "Avenir",
        loan: "Prêt",
        more: "Plus",
        transfer: "Transfert",
        video_desc: "Vidéo"
    },
    financial: {
        financial_records: "Dossiers financiers",
        link_charge: "Charge sur la chaîne",
        bank_charge: "Ligne télégraphique",
        charge_coin: "Pièces de monnaie",
        wallet_address: "Adresse du portefeuille",
        copy_address: "Copier l'adresse",
        charge_amount: "Nombre de pièces de monnaie",
        input_charge_amount: "Veuillez entrer le nombre de pièces à recharger",
        collect_coin_type: "Monnaie de collecte",
        coin: "Monnaie numérique",
        bank: "Carte bancaire",
        select_network: "Choisir un réseau",
        charge_num: "Montant de la recharge",
        input_charge_num: "Veuillez entrer le montant de la recharge",
        charge_history: "Enregistrement des dépôts",
        uncheck: "Non sélectionné",
        isfinish: "Terminé",
        isreject: "Refusé",
        unuseful: "Invalide"
    },
    bank: {
        swift_text: "Rapide",
        coin_type: "Monnaie de collecte",
        name: "Nom de la Banque",
        address: "Adresse de la Banque",
        SWIFT: "Rapide",
        username: "Le bénéficiaire",
        account: "Compte du bénéficiaire",
        remark: "Commentaires"
    },
    auth: {
        upload_idcard: "Veuillez télécharger le recto et le verso de votre passeport / carte d'identité",
        front: "Le Front",
        upload_front: "Téléchargez votre passeport / certificat recto",
        back: "Le contraire",
        upload_back: "Télécharger le verso de votre passeport / certificat",
        input_info: "Veuillez remplir vos informations personnelles",
        name: "Le nom",
        input_name: "Veuillez entrer votre nom",
        id_number: "Numéro de passeport / carte d'identité",
        input_id_num: "Veuillez entrer votre numéro de passeport / carte d'identité",
        waiting: "Audit",
        finish: "Confirmé"
    },
    withdraw: {
        amount: "Quantité",
        symbol: "Devises",
        withdraw_coin: "Soumettre un retrait",
        no_pay_way: "Les comptes en monnaie française n'ont pas de canaux de paiement.",
        calc_get: "Prévu",
        record: "Prise de monnaie record",
        send_amount: "Nombre de reçus",
        withdraw_address: "Adresse de prise de monnaie",
        unit: "Unités",
        select_withdraw_address: "Veuillez sélectionner l'adresse à appeler"
    },
    wallet: {
        bind_bank_card: "Carte bancaire liée",
        bind_coin_address: "Adresse de monnaie numérique liée",
        bind: "Combiné",
        save: "Protection",
        not_bind: "Veuillez d'abord configurer un compte de collecte",
        change_account: "Compte de financement",
        forex_account: "Compte de contrat",
        micro_account: "Compte futur"
    },
    follow: {
        apply_guide: "Instructions de candidature",
        auto_follow: "Chaque fois qu'un expert en trading ouvre une position sur un produit, j'ouvrirai automatiquement la position en conséquence.",
        auto_open_positions: "Ouverture automatique des lots",
        be_master: "Devenez un maître",
        closed_follow_order: "Position fermée suite à ordre",
        commission_rate: "taux de commission",
        copy_profit: "Profitez des nouvelles commandes",
        cover_time: "Heure de fermeture",
        follow: "suivre",
        follow_master: "Suivez le maître",
        follow_now: "Suivez maintenant",
        followed: "suivi",
        follower: "disciple",
        follower_num: "Nombre d'abonnés",
        follower_setting: "Paramètres de suivi",
        follower_sum: "Nombre total d'abonnés",
        following_order: "Commandes de suivi en cours",
        history_order: "Commandes historiques",
        i_agree: "J'ai lu et accepté",
        lever: "plusieurs",
        limit_price: "limite de prix",
        margin: "marge",
        master_trader: "Maître du commerce",
        max_following: "suivi maximum",
        my_follower: "mes abonnés",
        rate_of_return: "taux de retour",
        size: "échelle",
        start_ordering_now: "Commencez votre première commande maintenant",
        submit_apply: "présenter une demande",
        submit_multiple: "Commandez plusieurs",
        total_documentary_amount: "Montant total de la commande",
        total_profit: "Revenu total",
        total_revenue: "Revenu total",
        unfollow: "Ne plus suivre",
        view_follow_earnings: "Voir les revenus suivants",
        will_pay_profit: "Recettes à régler",
        be_trader: "devenir commerçant",
        cancel_follow_tip: "Les ordres ouverts ne suivront plus l'ordre de clôture, ce qui peut entraîner la perte de la meilleure opportunité de clôture. \nÊtes-vous sûr de vouloir annuler ?",
        confirm_cancel_follow: "Annuler la commande suivante",
        max_follow_bond: "Marge de suivi maximale par commande",
        trader_list: "Liste des commerçants"
    },
    loan: {
        agreement: "Accord",
        amount: "Montant",
        auth_reject: "Rejet de l'audit",
        auth_success: "Approuvé par examen",
        auth_waiting: "En attente d'audit",
        birthday: "Date de naissance:",
        confirm_repay: "Confirmation de remboursement",
        confirm_repay_tip: "Veuillez confirmer vos informations de remboursement",
        confirm_repayment: "Confirmer le remboursement",
        copy_address: "Copier l'adresse",
        country: "Pays",
        day: "Jour",
        day_rate: "Taux d'intérêt quotidien",
        female: "Femelle",
        first_name: "Nom de famille",
        free_day: "Jours sans intérêt",
        hand_pic: "Photo d'identité portable",
        id_card: "IDENTIFIANT",
        identify_card: "Certificats",
        input_amount: "Veuillez saisir le montant",
        input_country: "Veuillez entrer le pays",
        input_first_name: "Veuillez entrer votre nom de famille",
        input_last_name: "Veuillez entrer un nom",
        input_mobile: "Veuillez entrer votre numéro de téléphone",
        is_rejected: "Rejeté",
        is_repay: "Réparé",
        last_name: "Nom",
        loan: "Prêt",
        loan_now: "Emprunter maintenant",
        loan_order: "Ordre de prêt",
        loan_time: "Durée du prêt",
        loaning: "Vous faites une demande de prêt",
        male: "Mâle",
        max: "Maximum",
        mobile: "Numéro de téléphone",
        need_repay: "Remboursement requis",
        passport: "Passeport",
        penalty_amount: "Pénalité pour rupture de contrat",
        please_sign: "Veuillez signer votre nom.",
        please_waiting: "Merci d'avoir soumis le fichier KYC. \nNotre équipe auditera vos informations dans les 48 heures. \nSoyez patient et attendez les résultats de l’audit.",
        repay: "Rembourser maintenant",
        repayment_check: "Audit de remboursement en cours",
        repayment_time: "Date de remboursement",
        resign: "Démissionner",
        reviewed_at: "Accorder du temps",
        select_day: "Veuillez sélectionner une date",
        sex: "Genre",
        sign: "Autographe",
        start_loan: "Commencez à profiter de nos services de prêt",
        to_repayment: "Allez-y et remboursez",
        total_profit: "Intérêt total",
        transfer_address: "Adresse de transfert",
        upload_credit: "Télécharger les informations d'identification",
        verified: "Vérifié",
        verify: "Commencer la vérification"
    },
    micro: {
        "24h_volume": "Volume 24H",
        buy_down: "Acheter vers le bas",
        buy_up: "Acheter",
        calc_income: "Revenu attendu",
        calc_profit_rate: "Taux de rendement attendu",
        close: "Fermer",
        close_time: "Heure de fermeture",
        closed_position: "Postes fermés",
        direction: "Direction",
        high: "Haut",
        in_transaction: "Dans des postes",
        input_trade_num: "Veuillez entrer la quantité",
        low: "Faible",
        open: "Ouvrir",
        open_time: "Temps d'ouverture",
        predict_profit: "Attendez-vous à un profit",
        profit: "Profit",
        profit_rate: "Taux de profit",
        select_trade_time: "Sélectionnez la date d'expiration",
        statistics: "Statistiques",
        trade_num: "Quantité",
        trade_time: "Durée",
        trading_pairs: "Trading de paires"
    },
    mining: {
        better1: "Déposez et retirez à tout moment",
        better2: "Publié quotidiennement",
        better3: "Cycle minier",
        better4: "Airdrop à tout moment",
        coin_type: "Devise",
        day_profit: "Nissan attendu",
        doing: "en cours",
        expected_profit: "Nissan attendu",
        finished: "sur",
        input_lock_num: "Veuillez saisir le montant du blocage",
        interest: "Intérêt",
        machine_list: "Liste des machines minières",
        machine_rent: "Location de machines minières",
        max_subscribe: "Abonnement maximum",
        mining: "Gestion financière",
        mining_time: "Période minière",
        my_subscribe: "Mon abonnement",
        name: "nom",
        operate: "fonctionner",
        pay: "payer",
        pay_penal_sum_redemption: "Demande de remboursement anticipé des dommages-intérêts",
        product_better: "Avantages du produit",
        product_content: "Le cloud mining consiste à utiliser l'USDT pour être confié à la machine minière de super-informatique de la plate-forme pour extraire les bénéfices du pool minier de la plate-forme super-intelligente d'IA.",
        product_desc: "description du produit",
        profit_list: "Liste des avantages",
        redemption: "rachat par défaut",
        refunded: "remboursé",
        refunding: "Demander un remboursement",
        subscribe: "Abonnement",
        subscribe_list: "Liste d'abonnement",
        subscribe_num: "Quantité d'abonnement",
        subscribe_time: "Durée d'abonnement",
        sum_profit: "Revenu total estimé",
        watch_profit_list: "Afficher la liste des avantages"
    },
    transfer: {
        from: "Depuis",
        history: "Enregistrement de transfert",
        input_number: "Veuillez saisir la quantité à transférer",
        number: "Quantité transférée",
        to: "À"
    }
}
obj.de = {
    public: {
        name: "Name",
        last_price: "Letzter Preis",
        market: "Trend",
        quotation: "24H Änderung",
        no_data: "Noch keine Daten",
        no_more: "Nicht mehr",
        confirm: "Bestätigung",
        use: "Verfügbar",
        freeze: "Einfrieren",
        number: "Menge",
        history: "Aufzeichnung",
        other: "Sonstige",
        tip: "Prompt",
        copy_success: "Erfolgreich kopiert",
        upload_pic: "Zertifikat hochladen",
        submit: "Absenden",
        status: "Status",
        set: "Set",
        chat: "Online Service",
        copy: "Kopieren",
        delete: "löschen",
        confirm_del: "Sind Sie sicher, dass Sie löschen?",
        add: "Hinzufügen",
        input_full: "Bitte ausfüllen",
        password_not_equal: "Inkonsistenz des Passworts",
        coming_soon: "Kommt bald~",
        cancel: "Abbrechen",
        setting: "Einstellung",
        product_list: "Produktliste",
        submit_order: "Auftrag abschicken",
        all: "Alle",
        clear: "Klar",
        close: "Schließung",
        invite_tip: "Scannen Sie das QR-Code-Muster oben oder geben Sie den Einladungscode ein, um die Registrierung zu bestätigen.",
        my_assets: "Mein Vermögen",
        please_input: "Bitte treten Sie ein",
        record: "Aufzeichnen",
        test: "Nur zum Testen",
        today: "Heute",
        total_assets: "Gesamtumwandlung des Kontovermögens"
    },
    user: {
        h_second: "second",
        h_timer: "Countdown",
        h_accept: "Akzeptieren",
        h_welc: "Willkommen bei der Verwendung",
        announ_text: "Aus politischen Gründen werden keine Dienstleistungen für Nordkorea, Israel, China, Vanuatu und Kuba angeboten.",
        announ: "Ankündigung",
        com_email: "Beschwerde-E-Mail",
        dh: "Telefon",
        qh: "Vorwahl",
        qh_dh: "Vorwahl/Telefon",
        user_center: "Meine",
        login_email: "Geben Sie Ihre E-Mail-Adresse ein",
        login_phone: "Mobile Anmeldung",
        input_email: "Bitte geben Sie Ihre E-Mail-Adresse ein",
        input_phone: "Bitte geben Sie Ihre Handynummer ein",
        password: "Passwort",
        new_paw: "Neues Passwort",
        input_password: "Bitte geben Sie Ihr Passwort ein",
        re_input_pass: "Passwort neu eingeben",
        input_old_password: "Bitte geben Sie Ihr altes Passwort ein",
        new_user: "Neuer Benutzer?",
        join_us: "Jetzt beitreten",
        forgot_password: "Passwort vergessen",
        login: "Login",
        area_code: "Gebietsvorwahl",
        register: "Registrieren",
        register_email: "Geben Sie Ihre E-Mail-Adresse ein",
        register_phone: "Mobile Registrierung",
        can_use_asset: "Verfügbare Vermögenswerte",
        logout: "Abmelden",
        confirm_logout: "Ob aus dem Register zurückgetreten werden soll",
        logout_success: "Erfolgreicher Ausstieg",
        mock_login: "Sie müssen kein Konto eröffnen, erstellen Sie ein Demokonto, um jetzt zu handeln!",
        account_detail: "Kontodetails",
        mock_account: "Simulationskonto",
        invite_code: "Einladungscode",
        input_invite_code: "Bitte geben Sie den Einladungscode ein",
        copy_invite_link: "Einladungslink kopieren",
        trade_account: "Handelskonto",
        only_true_account: "Bitte registrieren Sie sich oder loggen Sie sich in ein echtes Hardkonto ein",
        reset_mock_account: "Simuliertes Return-Konto",
        confirm_reset: "Ob es zurückgegeben werden soll",
        email: "Postfach",
        welcome_login: "Willkommen zum Login",
        welcome_register: "Willkommen zur Anmeldung",
        useful_balance: "Verfügbare Mittel",
        please_login: "Bitte loggen Sie sich ein"
    },
    forgot: {
        sms_code: "Prüfcode",
        input_sms_code: "Bitte geben Sie den Bestätigungscode ein",
        send: "Senden",
        reset: "Passwort zurücksetzen"
    },
    trade: {
        buy: "Kaufen",
        sell: "Verkaufen",
        last_price: "Marktpreis",
        best_price: "Handel zum besten aktuellen Preis",
        buy_price: "Preis",
        enter_price: "Bitte geben Sie den Preis ein",
        trade_amount: "Handelslosgröße",
        balance: "Saldo",
        buy_up: "go long",
        buy_low: "Verkürzung",
        current_entrust: "Vorherige Inbetriebnahme",
        type: "Typ",
        time: "Datum",
        price: "Preis",
        trade_price: "Transaktionsbetrag",
        operate: "Betrieb",
        close_order: "Position schließen",
        high: "Hoch",
        open: "Öffnen",
        low: "Niedrig",
        volume: "Gesamtvolumen",
        order: "Aufträge",
        closed: "Geschlossen",
        order_confirm: "Ihre Bestellung wurde bestätigt",
        order_page: "Bestellseite",
        no_mult: "Kein Mehrfaches",
        no_mult_config: "Kein Hebel konfiguriert, kann vorübergehend nicht bestellt werden"
    },
    order: {
        current_price: "Aktueller Preis",
        total_ol: "Gesamtergebnis",
        holding: "Position halten",
        market_price: "Marktpreis",
        un_deal_order: "Ausstehende Aufträge",
        history: "Geschichte",
        hand_num: "Viele",
        stop_loss: "Set Loss",
        stop_profit: "Gewinn festlegen",
        times: "Multiplikator",
        handle_fee: "Bearbeitungsgebühr",
        bond_fee: "Marge",
        balance: "Saldo",
        buy_in: "Kaufen",
        sell_out: "Verkaufen",
        trading: "Positionen",
        dealing: "Ausstehende Aufträge",
        profit: "Gewinn und Verlust",
        total: "Nettowert",
        pay_rate: "Vorauszahlungsverhältnis",
        can_use: "Vorauszahlung möglich",
        trade_amount: "Viele",
        unit: "Jedes Blatt",
        page: "Blatt",
        hazard_rate: "Risikorate",
        all_caution_money: "Aktuelle Marge",
        detail: "Bestelldetails",
        close: "Position schließen",
        cancel: "Bestellung stornieren",
        calc_handle_fee: "Geschätzte Bearbeitungsgebühr",
        calc_bond_fee: "Geschätzte Marge",
        set_stop_price: "Speichern",
        currency: "Transaktionspaare",
        order_id: "Reservierungsnummer",
        order_type: "Richtung",
        order_price: "Niedrigerer Stückpreis",
        close_price: "Günstige Lagerpreise",
        income: "Gewinn",
        confrim_close_order: "Ist es ein billiges Lager?",
        open_time: "Öffnungszeiten"
    },
    func: {
        charge_coin: "Kaution",
        withdraw_coin: "Rücknahme",
        billing_detail: "Rechnungsdetails",
        real_auth: "Echtname-Verifizierung",
        invite_friend: "Freunde einladen",
        reset_password: "Passwort ändern",
        setting: "Einrichtung",
        lang: "Sprache",
        wallet: "Geldbörse",
        buy_coin: "Kaufen Sie Münzen mit Bankkarte",
        contract: "Vertrag",
        future: "Zukunft",
        loan: "Darlehen",
        more: "Mehr",
        transfer: "Überweisen",
        video_desc: "Video"
    },
    financial: {
        financial_records: "Finanzbuchhaltung",
        link_charge: "Aufladen an der Kette",
        bank_charge: "Telegrafendraht",
        charge_coin: "Münzen",
        wallet_address: "Wallet-Adresse",
        copy_address: "Adresse kopieren",
        charge_amount: "Anzahl der Münzen",
        input_charge_amount: "Bitte geben Sie die Anzahl der zu belastenden Münzen ein",
        collect_coin_type: "Empfangswährung",
        coin: "Digitale Währung",
        bank: "Bankkarte",
        select_network: "Netzwerk auswählen",
        charge_num: "Aufladungsbetrag",
        input_charge_num: "Bitte geben Sie den Ladebetrag ein",
        charge_history: "Einlagenbilanz",
        uncheck: "Nicht markiert",
        isfinish: "Abgeschlossen",
        isreject: "Abgelehnt",
        unuseful: "Ungültig"
    },
    bank: {
        swift_text: "SWIFT",
        coin_type: "Empfängerwährung",
        name: "Name der Bank",
        address: "Bankadresse",
        SWIFT: "SWIFT",
        username: "Zahlungsempfänger",
        account: "Zahlungsempfängerkonto",
        remark: "Bemerkung"
    },
    auth: {
        upload_idcard: "Bitte laden Sie die Vorder- und Rückseite Ihres Reisepasses/Personalausweises hoch",
        front: "Vorne",
        upload_front: "Laden Sie die Vorderseite Ihres Reisepasses/Zeugnisses hoch",
        back: "Rückseite",
        upload_back: "Laden Sie die Rückseite Ihres Reisepasses/Zertifikats hoch",
        input_info: "Bitte füllen Sie Ihre persönlichen Daten aus",
        name: "Name",
        input_name: "Bitte geben Sie Ihren Namen ein",
        id_number: "Pass-/ID-Nummer",
        input_id_num: "Bitte geben Sie Ihre Pass-/ID-Nummer ein",
        waiting: "Prüfung",
        finish: "Zertifiziert"
    },
    withdraw: {
        amount: "Betrag",
        symbol: "Währung",
        withdraw_coin: "Auszahlung einreichen",
        no_pay_way: "Es gibt keinen Zahlungskanal für das französische Währungskonto.",
        calc_get: "Es wird erwartet, dass",
        record: "Aufzeichnung der Münzentnahme",
        send_amount: "Anzahl der Einnahmen",
        withdraw_address: "Adresse für Münzabhebungen",
        unit: "Einheit",
        select_withdraw_address: "Bitte wählen Sie eine Adresse zum Anrufen"
    },
    wallet: {
        bind_bank_card: "Verbindliche Bankkarte",
        bind_coin_address: "Adresse der verbindlichen digitalen Währung",
        bind: "Bindung",
        save: "Konservierung",
        not_bind: "Bitte legen Sie zuerst ein Inkassokonto an",
        change_account: "Finanzierungskonto",
        forex_account: "Vertragskonto",
        micro_account: "Zukünftiges Konto"
    },
    follow: {
        apply_guide: "Anwendungsinstruktionen",
        auto_follow: "Jedes Mal, wenn ein Handelsexperte eine Position für ein Produkt eröffnet, eröffne ich die Position automatisch entsprechend.",
        auto_open_positions: "Automatisches Öffnen von Losen",
        be_master: "Werde ein Meister",
        closed_follow_order: "Geschlossene Stellung entsprechend der Reihenfolge",
        commission_rate: "Provisionssatz",
        copy_profit: "Profitieren Sie von neuen Aufträgen",
        cover_time: "Geschäftsschluss",
        follow: "folgen",
        follow_master: "Folge dem Meister",
        follow_now: "Folge jetzt",
        followed: "gefolgt",
        follower: "Anhänger",
        follower_num: "Anzahl der Follower",
        follower_setting: "Follow-up-Einstellungen",
        follower_sum: "Gesamtzahl der Follower",
        following_order: "Folgeaufträge in Bearbeitung",
        history_order: "Historische Orden",
        i_agree: "Ich habe gelesen und stimme zu",
        lever: "mehrere",
        limit_price: "Preislimit",
        margin: "Marge",
        master_trader: "Handelsmeister",
        max_following: "maximale folgen",
        my_follower: "meine Abonnenten",
        rate_of_return: "Rendite",
        size: "Skala",
        start_ordering_now: "Starten Sie jetzt Ihre erste Bestellung",
        submit_apply: "Bewerbung einreichen",
        submit_multiple: "Bestellen Sie mehrere",
        total_documentary_amount: "Gesamtbestellwert",
        total_profit: "Gesamtumsatz",
        total_revenue: "Gesamtumsatz",
        unfollow: "Nicht mehr folgen",
        view_follow_earnings: "Folgende Einkünfte anzeigen",
        will_pay_profit: "Der Erlös ist abzurechnen",
        be_trader: "Werde Händler",
        cancel_follow_tip: "Offene Aufträge folgen nicht mehr dem Abschlussauftrag, was dazu führen kann, dass die beste Abschlussmöglichkeit verpasst wird. \nSind Sie sicher, dass Sie stornieren möchten?",
        confirm_cancel_follow: "Folgende Bestellung stornieren",
        max_follow_bond: "Maximale Folgemarge pro Bestellung",
        trader_list: "Händlerliste"
    },
    loan: {
        agreement: "Vereinbarung",
        amount: "Menge",
        auth_reject: "Audit-Ablehnung",
        auth_success: "Durch Überprüfung genehmigt",
        auth_waiting: "Ausstehende Prüfung",
        birthday: "Geburtsdatum:",
        confirm_repay: "Rückzahlungsbestätigung",
        confirm_repay_tip: "Bitte bestätigen Sie Ihre Rückzahlungsinformationen",
        confirm_repayment: "Bestätigen Sie die Rückzahlung",
        copy_address: "Adresse kopieren",
        country: "Land",
        day: "Tag",
        day_rate: "Täglicher Zinssatz",
        female: "Weiblich",
        first_name: "Nachname",
        free_day: "Zinsfreie Tage",
        hand_pic: "Handheld-Ausweisfoto",
        id_card: "AUSWEIS",
        identify_card: "Zertifikate",
        input_amount: "Bitte geben Sie den Betrag ein",
        input_country: "Bitte geben Sie das Land ein",
        input_first_name: "Bitte geben Sie den Nachnamen ein",
        input_last_name: "Bitte geben Sie einen Namen ein",
        input_mobile: "Bitte geben Sie Ihre Telefonnummer ein",
        is_rejected: "Abgelehnt",
        is_repay: "Repariert",
        last_name: "Name",
        loan: "Darlehen",
        loan_now: "Jetzt ausleihen",
        loan_order: "Kreditauftrag",
        loan_time: "Kreditlaufzeit",
        loaning: "Sie beantragen einen Kredit",
        male: "Männlich",
        max: "Maximal",
        mobile: "Telefonnummer",
        need_repay: "Rückzahlung erforderlich",
        passport: "Reisepass",
        penalty_amount: "Vertragsstrafe",
        please_sign: "Bitte unterschreiben Sie mit Ihrem Namen.",
        please_waiting: "Vielen Dank für die Übermittlung der KYC-Datei. \nUnser Team wird Ihre Informationen innerhalb von 48 Stunden prüfen. \nBitte haben Sie etwas Geduld und warten Sie auf die Auditergebnisse.",
        repay: "Jetzt zurückzahlen",
        repayment_check: "Rückzahlungsprüfung läuft",
        repayment_time: "Rückzahlungsdatum",
        resign: "Zurücktreten",
        reviewed_at: "Lass dir Zeit",
        select_day: "Bitte wählen Sie ein Datum aus",
        sex: "Geschlecht",
        sign: "Autogramm",
        start_loan: "Genießen Sie jetzt unsere Kreditdienstleistungen",
        to_repayment: "Machen Sie weiter und zahlen Sie zurück",
        total_profit: "Gesamtzins",
        transfer_address: "Adresse übertragen",
        upload_credit: "Anmeldeinformationen hochladen",
        verified: "Verifiziert",
        verify: "Verifizierung starten"
    },
    micro: {
        "24h_volume": "24-Stunden-Volumen",
        buy_down: "Kaufen Sie nach unten",
        buy_up: "Aufkaufen",
        calc_income: "Erwartetes Einkommen",
        calc_profit_rate: "Erwartete Rendite",
        close: "Schließen",
        close_time: "Geschlossene Zeit",
        closed_position: "Geschlossene Positionen",
        direction: "Richtung",
        high: "Hoch",
        in_transaction: "In Positionen",
        input_trade_num: "Bitte Menge eingeben",
        low: "Niedrig",
        open: "Offen",
        open_time: "Öffnungszeiten",
        predict_profit: "Erwarten Sie Gewinn",
        profit: "Profitieren",
        profit_rate: "Gewinnrate",
        select_trade_time: "Wählen Sie das Ablaufdatum",
        statistics: "Statistiken",
        trade_num: "Menge",
        trade_time: "Dauer",
        trading_pairs: "Handelspaare"
    },
    mining: {
        better1: "Ein- und Auszahlung jederzeit möglich",
        better2: "Wird täglich herausgegeben",
        better3: "Bergbauzyklus",
        better4: "Airdrop jederzeit",
        coin_type: "Währung",
        day_profit: "Nissan erwartet",
        doing: "im Gange",
        expected_profit: "Nissan erwartet",
        finished: "über",
        input_lock_num: "Bitte geben Sie den Sperrbetrag ein",
        interest: "Interesse",
        machine_list: "Liste der Bergbaumaschinen",
        machine_rent: "Vermietung von Bergbaumaschinen",
        max_subscribe: "Maximales Abonnement",
        mining: "Finanzmanagement",
        mining_time: "Bergbauzeit",
        my_subscribe: "Mein Abonnement",
        name: "Name",
        operate: "arbeiten",
        pay: "zahlen",
        pay_penal_sum_redemption: "Antrag auf vorzeitige Rückzahlung des pauschalierten Schadensersatzes",
        product_better: "Produktvorteile",
        product_content: "Beim Cloud-Mining wird USDT der Super-Computing-Power-Mining-Maschine der Plattform anvertraut, um die Gewinne im Mining-Pool der superintelligenten KI-Plattform abzubauen.",
        product_desc: "Produktbeschreibung",
        profit_list: "Leistungsliste",
        redemption: "Standardrückzahlung",
        refunded: "zurückerstattet",
        refunding: "Rückerstattung beantragen",
        subscribe: "Abonnement",
        subscribe_list: "Abonnementliste",
        subscribe_num: "Abonnementmenge",
        subscribe_time: "Abonnementzeit",
        sum_profit: "Geschätzter Gesamtumsatz",
        watch_profit_list: "Leistungsliste anzeigen"
    },
    transfer: {
        from: "Aus",
        history: "Übertragungsprotokoll",
        input_number: "Bitte geben Sie die Transfermenge ein",
        number: "Übertragen Sie die Menge",
        to: "Zu"
    }
}
obj.ru = {
    public: {
        name: "Имя",
        last_price: "Предыдущая цена",
        market: "Тенденции",
        quotation: "24H Изменить",
        no_data: "Пока нет данных.",
        no_more: "Больше нет",
        confirm: "Подтверждение",
        use: "Доступные",
        freeze: "Замораживание",
        number: "А",
        history: "Запись",
        other: "Кроме того",
        tip: "Стимулирование",
        copy_success: "Копировать успешно",
        upload_pic: "Загружается сертификат",
        submit: "Представлено",
        status: "Статус",
        set: "Настройка",
        chat: "Онлайновые услуги",
        copy: "Копирование",
        delete: "Исключить",
        confirm_del: "Вы уверены, что хотите удалить?",
        add: "Добавить",
        input_full: "Заполните, пожалуйста.",
        password_not_equal: "Пароль не совпадает.",
        coming_soon: "Скоро запустят",
        cancel: "Отменить",
        setting: "Справочная информация",
        product_list: "Список продуктов",
        submit_order: "Представление заказов",
        all: "Все",
        clear: "Прозрачный",
        close: "Закрытие",
        invite_tip: "Отсканируйте образец QR-кода выше или введите код приглашения, чтобы подтвердить регистрацию.",
        my_assets: "Мои активы",
        please_input: "Пожалуйста, введите",
        record: "Записывать",
        test: "Просто для тестирования",
        today: "Сегодня",
        total_assets: "Общая конверсия активов аккаунта"
    },
    user: {
        h_second: "секунда",
        h_timer: "обратный отсчет",
        h_accept: "Принять",
        h_welc: "Добро пожаловать в использование",
        announ_text: "По политическим причинам услуги не предоставляются Северной Корее, Израилю, Китаю, Вануату и Кубе.",
        announ: "объявление",
        com_email: "Жалоба по электронной почте",
        dh: "телефон",
        qh: "код города",
        qh_dh: "код города/телефон",
        user_center: "Минералы",
        login_email: "Введите свою электронную почту",
        login_phone: "Мобильный вход",
        input_email: "Введите адрес электронной почты",
        input_phone: "Пожалуйста, введите номер вашего мобильного.",
        password: "Язык",
        new_paw: "Новый пароль",
        input_password: "Введите пароль.",
        re_input_pass: "Введите пароль",
        input_old_password: "Введите свой старый пароль.",
        new_user: "Новые пользователи?",
        join_us: "Присоединяйтесь немедленно.",
        forgot_password: "Забыть пароль",
        login: "Регистрация",
        area_code: "Региональный код",
        register: "Регистрация",
        register_email: "Введите свою электронную почту",
        register_phone: "Регистрация мобильного телефона",
        can_use_asset: "Имеющиеся активы",
        logout: "Списание",
        confirm_logout: "Выход из регистрации",
        logout_success: "Успешный выход",
        mock_login: "Не нужно открывать счет, создайте аналоговый счет для торговли!",
        account_detail: "Сведения об учетной записи",
        mock_account: "Имитационный счет",
        invite_code: "Код приглашения",
        input_invite_code: "Введите код приглашения.",
        copy_invite_link: "Копировать ссылку приглашения",
        trade_account: "Счета операций",
        only_true_account: "Пожалуйста, зарегистрируйтесь или войдите в реальный жесткий аккаунт.",
        reset_mock_account: "Вернуться к учётной записи моделирования",
        confirm_reset: "Возврат товара",
        email: "Почтовый ящик",
        welcome_login: "Добро пожаловать в систему",
        welcome_register: "Добро пожаловать на регистрацию",
        useful_balance: "Имеющиеся средства",
        please_login: "Пожалуйста, войдите"
    },
    forgot: {
        sms_code: "Код проверки",
        input_sms_code: "Введите код проверки.",
        send: "Почта",
        reset: "Сбросить пароль"
    },
    trade: {
        buy: "Покупка",
        sell: "Продажа",
        last_price: "Рыночные цены",
        best_price: "Торговля по лучшей текущей цене",
        buy_price: "Цены",
        enter_price: "Пожалуйста, введите цену.",
        trade_amount: "Размер транзакции",
        balance: "Равновесие",
        buy_up: "Больше.",
        buy_low: "Короткое замыкание",
        current_entrust: "Предварительная отладка",
        type: "Тип",
        time: "Дата",
        price: "Цены",
        trade_price: "Сумма сделки",
        operate: "Деятельность",
        close_order: "Закрыть позицию",
        high: "Высокий",
        open: "Открыть",
        low: "Низкий",
        volume: "Общий объем",
        order: "Заказы",
        closed: "Закрыть",
        order_confirm: "Ваш заказ подтвержден.",
        order_page: "Страница заказа",
        no_mult: "Нет кратного",
        no_mult_config: "Не настроен рычаг, временно невозможно сделать заказ"
    },
    order: {
        current_price: "Текущая цена",
        total_ol: "Общая сумма прибылей и убытков",
        holding: "Хранить склад",
        market_price: "Рыночные цены",
        un_deal_order: "Необработанные заказы",
        history: "История",
        hand_num: "Лотс",
        stop_loss: "Установленные потери",
        stop_profit: "Установить прибыль",
        times: "Множитель",
        handle_fee: "Плата за услуги",
        bond_fee: "Границы",
        balance: "Равновесие",
        buy_in: "Покупка",
        sell_out: "Продажа",
        trading: "Местоположение",
        dealing: "Необработанные заказы",
        profit: "Убытки и убытки",
        total: "Чистая стоимость",
        pay_rate: "Доля авансов",
        can_use: "Возможен досрочный платеж",
        trade_amount: "Лотс",
        unit: "Каждый лист бумаги",
        page: "Простыни",
        hazard_rate: "Коэффициент риска",
        all_caution_money: "Текущий залог",
        detail: "Подробная информация о заказе",
        close: "Закрыть позицию",
        cancel: "Отменить заказ",
        calc_handle_fee: "Прогнозируемые расходы",
        calc_bond_fee: "Ожидаемая прибыль",
        set_stop_price: "Спасение",
        currency: "Дела обрабатываются правильно.",
        order_id: "Номер бронирования",
        order_type: "Направление",
        order_price: "Более низкая цена",
        close_price: "Складские цены недорого",
        income: "Прибыль",
        confrim_close_order: "Это дешевый склад?",
        open_time: "Время открытия"
    },
    func: {
        charge_coin: "Депозит",
        withdraw_coin: "Снятие",
        billing_detail: "Описание счета",
        real_auth: "Проверка подлинного имени",
        invite_friend: "Пригласить друзей",
        reset_password: "Изменить пароль",
        setting: "Учреждения",
        lang: "Язык",
        wallet: "Бумажник",
        buy_coin: "Купить монеты банковской картой",
        contract: "Договор",
        future: "Будущее",
        loan: "Заем",
        more: "Более",
        transfer: "Передача",
        video_desc: "Видео"
    },
    financial: {
        financial_records: "Финансовая отчетность",
        link_charge: "Зарядка в цепи.",
        bank_charge: "Телеграфные линии",
        charge_coin: "Монеты",
        wallet_address: "Адрес кошелька",
        copy_address: "Копировать адрес",
        charge_amount: "Количество монет",
        input_charge_amount: "Пожалуйста, введите количество монет",
        collect_coin_type: "Валюта поступлений",
        coin: "Цифровая валюта",
        bank: "Банковские карточки",
        select_network: "Выберите сеть",
        charge_num: "Сумма пополнения",
        input_charge_num: "Введите сумму пополнения.",
        charge_history: "Учет вкладов",
        uncheck: "Не выбрано",
        isfinish: "Завершено",
        isreject: "Отказано",
        unuseful: "Неверный"
    },
    bank: {
        swift_text: "Быстрый",
        coin_type: "Валюта поступлений",
        name: "Название банка",
        address: "Адрес банка",
        SWIFT: "Быстрый",
        username: "Получатель",
        account: "Счета получателей",
        remark: "Замечания"
    },
    auth: {
        upload_idcard: "Пожалуйста, загрузите спереди и сзади ваш паспорт / удостоверение личности",
        front: "Положительный",
        upload_front: "Загрузить ваш паспорт / сертификат спереди",
        back: "Обратная сторона",
        upload_back: "Загрузить обратную сторону вашего паспорта / сертификата",
        input_info: "Пожалуйста, заполните вашу личную информацию.",
        name: "Имя",
        input_name: "Введите ваше имя",
        id_number: "Номер паспорта / удостоверения личности",
        input_id_num: "Пожалуйста, введите номер вашего паспорта / удостоверения личности",
        waiting: "Ревизия",
        finish: "Подтверждение"
    },
    withdraw: {
        amount: "Количество",
        symbol: "Валюта",
        withdraw_coin: "Представление средств",
        no_pay_way: "Банковские счета не имеют платежных каналов.",
        calc_get: "Ожидается",
        record: "Монетные записи",
        send_amount: "Количество квитанций",
        withdraw_address: "Денежный адрес",
        unit: "Модуль",
        select_withdraw_address: "Выберите адрес для вызова."
    },
    wallet: {
        bind_bank_card: "Привязка банковских карт",
        bind_coin_address: "Адрес привязанной цифровой валюты",
        bind: "Сочетание",
        save: "Защита",
        not_bind: "Сначала откройте счет.",
        change_account: "Счет финансирования",
        forex_account: "Контрактный счет",
        micro_account: "Будущий счет"
    },
    follow: {
        apply_guide: "Инструкция по применению",
        auto_follow: "Каждый раз, когда торговый эксперт открывает позицию по продукту, я автоматически открываю позицию соответственно.",
        auto_open_positions: "Автоматическое открытие лотов",
        be_master: "Стать мастером",
        closed_follow_order: "Закрытая позиция после ордера",
        commission_rate: "ставка комиссии",
        copy_profit: "Прибыль от новых заказов",
        cover_time: "Время закрытия",
        follow: "следовать",
        follow_master: "Следуй за мастером",
        follow_now: "Следуйте сейчас",
        followed: "подписан",
        follower: "последователь",
        follower_num: "Количество подписчиков",
        follower_setting: "Настройки последующих действий",
        follower_sum: "Общее количество подписчиков",
        following_order: "Последующие заказы в обработке",
        history_order: "Исторические порядки",
        i_agree: "Я прочитал и согласен",
        lever: "несколько",
        limit_price: "ценовой предел",
        margin: "допуск",
        master_trader: "Мастер торговли",
        max_following: "максимальное количество подписчиков",
        my_follower: "мои подписчики",
        rate_of_return: "норма прибыли",
        size: "шкала",
        start_ordering_now: "Начните свой первый заказ прямо сейчас",
        submit_apply: "подать заявку",
        submit_multiple: "Заказать несколько",
        total_documentary_amount: "Общая сумма заказа",
        total_profit: "Общий доход",
        total_revenue: "Общий доход",
        unfollow: "Отписаться",
        view_follow_earnings: "Посмотреть следующий доход",
        will_pay_profit: "Доходы подлежат урегулированию",
        be_trader: "стать трейдером",
        cancel_follow_tip: "Открытые ордера больше не будут следовать за ордером закрытия, что может привести к упущению лучшей возможности закрытия. \nВы уверены, что хотите отменить?",
        confirm_cancel_follow: "Отменить следующий заказ",
        max_follow_bond: "Максимальная следующая маржа за заказ",
        trader_list: "Список трейдеров"
    },
    loan: {
        agreement: "Соглашение",
        amount: "Количество",
        auth_reject: "Отказ от аудита",
        auth_success: "Одобрено проверкой",
        auth_waiting: "Ожидается аудит",
        birthday: "Дата рождения:",
        confirm_repay: "Подтверждение погашения",
        confirm_repay_tip: "Пожалуйста, подтвердите информацию о погашении",
        confirm_repayment: "Подтвердить погашение",
        copy_address: "Копировать адрес",
        country: "Страна",
        day: "День",
        day_rate: "Ежедневная процентная ставка",
        female: "Женский",
        first_name: "Фамилия",
        free_day: "Беспроцентные дни",
        hand_pic: "Портативное фото для удостоверения личности",
        id_card: "ИДЕНТИФИКАТОР",
        identify_card: "Сертификаты",
        input_amount: "Пожалуйста, введите сумму",
        input_country: "Пожалуйста, укажите страну",
        input_first_name: "Пожалуйста, введите фамилию",
        input_last_name: "Пожалуйста, введите имя",
        input_mobile: "Пожалуйста, введите свой номер телефона",
        is_rejected: "Отклоненный",
        is_repay: "Отремонтировано",
        last_name: "Имя",
        loan: "Заем",
        loan_now: "Заимствование сейчас",
        loan_order: "Заказ кредита",
        loan_time: "Срок кредита",
        loaning: "Вы подаете заявку на кредит",
        male: "Мужской",
        max: "Максимум",
        mobile: "Номер телефона",
        need_repay: "Требуется погашение",
        passport: "Паспорт",
        penalty_amount: "Штраф за нарушение договора",
        please_sign: "Пожалуйста, подпишите свое имя.",
        please_waiting: "Благодарим вас за отправку файла KYC. \nНаша команда проверит вашу информацию в течение 48 часов. \nПожалуйста, наберитесь терпения и дождитесь результатов проверки.",
        repay: "Погасить сейчас",
        repayment_check: "Аудит погашения продолжается",
        repayment_time: "Дата погашения",
        resign: "Подать в отставку",
        reviewed_at: "Дайте время",
        select_day: "Пожалуйста, выберите дату",
        sex: "Пол",
        sign: "Автограф",
        start_loan: "Начните пользоваться нашими услугами кредитования",
        to_repayment: "Иди и погаси долг",
        total_profit: "Общий процент",
        transfer_address: "Адрес передачи",
        upload_credit: "Загрузить учетные данные",
        verified: "Проверено",
        verify: "Начать проверку"
    },
    micro: {
        "24h_volume": "24-часовой объем",
        buy_down: "Выкупить",
        buy_up: "Скупить",
        calc_income: "Ожидаемый доход",
        calc_profit_rate: "Ожидаемая доходность",
        close: "Закрывать",
        close_time: "Время закрытия",
        closed_position: "Закрытые позиции",
        direction: "Направление",
        high: "Высокий",
        in_transaction: "На позициях",
        input_trade_num: "Пожалуйста, введите количество",
        low: "Низкий",
        open: "Открыть",
        open_time: "Открытое время",
        predict_profit: "Ожидайте прибыль",
        profit: "Выгода",
        profit_rate: "Ставка прибыли",
        select_trade_time: "Выберите дату истечения срока действия",
        statistics: "Статистика",
        trade_num: "Количество",
        trade_time: "Продолжительность",
        trading_pairs: "Торговые пары"
    },
    mining: {
        better1: "Ввод и вывод средств в любое время",
        better2: "Выходит ежедневно",
        better3: "Цикл майнинга",
        better4: "Аирдроп в любое время",
        coin_type: "Валюта",
        day_profit: "Ожидаемый Ниссан",
        doing: "в ходе выполнения",
        expected_profit: "Ожидаемый Ниссан",
        finished: "над",
        input_lock_num: "Пожалуйста, введите сумму блокировки",
        interest: "Интерес",
        machine_list: "Список горных машин",
        machine_rent: "Аренда горных машин",
        max_subscribe: "Максимальная подписка",
        mining: "Финансовый менеджмент",
        mining_time: "Период майнинга",
        my_subscribe: "Моя подписка",
        name: "имя",
        operate: "действовать",
        pay: "платить",
        pay_penal_sum_redemption: "Заявление о досрочном погашении заранее оцененных убытков",
        product_better: "Преимущества продукта",
        product_content: "Облачный майнинг заключается в использовании USDT, который будет передан супервычислительной машине платформы для добычи прибыли в пуле майнинга сверхинтеллектуальной платформы AI.",
        product_desc: "Описание продукта",
        profit_list: "Список преимуществ",
        redemption: "погашение по умолчанию",
        refunded: "возвращен",
        refunding: "Подача заявления на возврат средств",
        subscribe: "Подписка",
        subscribe_list: "Список подписки",
        subscribe_num: "Количество подписки",
        subscribe_time: "Время подписки",
        sum_profit: "Предполагаемый общий доход",
        watch_profit_list: "Посмотреть список преимуществ"
    },
    transfer: {
        from: "От",
        history: "Запись о переводе",
        input_number: "Пожалуйста, введите сумму перевода",
        to: "К",
        number: "Сумма перевода"
    }
}
obj.esp = {
    public: {
        name: "Nombre",
        last_price: "El último precio",
        market: "Tendencias",
        quotation: "Cambio 24h",
        no_data: "Aún no hay datos",
        no_more: "Ya no",
        confirm: "Confirmación",
        use: "Disponible",
        freeze: "Congelación",
        number: "Cantidad",
        history: "Registro",
        other: "Además",
        tip: "Promover",
        copy_success: "Copia exitosa",
        upload_pic: "Se está cargando el certificado",
        submit: "Presentación",
        status: "Estatus",
        set: "Configuración",
        chat: "Servicios en línea",
        copy: "Copiar",
        delete: "Eliminar",
        confirm_del: "¿Estás seguro de que quieres eliminarlo?",
        add: "Añadir",
        input_full: "Por favor, rellene",
        password_not_equal: "Contraseña inconsistente",
        coming_soon: "Está a punto de lanzarse.",
        cancel: "Cancelación",
        setting: "Antecedentes",
        product_list: "Lista de productos",
        submit_order: "Presentación de pedidos",
        all: "Todo",
        clear: "Claro",
        close: "Cierre",
        invite_tip: "Escanee el patrón del código QR de arriba o ingrese el código de invitación para confirmar el registro.",
        my_assets: "Mis activos",
        please_input: "Por favor ingresa",
        record: "Registro",
        test: "solo para probar",
        today: "Hoy",
        total_assets: "Conversión total de activos de la cuenta"
    },
    user: {
        h_second: "segundo",
        h_timer: "cuenta regresiva",
        h_accept: "Aceptar",
        h_welc: "Bienvenido a usar",
        announ_text: "Por razones de política, no se brindan servicios a Corea del Norte, Israel, China, Vanuatu y Cuba.",
        announ: "anuncio",
        com_email: "Correo electrónico de queja",
        dh: "teléfono",
        qh: "código de área",
        qh_dh: "código de área/teléfono",
        user_center: "Mineral",
        login_email: "Introduzca su correo electrónico",
        login_phone: "Inicio de sesión del teléfono móvil",
        input_email: "Introduzca su dirección de correo electrónico",
        input_phone: "Introduzca su número de teléfono móvil",
        password: "Palabras clave",
        new_paw: "Nueva contraseña",
        input_password: "Introduzca su contraseña",
        re_input_pass: "Volver a escribir la contraseña",
        input_old_password: "Introduzca su antigua contraseña",
        new_user: "¿Nuevos usuarios?",
        join_us: "Únete de inmediato",
        forgot_password: "Olvida la contraseña",
        login: "Iniciar sesión",
        area_code: "Código de área",
        register: "Registro",
        register_email: "Introduzca su correo electrónico",
        register_phone: "Registro de teléfonos móviles",
        can_use_asset: "Activos disponibles",
        logout: "Cancelación",
        confirm_logout: "Si se retira del registro",
        logout_success: "Salida exitosa",
        mock_login: "¡¡ no es necesario abrir una cuenta para crear una cuenta simulada para realizar transacciones!",
        account_detail: "Detalles de la cuenta",
        mock_account: "Cuenta simulada",
        invite_code: "Código de invitación",
        input_invite_code: "Por favor, introduzca el Código de invitación.",
        copy_invite_link: "Copiar enlace de invitación",
        trade_account: "Cuenta de transacción",
        only_true_account: "Por favor, registre o inicie sesión en una cuenta dura real",
        reset_mock_account: "Volver a la cuenta simulada",
        confirm_reset: "Si devolver o no",
        email: "Buzón postal",
        welcome_login: "Bienvenido a iniciar sesión",
        welcome_register: "Bienvenido a registrarse",
        useful_balance: "Fondos disponibles",
        please_login: "Por favor, inicie sesión"
    },
    forgot: {
        sms_code: "Código de verificación",
        input_sms_code: "Por favor, introduzca el Código de verificación",
        send: "Correo",
        reset: "Restablecer la contraseña"
    },
    trade: {
        buy: "Compra",
        sell: "Vender",
        last_price: "Precio de mercado",
        best_price: "Negociar al mejor precio actual",
        buy_price: "Precio",
        enter_price: "Por favor, introduzca el precio",
        trade_amount: "Tamaño del lote de transacciones",
        balance: "Equilibrio",
        buy_up: "Hacer más",
        buy_low: "Cortocircuito",
        current_entrust: "Preprocesamiento",
        type: "Tipo",
        time: "Fecha",
        price: "Precio",
        trade_price: "Importe de la transacción",
        operate: "Actividades",
        close_order: "Posición de cierre",
        high: "Alto",
        open: "Abrir",
        low: "Bajo",
        volume: "Volumen total",
        order: "Pedidos",
        closed: "Cierre",
        order_confirm: "Su pedido ha sido confirmado",
        order_page: "Página de pedidos",
        no_mult: "No hay múltiplos",
        no_mult_config: "No se ha configurado el apalancamiento y no se puede hacer un pedido por el momento."
    },
    order: {
        current_price: "Precios actuales",
        total_ol: "Ganancias y pérdidas totales",
        holding: "Posiciones",
        market_price: "Precio de mercado",
        un_deal_order: "Pedidos pendientes",
        history: "Historia",
        hand_num: "Lotz",
        stop_loss: "Establecer pérdidas",
        stop_profit: "Establecer beneficios",
        times: "Multiplicador",
        handle_fee: "Comisiones",
        bond_fee: "Borde",
        balance: "Equilibrio",
        buy_in: "Compra",
        sell_out: "Vender",
        trading: "Posición",
        dealing: "Pedidos pendientes",
        profit: "Ganancias y pérdidas",
        total: "Valor neto",
        pay_rate: "Tasa de anticipos",
        can_use: "Se puede reembolsar por adelantado",
        trade_amount: "Lotz",
        unit: "Cada hoja de papel",
        page: "Sábanas",
        hazard_rate: "Tasa de riesgo",
        all_caution_money: "Margen actual",
        detail: "Detalles del pedido",
        close: "Posición de cierre",
        cancel: "Cancelación del pedido",
        calc_handle_fee: "Comisiones previstas",
        calc_bond_fee: "Beneficios previstos",
        set_stop_price: "Salvar",
        currency: "Transacciones",
        order_id: "Número de reserva",
        order_type: "Dirección",
        order_price: "Precio unitario más bajo",
        close_price: "El precio del almacén es barato",
        income: "Ganancias",
        confrim_close_order: "¿¿ es un almacén barato?",
        open_time: "Horario de apertura"
    },
    func: {
        charge_coin: "Depósito",
        withdraw_coin: "Retirada",
        billing_detail: "Detalles de la factura",
        real_auth: "Verificación del sistema de nombre real",
        invite_friend: "Invitar a amigos",
        reset_password: "Modificar la contraseña",
        setting: "Instituciones",
        lang: "Idiomas",
        wallet: "Billetera",
        buy_coin: "Comprar monedas con tarjeta bancaria",
        contract: "Contrato",
        future: "Futuro",
        loan: "Préstamo",
        more: "Más",
        transfer: "Transferir",
        video_desc: "Video"
    },
    financial: {
        financial_records: "Registros financieros",
        link_charge: "Cargar en la cadena",
        bank_charge: "Línea telegráfica",
        charge_coin: "Monedas",
        wallet_address: "Dirección de la billetera",
        copy_address: "Copiar dirección",
        charge_amount: "Número de monedas",
        input_charge_amount: "Introduzca el número de monedas a recargar",
        collect_coin_type: "Moneda de cobro",
        coin: "Moneda digital",
        bank: "Tarjeta bancaria",
        select_network: "Selección de redes",
        charge_num: "Cantidad recargada",
        input_charge_num: "Introduzca el monto de recarga",
        charge_history: "Registro de depósitos",
        uncheck: "No seleccionado",
        isfinish: "Completado",
        isreject: "Rechazada",
        unuseful: "Inválido"
    },
    bank: {
        swift_text: "Rápido",
        coin_type: "Moneda de cobro",
        name: "Nombre del Banco",
        address: "Dirección bancaria",
        SWIFT: "Rápido",
        username: "Beneficiario",
        account: "Cuenta del beneficiario",
        remark: "Comentarios"
    },
    auth: {
        upload_idcard: "Por favor, suba la parte delantera y trasera de su pasaporte / tarjeta de identificación.",
        front: "Frontal",
        upload_front: "Suba la parte delantera de su pasaporte / certificado",
        back: "Reverso",
        upload_back: "Suba el reverso de su pasaporte / certificado",
        input_info: "Por favor, rellene su información personal.",
        name: "Nombre",
        input_name: "Introduzca su nombre",
        id_number: "Número de pasaporte / DNI",
        input_id_num: "Introduzca su pasaporte / número de identificación",
        waiting: "Auditoría",
        finish: "Confirmado"
    },
    withdraw: {
        amount: "Cantidad",
        symbol: "Moneda",
        withdraw_coin: "Presentación de retiros",
        no_pay_way: "La cuenta en moneda francesa no tiene canales de pago.",
        calc_get: "Se espera",
        record: "Registro de retiro de moneda",
        send_amount: "Número de recibos",
        withdraw_address: "Dirección de recogida de moneda",
        unit: "Unidad",
        select_withdraw_address: "Por favor, elija la dirección a llamar"
    },
    wallet: {
        bind_bank_card: "Tarjeta bancaria vinculada",
        bind_coin_address: "Dirección de moneda digital vinculada",
        bind: "Combinar",
        save: "Protección",
        not_bind: "Por favor, establezca primero la cuenta de cobro",
        change_account: "Cuenta de fondos",
        forex_account: "cuenta de contrato",
        micro_account: "cuenta futura"
    },
    follow: {
        apply_guide: "Instrucciones de aplicación",
        auto_follow: "Cada vez que un experto en trading abre una posición sobre un producto, yo abriré automáticamente la posición en consecuencia.",
        auto_open_positions: "Apertura automática de lotes",
        be_master: "Conviértete en un maestro",
        closed_follow_order: "Posición cerrada siguiendo orden",
        commission_rate: "porcentaje de comision",
        copy_profit: "Beneficio de nuevos pedidos",
        cover_time: "hora de cierre",
        follow: "seguir",
        follow_master: "sigue al maestro",
        follow_now: "Siga ahora",
        followed: "seguido",
        follower: "seguidor",
        follower_num: "Número de seguidores",
        follower_setting: "Configuración de seguimiento",
        follower_sum: "Número total de seguidores",
        following_order: "Seguimiento de pedidos en curso",
        history_order: "Órdenes históricas",
        i_agree: "He leído y estoy de acuerdo",
        lever: "múltiple",
        limit_price: "límite de precio",
        margin: "margen",
        master_trader: "Maestro comercial",
        max_following: "seguimiento máximo",
        my_follower: "mis seguidores",
        rate_of_return: "tasa de retorno",
        size: "escala",
        start_ordering_now: "Comience su primer pedido ahora",
        submit_apply: "presentar la solicitud",
        submit_multiple: "Orden múltiple",
        total_documentary_amount: "Monto total del pedido",
        total_profit: "Los ingresos totales",
        total_revenue: "Los ingresos totales",
        unfollow: "Dejar de seguir",
        view_follow_earnings: "Ver los siguientes ingresos",
        will_pay_profit: "Ingresos por liquidar",
        be_trader: "convertirse en un comerciante",
        cancel_follow_tip: "Las órdenes abiertas ya no seguirán la orden de cierre, lo que puede resultar en perder la mejor oportunidad de cierre. \n¿Estás seguro de que quieres cancelar?",
        confirm_cancel_follow: "Cancelar el siguiente pedido",
        max_follow_bond: "Margen de seguimiento máximo por pedido",
        trader_list: "Lista de comerciantes"
    },
    loan: {
        agreement: "Acuerdo",
        amount: "Cantidad",
        auth_reject: "Rechazo de auditoría",
        auth_success: "Aprobado por revisión",
        auth_waiting: "Auditoría pendiente",
        birthday: "Fecha de nacimiento:",
        confirm_repay: "Confirmación de pago",
        confirm_repay_tip: "Por favor confirme su información de pago",
        confirm_repayment: "Confirmar pago",
        copy_address: "Copiar dirección",
        country: "País",
        day: "Día",
        day_rate: "Tasa de interés diaria",
        female: "Femenino",
        first_name: "Apellido",
        free_day: "Días sin intereses",
        hand_pic: "Foto de identificación portátil",
        id_card: "IDENTIFICACIÓN",
        identify_card: "Certificados",
        input_amount: "Por favor ingrese la cantidad",
        input_country: "Por favor ingresa el país",
        input_first_name: "Por favor ingresa el apellido",
        input_last_name: "Por favor ingresa un nombre",
        input_mobile: "Por favor ingresa tu número de teléfono",
        is_rejected: "Rechazado",
        is_repay: "reparado",
        last_name: "Nombre",
        loan: "Préstamo",
        loan_now: "Pedir prestado ahora",
        loan_order: "orden de préstamo",
        loan_time: "Plazo del préstamo",
        loaning: "Estás solicitando un préstamo",
        male: "Masculino",
        max: "Máximo",
        mobile: "Número de teléfono",
        need_repay: "Reembolso requerido",
        passport: "Pasaporte",
        penalty_amount: "Sanción por incumplimiento de contrato",
        please_sign: "Por favor firme su nombre.",
        please_waiting: "Gracias por enviar el archivo KYC. \nNuestro equipo auditará su información dentro de las 48 horas. \nTenga paciencia y espere los resultados de la auditoría.",
        repay: "Paga ahora",
        repayment_check: "Auditoría de reembolso en curso",
        repayment_time: "fecha de amortización",
        resign: "Renunciar",
        reviewed_at: "dar tiempo",
        select_day: "Por favor seleccione una fecha",
        sex: "Género",
        sign: "Autógrafo",
        start_loan: "Comience a disfrutar de nuestros servicios de préstamos",
        to_repayment: "Adelante y paga",
        total_profit: "Interés total",
        transfer_address: "Dirección de transferencia",
        upload_credit: "Subir credenciales",
        verified: "Verificado",
        verify: "Iniciar verificación"
    },
    micro: {
        "24h_volume": "Volumen 24H",
        buy_down: "Comprar abajo",
        buy_up: "Comprar",
        calc_income: "Ingresos esperados",
        calc_profit_rate: "Tasa de rendimiento esperada",
        close: "Cerca",
        close_time: "hora cerrada",
        closed_position: "Posiciones cerradas",
        direction: "Dirección",
        high: "Alto",
        in_transaction: "en posiciones",
        input_trade_num: "Por favor ingrese la cantidad",
        low: "Bajo",
        open: "Abierto",
        open_time: "tiempo abierto",
        predict_profit: "esperar ganancias",
        profit: "Ganancia",
        profit_rate: "Tasa de beneficio",
        select_trade_time: "Seleccionar fecha de vencimiento",
        statistics: "Estadística",
        trade_num: "Cantidad",
        trade_time: "Duración",
        trading_pairs: "Pares comerciales"
    },
    mining: {
        better1: "Deposita y retira en cualquier momento",
        better2: "Emitido diariamente",
        better3: "ciclo minero",
        better4: "Lanzamiento aéreo en cualquier momento",
        coin_type: "Divisa",
        day_profit: "Nissan esperado",
        doing: "en curso",
        expected_profit: "Nissan esperado",
        finished: "encima",
        input_lock_num: "Por favor ingresa el monto del bloqueo",
        interest: "Interés",
        machine_list: "Lista de máquinas mineras",
        max_subscribe: "Suscripción máxima",
        mining: "Gestión financiera",
        mining_time: "Periodo minero",
        my_subscribe: "mi suscripción",
        name: "nombre",
        operate: "funcionar",
        pay: "pagar",
        pay_penal_sum_redemption: "Solicitud de reembolso anticipado de indemnización por daños y perjuicios",
        product_better: "Ventajas del producto",
        product_content: "La minería en la nube consiste en utilizar USDT para confiarlo a la máquina de minería de potencia de supercomputación de la plataforma para extraer las ganancias en el grupo de minería de la plataforma superinteligente de IA.",
        product_desc: "Descripción del Producto",
        profit_list: "Lista de beneficios",
        redemption: "canje predeterminado",
        refunded: "reintegrado",
        refunding: "Solicitar reembolso",
        subscribe: "Suscripción",
        subscribe_list: "Lista de suscripciones",
        subscribe_num: "Cantidad de suscripción",
        subscribe_time: "tiempo de suscripción",
        sum_profit: "Ingresos totales estimados",
        watch_profit_list: "Ver lista de beneficios",
        machine_rent: "Alquiler de maquinas mineras"
    },
    transfer: {
        history: "Registro de transferencia",
        input_number: "Por favor ingrese la cantidad de transferencia",
        number: "Cantidad de transferencia",
        to: "A",
        from: "De"
    }
}
obj.po = {
    public: {
        name: "Nome",
        last_price: "Último Preço",
        market: "Tendência",
        quotation: "Alteração 24H",
        no_data: "Ainda não existem dados",
        no_more: "Não mais",
        confirm: "confirmação",
        use: "Disponível",
        freeze: "Congelar",
        number: "Quantidade",
        history: "Gravar",
        other: "Outros",
        tip: "Pedir",
        copy_success: "Copiado com sucesso",
        upload_pic: "Carregar o Certificado",
        submit: "Enviar",
        status: "Estado",
        set: "Definir",
        chat: "Serviço Online",
        copy: "Copiar",
        delete: "apagar",
        confirm_del: "Tem a certeza de apagar?",
        add: "Adicionar",
        input_full: "Complete por favor",
        password_not_equal: "Inconferência da senha",
        coming_soon: "Em breve ~",
        cancel: "Cancelar",
        setting: "Configuração",
        product_list: "Lista de Produtos",
        submit_order: "Enviar Ordem",
        all: "Todos",
        clear: "Claro",
        close: "Encerramento",
        invite_tip: "Digitalize o padrão do código QR acima ou insira o código de convite para confirmar o registro.",
        my_assets: "Meus ativos",
        please_input: "Por favor insira",
        record: "Registro",
        test: "Só para testar",
        today: "Hoje",
        total_assets: "Conversão total de ativos da conta"
    },
    user: {
        h_second: "segundo",
        h_timer: "contagem regressiva",
        h_accept: "Aceitar",
        h_welc: "Bem-vindo ao uso",
        announ_text: "Devido a razões políticas, os serviços não são fornecidos para a Coreia do Norte, Israel, China, Vanuatu e Cuba.",
        announ: "anúncio",
        com_email: "E-mail de reclamação",
        dh: "telefone",
        qh: "código de área",
        qh_dh: "código de área/telefone",
        user_center: "Minha",
        login_email: "Indique o seu E- mail",
        login_phone: "Ligação Móvel",
        input_email: "Introduza o seu endereço de e-mail",
        input_phone: "Por favor, introduza o seu número de telemóvel",
        password: "Senha",
        new_paw: "Nova senha",
        input_password: "Por favor introduza a sua senha",
        re_input_pass: "Digite novamente a senha",
        input_old_password: "Por favor introduza a sua senha antiga",
        new_user: "Novo Utilizador?",
        join_us: "Junte-se Agora",
        forgot_password: "Esqueceu- se da senha",
        login: "Login",
        area_code: "Código da área",
        register: "Registar",
        register_email: "Indique o seu E- mail",
        register_phone: "Registo móvel",
        can_use_asset: "Activos disponíveis",
        logout: "Sair",
        confirm_logout: "Retirada do registo",
        logout_success: "Saída bem sucedida",
        mock_login: "Não há necessidade de abrir uma conta, crie uma conta demo para negociar agora!",
        account_detail: "Detalhes da Conta",
        mock_account: "Conta de Simulação",
        invite_code: "Código do Convite",
        input_invite_code: "Indique por favor o código do convite",
        copy_invite_link: "Copiar a Ligação de Convites",
        trade_account: "Conta de negociação",
        only_true_account: "Por favor, registre-se ou faça login em uma conta real",
        reset_mock_account: "Devolver a conta simulada",
        confirm_reset: "Se deve devolvê-lo",
        email: "Caixa Postal",
        welcome_login: "Bem- vindo ao login",
        welcome_register: "Bem-vindo ao registo",
        useful_balance: "Fundos disponíveis",
        please_login: "Por favor, faça login"
    },
    forgot: {
        sms_code: "Código de verificação",
        input_sms_code: "Introduza o código de verificação",
        send: "Enviar",
        reset: "Repor a Senha"
    },
    trade: {
        buy: "Comprar",
        sell: "Vender",
        last_price: "Preço de mercado",
        best_price: "Negociação ao melhor preço atual",
        buy_price: "Preço",
        enter_price: "Introduza o preço",
        trade_amount: "Dimensão do lote de negociação",
        balance: "Saldo",
        buy_up: "Vai longe",
        buy_low: "Encerramento",
        current_entrust: "Comissionamento prévio",
        type: "Tipo",
        time: "Data",
        price: "preço",
        trade_price: "Montante da transacção",
        operate: "Operação",
        close_order: "Fechar a posição",
        high: "Alto",
        open: "Abrir",
        low: "Baixo",
        volume: "Volume total",
        order: "Ordens",
        closed: "Fechado",
        order_confirm: "A sua encomenda foi confirmada.",
        order_page: "Página de Encomenda",
        no_mult: "Sem múltiplo",
        no_mult_config: "Nenhuma alavanca configurada, incapaz de fazer um pedido temporariamente"
    },
    order: {
        current_price: "Preço actual",
        total_ol: "Total dos resultados",
        holding: "Posição de posição",
        market_price: "Preço de mercado",
        un_deal_order: "Ordens pendentes",
        history: "História",
        hand_num: "Lotes",
        stop_loss: "Definir Perda",
        stop_profit: "Definir o Lucro",
        times: "Multiplicador",
        handle_fee: "Taxa de tratamento",
        bond_fee: "Margem",
        balance: "Saldo",
        buy_in: "Comprar",
        sell_out: "Vender",
        trading: "Posições",
        dealing: "Ordens pendentes",
        profit: "Lucros e perdas",
        total: "Valor líquido",
        pay_rate: "Taxa de pré-pagamento",
        can_use: "Pré-pagamento disponível",
        trade_amount: "Lotes",
        unit: "Cada folha",
        page: "Folha",
        hazard_rate: "Taxa de risco",
        all_caution_money: "Margem Corrente",
        detail: "Detalhes da encomenda",
        close: "Fechar a posição",
        cancel: "Cancelar encomenda",
        calc_handle_fee: "Taxa de manuseamento estimada",
        calc_bond_fee: "Margem estimada",
        set_stop_price: "Gravar",
        currency: "Pares de transacções",
        order_id: "Número da reserva",
        order_type: "direcção",
        order_price: "Preço unitário inferior",
        close_price: "Preço de armazém barato",
        income: "lucro",
        confrim_close_order: "É um armazém barato",
        open_time: "Horário aberto"
    },
    func: {
        charge_coin: "Depósito",
        withdraw_coin: "Retirada",
        billing_detail: "Detalhes da facturação",
        real_auth: "Verificação de Nome Real",
        invite_friend: "Convidar Amigos",
        reset_password: "Mudar a Senha",
        setting: "estabelecimento",
        lang: "Língua",
        wallet: "Carteira",
        buy_coin: "Compre moedas com cartão bancário",
        contract: "Contrato",
        future: "Futuro",
        loan: "Empréstimo",
        more: "Mais",
        transfer: "Transferir",
        video_desc: "Vídeo"
    },
    financial: {
        financial_records: "Registos Financeiros",
        link_charge: "Recarga na corrente",
        bank_charge: "Fio telégrafo",
        charge_coin: "Moedas",
        wallet_address: "Endereço da Carteira",
        copy_address: "Copiar o Endereço",
        charge_amount: "Número de moedas",
        input_charge_amount: "Introduza o número de moedas a cobrar",
        collect_coin_type: "Moeda do recibo",
        coin: "Moeda Digital",
        bank: "Cartão Bancário",
        select_network: "Seleccionar a Rede",
        charge_num: "Montante da recarga",
        input_charge_num: "Indique a quantidade de recarga",
        charge_history: "Registo de depósito",
        uncheck: "Desconhecido",
        isfinish: "Concluído",
        isreject: "Rejeitado",
        unuseful: "Inválido"
    },
    bank: {
        swift_text: "SWIFT",
        coin_type: "Moeda beneficiária",
        name: "Nome do Banco",
        address: "Endereço Bancário",
        SWIFT: "SWIFT",
        username: "Beneficiário",
        account: "Conta de beneficiário",
        remark: "Observação"
    },
    auth: {
        upload_idcard: "Por favor, carregue a frente e verso do seu passaporte / ID",
        front: "Frente",
        upload_front: "Carregue a frente do seu passaporte/certificado",
        back: "Lado inverso",
        upload_back: "Carregue o verso do seu passaporte/certificado",
        input_info: "Preencha as suas informações pessoais",
        name: "Nome",
        input_name: "Por favor indique o seu nome",
        id_number: "Passaporte/número de identificação",
        input_id_num: "Introduza o seu passaporte/número de identificação",
        waiting: "Auditoria",
        finish: "Certificado"
    },
    withdraw: {
        amount: "Montante",
        symbol: "Moeda",
        withdraw_coin: "Apresentar a retirada",
        no_pay_way: "Não há canal de pagamento para a conta em moeda francesa.",
        calc_get: "Espera-se que",
        record: "Registo de retirada de moedas",
        send_amount: "Número de receitas",
        withdraw_address: "Endereço para retirada de moedas",
        unit: "Unidade",
        select_withdraw_address: "Seleccione por favor um endereço para ligar"
    },
    wallet: {
        bind_bank_card: "Cartão bancário vinculativo",
        bind_coin_address: "Ligar o endereço da moeda digital",
        bind: "ligação",
        save: "preservação",
        not_bind: "Por favor, crie uma conta de cobrança primeiro",
        change_account: "Conta de financiamento",
        forex_account: "Conta de contrato",
        micro_account: "Conta futura"
    },
    follow: {
        apply_guide: "Instruções de aplicação",
        auto_follow: "Cada vez que um especialista em negociação abre uma posição em um produto, eu abrirei automaticamente a posição de acordo.",
        auto_open_positions: "Abertura automática de lotes",
        be_master: "Torne-se um mestre",
        closed_follow_order: "Posição fechada seguindo ordem",
        commission_rate: "taxa de comissão",
        copy_profit: "Lucre com novos pedidos",
        cover_time: "Horário de encerramento",
        follow: "seguir",
        follow_master: "Siga o mestre",
        follow_now: "Siga agora",
        followed: "seguido",
        follower: "seguidor",
        follower_num: "Número de seguidores",
        follower_setting: "Configurações de acompanhamento",
        follower_sum: "Número total de seguidores",
        following_order: "Pedidos de acompanhamento em andamento",
        history_order: "Ordens históricas",
        i_agree: "eu li e concordo",
        lever: "múltiplo",
        limit_price: "limite de preço",
        margin: "margem",
        master_trader: "Mestre de negociação",
        max_following: "acompanhamento máximo",
        my_follower: "meus seguidores",
        rate_of_return: "taxa de retorno",
        size: "escala",
        start_ordering_now: "Comece seu primeiro pedido agora",
        submit_apply: "enviar inscrição",
        submit_multiple: "Encomende vários",
        total_documentary_amount: "Valor total do pedido",
        total_profit: "Rendimento total",
        total_revenue: "Rendimento total",
        unfollow: "Deixar de seguir",
        view_follow_earnings: "Ver os seguintes rendimentos",
        will_pay_profit: "Receita a ser liquidada",
        be_trader: "torne-se um comerciante",
        cancel_follow_tip: "As ordens abertas não seguirão mais a ordem de fechamento, o que pode resultar na perda da melhor oportunidade de fechamento. \nTem certeza de que deseja cancelar?",
        confirm_cancel_follow: "Cancelar pedido seguinte",
        max_follow_bond: "Margem máxima de acompanhamento por pedido",
        trader_list: "Lista de comerciantes"
    },
    loan: {
        agreement: "Acordo",
        amount: "Quantia",
        auth_reject: "Rejeição de auditoria",
        auth_success: "Aprovado por revisão",
        auth_waiting: "Auditoria pendente",
        birthday: "Data de nascimento:",
        confirm_repay: "Confirmação de reembolso",
        confirm_repay_tip: "Por favor, confirme suas informações de reembolso",
        confirm_repayment: "Confirmar reembolso",
        copy_address: "Copiar endereço",
        country: "País",
        day: "Dia",
        day_rate: "Taxa de juros diária",
        female: "Fêmea",
        first_name: "Sobrenome",
        free_day: "Dias sem juros",
        hand_pic: "Foto de identificação portátil",
        id_card: "EU IA",
        identify_card: "Certificados",
        input_amount: "Por favor insira o valor",
        input_country: "Por favor insira o país",
        input_first_name: "Por favor insira o sobrenome",
        input_last_name: "Por favor insira um nome",
        input_mobile: "Por favor insira seu número de telefone",
        is_rejected: "Rejeitado",
        is_repay: "Reparado",
        last_name: "Nome",
        loan: "Empréstimo",
        loan_now: "Emprestando agora",
        loan_order: "Pedido de empréstimo",
        loan_time: "Prazo do empréstimo",
        loaning: "Você está solicitando um empréstimo",
        male: "Macho",
        max: "Máximo",
        mobile: "Número de telefone",
        need_repay: "Reembolso necessário",
        passport: "Passaporte",
        penalty_amount: "Pena por quebra de contrato",
        please_sign: "Por favor assine seu nome.",
        please_waiting: "Obrigado por enviar o arquivo KYC. \nNossa equipe auditará suas informações dentro de 48 horas. \nPor favor, seja paciente e aguarde os resultados da auditoria.",
        repay: "Reembolsar agora",
        repayment_check: "Auditoria de reembolso em andamento",
        repayment_time: "Data de reembolso",
        resign: "Reassinar",
        reviewed_at: "Dê tempo",
        select_day: "Selecione uma data",
        sex: "Gênero",
        sign: "Autógrafo",
        start_loan: "Comece a desfrutar de nossos serviços de empréstimo",
        to_repayment: "Vá em frente e pague",
        total_profit: "Juros totais",
        transfer_address: "Endereço de transferência",
        upload_credit: "Carregar credenciais",
        verified: "Verificado",
        verify: "Iniciar verificação"
    },
    micro: {
        "24h_volume": "Volume 24H",
        buy_down: "Compre para baixo",
        buy_up: "Compre",
        calc_income: "Renda esperada",
        calc_profit_rate: "Taxa de retorno esperada",
        close: "Fechar",
        close_time: "Horário fechado",
        closed_position: "Posições fechadas",
        direction: "Direção",
        high: "Alto",
        in_transaction: "Em posições",
        input_trade_num: "Por favor insira a quantidade",
        low: "Baixo",
        open: "Abrir",
        open_time: "Horário aberto",
        predict_profit: "Espere lucro",
        profit: "Lucro",
        profit_rate: "Taxa de lucro",
        select_trade_time: "Selecione a data de validade",
        statistics: "Estatísticas",
        trade_num: "Quantidade",
        trade_time: "Duração",
        trading_pairs: "Pares de negociação"
    },
    mining: {
        better1: "Deposite e retire a qualquer momento",
        better2: "Emitido diariamente",
        better3: "Ciclo de mineração",
        better4: "Airdrop a qualquer momento",
        coin_type: "Moeda",
        day_profit: "Esperado Nissan",
        doing: "em andamento",
        expected_profit: "Esperado Nissan",
        finished: "sobre",
        input_lock_num: "Insira o valor do bloqueio",
        interest: "Interesse",
        machine_list: "Lista de máquinas de mineração",
        machine_rent: "Aluguel de máquinas de mineração",
        max_subscribe: "Assinatura máxima",
        mining: "Gestão financeira",
        mining_time: "Período de mineração",
        my_subscribe: "Minha assinatura",
        name: "nome",
        operate: "operar",
        pay: "pagar",
        pay_penal_sum_redemption: "Pedido de resgate antecipado de danos liquidados",
        product_better: "Vantagens do produto",
        product_content: "A mineração em nuvem deve usar o USDT para ser confiado à máquina de mineração de poder de supercomputação da plataforma para extrair os lucros no pool de mineração da plataforma superinteligente de IA.",
        product_desc: "Descrição do produto",
        profit_list: "Lista de benefícios",
        redemption: "resgate padrão",
        refunded: "reembolsado",
        refunding: "Solicitando reembolso",
        subscribe: "Subscrição",
        subscribe_list: "Lista de assinaturas",
        subscribe_num: "Quantidade de assinaturas",
        subscribe_time: "Tempo de assinatura",
        sum_profit: "Receita total estimada",
        watch_profit_list: "Ver lista de benefícios"
    },
    transfer: {
        from: "De",
        history: "Registro de transferência",
        input_number: "Insira a quantidade de transferência",
        number: "Quantidade de transferência",
        to: "Para"
    }
}
obj.alb = {
    public: {
        name: "الإسم",
        last_price: "السعر الأخير",
        market: "الاتجاه",
        quotation: "تغيير",
        no_data: "لا توجد بيانات",
        no_more: "لم يعد",
        confirm: "تأكيد",
        use: "متاح",
        freeze: "تجمد",
        number: "كمية",
        history: "سجل",
        other: "بالإضافة إلى ذلك",
        tip: "حث",
        copy_success: "نسخة ناجحة",
        upload_pic: "تحميل الشهادة",
        submit: "قدم",
        status: "مركز",
        set: "ضبط",
        chat: "خدمات الانترنت",
        copy: "نسخ",
        delete: "حذف",
        confirm_del: "هل أنت متأكد أنك تريد حذف ؟",
        add: "إضافة .",
        input_full: "يرجى ملء",
        password_not_equal: "كلمة السر غير متناسقة",
        coming_soon: "قريبا",
        cancel: "ألغى",
        setting: "معلومات أساسية",
        product_list: "قائمة المنتجات",
        submit_order: "تقديم طلب",
        all: "الجميع",
        clear: "واضح",
        close: "إنهاء",
        invite_tip: "قم بمسح نمط رمز الاستجابة السريعة أعلاه أو أدخل رمز الدعوة لتأكيد التسجيل.",
        my_assets: "أصولي",
        please_input: "الرجاء الدخول",
        record: "سِجِلّ",
        test: "فقط للاختبار",
        today: "اليوم",
        total_assets: "إجمالي تحويل أصول الحساب"
    },
    user: {
        h_second: "الثانية",
        h_timer: "العد التنازلي",
        h_accept: "قبول",
        h_welc: "مرحبًا بك في الاستخدام",
        announ_text: "لأسباب تتعلق بالسياسة ، لا يتم تقديم الخدمات إلى كوريا الشمالية وإسرائيل والصين وفانواتو وكوبا.",
        announ: "إعلان",
        com_email: "صندوق بريد الشكوى",
        dh: "هاتف",
        qh: "رمز المنطقة",
        qh_dh: "رمز المنطقة / الهاتف",
        user_center: "ركاز",
        login_email: "أدخل البريد الإلكتروني الخاص بك",
        login_phone: "الهاتف المحمول تسجيل الدخول",
        input_email: "الرجاء إدخال عنوان البريد الإلكتروني الخاص بك",
        input_phone: "من فضلك أدخل رقم هاتفك",
        password: "كلمة السر",
        new_paw: "كلمة السر الجديدة",
        input_password: "الرجاء إدخال كلمة السر الخاصة بك",
        re_input_pass: "إعادة كتابة كلمة المرور",
        input_old_password: "الرجاء إدخال كلمة السر القديمة",
        new_user: "مستخدم جديد ؟",
        join_us: "الانضمام فورا",
        forgot_password: "نسيت كلمة السر",
        login: "سجل",
        area_code: "رمز المنطقة",
        register: "التسجيل",
        register_email: "أدخل البريد الإلكتروني الخاص بك",
        register_phone: "تسجيل الهاتف المحمول",
        can_use_asset: "الأصول المتاحة",
        logout: "شطب",
        confirm_logout: "خروج التسجيل",
        logout_success: "خروج ناجح",
        mock_login: "لا تحتاج إلى فتح حساب ، إنشاء حساب محاكاة يمكن إجراء المعاملات !",
        account_detail: "تفاصيل الحساب",
        mock_account: "حساب محاكاة",
        invite_code: "رمز الدعوة",
        input_invite_code: "الرجاء إدخال رمز الدعوة",
        copy_invite_link: "نسخ دعوة الرابط",
        trade_account: "حساب التداول",
        only_true_account: "الرجاء تسجيل الدخول أو تسجيل الدخول إلى الحساب الثابت الحقيقي",
        reset_mock_account: "العودة إلى حساب محاكاة",
        confirm_reset: "العودة",
        email: "صندوق بريد",
        welcome_login: "مرحبا بكم في تسجيل الدخول",
        welcome_register: "مرحبا بكم في التسجيل",
        useful_balance: "الأموال المتاحة",
        please_login: "الرجاء تسجيل الدخول"
    },
    forgot: {
        sms_code: "رمز التحقق",
        input_sms_code: "الرجاء إدخال رمز التحقق",
        send: "البريدية",
        reset: "إعادة تعيين كلمة المرور"
    },
    trade: {
        buy: "شراء",
        sell: "بيع .",
        last_price: "سعر السوق",
        best_price: "التجارة في أفضل الأسعار الحالية",
        buy_price: "الأسعار",
        enter_price: "من فضلك أدخل السعر",
        trade_amount: "حجم الصفقة",
        balance: "التوازن",
        buy_up: "القيام بالكثير",
        buy_low: "دائرة كهربائية قصيرة",
        current_entrust: "قبل التصحيح",
        type: "نوع .",
        time: "تواريخ",
        price: "الأسعار",
        trade_price: "مبلغ الصفقة",
        operate: "النشاطات",
        close_order: "موقف مغلقة",
        high: "عالية",
        open: "فتح .",
        low: "منخفض",
        volume: "مجموع حجم",
        order: "أمر",
        closed: "غلق",
        order_confirm: "تم تأكيد طلبك",
        order_page: "صفحة النظام",
        no_mult: "أي مضاعفات",
        no_mult_config: "لم يتم تكوين رافعة ، لا يمكن وضع النظام مؤقتا"
    },
    order: {
        current_price: "السعر الحالي",
        total_ol: "مجموع الربح والخسارة",
        holding: "موقف",
        market_price: "سعر السوق",
        un_deal_order: "من أجل تجهيز",
        history: "تاريخ",
        hand_num: "لوتز",
        stop_loss: "وضع الخسارة",
        stop_profit: "تحديد الربح",
        times: "مضاعف",
        handle_fee: "رسوم المناولة",
        bond_fee: "حافة",
        balance: "التوازن",
        buy_in: "شراء",
        sell_out: "بيع .",
        trading: "موقع",
        dealing: "من أجل تجهيز",
        profit: "الربح والخسارة",
        total: "صافي القيمة",
        pay_rate: "نسبة السلف",
        can_use: "السداد المبكر",
        trade_amount: "لوتز",
        unit: "كل ورقة",
        page: "ملاءات السرير",
        hazard_rate: "معدل المخاطرة",
        all_caution_money: "الهامش الحالي",
        detail: "تفاصيل النظام",
        close: "موقف مغلقة",
        cancel: "إلغاء النظام",
        calc_handle_fee: "الرسوم المقدرة",
        calc_bond_fee: "الربح المتوقع",
        set_stop_price: "أنقذ",
        currency: "معاملة الزوج",
        order_id: "رقم الحجز",
        order_type: "الاتجاه",
        order_price: "انخفاض سعر الوحدة",
        close_price: "مستودع رخيصة",
        income: "ربح",
        confrim_close_order: "هذا هو مستودع رخيصة",
        open_time: "ساعات العمل"
    },
    func: {
        charge_coin: "إيداع",
        withdraw_coin: "سحب",
        billing_detail: "تفاصيل الفواتير",
        real_auth: "التحقق من الاسم الحقيقي",
        invite_friend: "دعوة الأصدقاء",
        reset_password: "تعديل كلمة المرور",
        setting: "المؤسسات",
        lang: "لغة",
        wallet: "محفظة",
        buy_coin: "شراء العملات باستخدام البطاقة المصرفية",
        contract: "عقد",
        future: "مستقبل",
        loan: "يُقرض",
        more: "أكثر",
        transfer: "تحويل",
        video_desc: "فيديو"
    },
    financial: {
        financial_records: "السجلات المالية",
        link_charge: "شحن على سلسلة",
        bank_charge: "سلك التلغراف",
        charge_coin: "عملة معدنية",
        wallet_address: "عنوان المحفظة",
        copy_address: "نسخ العنوان",
        charge_amount: "عدد القطع النقدية",
        input_charge_amount: "من فضلك أدخل عدد القطع النقدية التي تريد شحن",
        collect_coin_type: "جمع العملة",
        coin: "العملة الرقمية",
        bank: "بطاقة مصرفية",
        select_network: "اختيار الشبكة",
        charge_num: "شحن المبلغ",
        input_charge_num: "من فضلك أدخل مبلغ الشحن",
        charge_history: "إيداع سجل",
        uncheck: "غير محدد",
        isfinish: "انتهى",
        isreject: "رفض",
        unuseful: "باطل"
    },
    bank: {
        swift_text: "سريع",
        coin_type: "جمع العملة",
        name: "اسم البنك",
        address: "عنوان البنك",
        SWIFT: "سريع",
        username: "المستفيد",
        account: "حساب المستفيد",
        remark: "تعليق ."
    },
    auth: {
        upload_idcard: "يرجى تحميل جواز سفرك / بطاقة الهوية إلى الأمام والخلف",
        front: "أمامي",
        upload_front: "تحميل جواز سفرك / الشهادة مباشرة",
        back: "عكس",
        upload_back: "تحميل جواز سفرك / الشهادة على الجانب الآخر",
        input_info: "يرجى ملء المعلومات الشخصية الخاصة بك",
        name: "الإسم",
        input_name: "من فضلك أدخل اسمك",
        id_number: "رقم الجواز / الهوية",
        input_id_num: "الرجاء إدخال رقم جواز السفر / الهوية",
        waiting: "مراجعة الحسابات",
        finish: "أكّد"
    },
    withdraw: {
        amount: "الكمية",
        symbol: "العملة",
        withdraw_coin: "تقديم سحب",
        no_pay_way: "لا توجد قنوات الدفع في حساب العملة الفرنسية .",
        calc_get: "توقع",
        record: "سجل العملة",
        send_amount: "استلام الكمية",
        withdraw_address: "عنوان العملة",
        unit: "وحدة",
        select_withdraw_address: "الرجاء اختيار العنوان الذي تريد الاتصال"
    },
    wallet: {
        bind_bank_card: "ربط بطاقة البنك",
        bind_coin_address: "ربط عنوان العملة الرقمية",
        bind: "ملزم",
        save: "حماية",
        not_bind: "يرجى إعداد حساب الدفع",
        change_account: "حساب التمويل",
        forex_account: "حساب العقد",
        micro_account: "حساب المستقبل"
    },
    follow: {
        apply_guide: "تعليمات التطبيق",
        auto_follow: "في كل مرة يفتح فيها خبير تداول مركزًا على منتج ما، سأفتح المركز تلقائيًا وفقًا لذلك.",
        auto_open_positions: "الفتح التلقائي للكميات",
        be_master: "تصبح على درجة الماجستير",
        closed_follow_order: "موقف مغلق بعد النظام",
        commission_rate: "نسبة العمولة",
        copy_profit: "الربح من الطلبات الجديدة",
        cover_time: "وقت الإغلاق",
        follow: "يتبع",
        follow_master: "اتبع السيد",
        follow_now: "اتبع الآن",
        followed: "يتبع",
        follower: "تابع",
        follower_num: "عدد المتابعين",
        follower_setting: "إعدادات المتابعة",
        follower_sum: "إجمالي عدد المتابعين",
        following_order: "أوامر المتابعة قيد التنفيذ",
        history_order: "أوامر تاريخية",
        i_agree: "لقد قرأت وأوافق",
        lever: "عديد",
        limit_price: "حد السعر",
        margin: "هامِش",
        master_trader: "سيد التداول",
        max_following: "الحد الأقصى للمتابعة",
        my_follower: "أتباعي",
        rate_of_return: "معدل العائد",
        size: "حجم",
        start_ordering_now: "ابدأ طلبك الأول الآن",
        submit_apply: "قدم الطلب",
        submit_multiple: "طلب متعددة",
        total_documentary_amount: "إجمالي مبلغ الطلب",
        total_profit: "إجمالي الإيرادات",
        total_revenue: "إجمالي الإيرادات",
        unfollow: "الغاء المتابعة",
        view_follow_earnings: "عرض الدخل التالي",
        will_pay_profit: "عائدات ليتم تسويتها",
        be_trader: "تصبح تاجرا",
        cancel_follow_tip: "لن تتبع الأوامر المفتوحة بعد الآن أمر الإغلاق، مما قد يؤدي إلى ضياع أفضل فرصة إغلاق. \nهل أنت متأكد أنك تريد الإلغاء؟",
        confirm_cancel_follow: "إلغاء الطلب التالي",
        max_follow_bond: "الحد الأقصى للهامش التالي لكل أمر",
        trader_list: "قائمة التاجر"
    },
    loan: {
        identify_card: "الشهادات",
        input_amount: "الرجاء إدخال المبلغ",
        input_country: "الرجاء إدخال البلاد",
        input_first_name: "الرجاء إدخال الاسم الأخير",
        input_last_name: "الرجاء إدخال اسم",
        input_mobile: "الرجاء إدخال رقم هاتفك",
        is_rejected: "مرفوض",
        is_repay: "تم إصلاحه",
        last_name: "اسم",
        loan: "يُقرض",
        loan_now: "الاقتراض الآن",
        loan_order: "أمر القرض",
        loan_time: "مدة القرض",
        loaning: "أنت تتقدم بطلب للحصول على قرض",
        male: "ذكر",
        max: "الحد الأقصى",
        mobile: "رقم التليفون",
        need_repay: "السداد مطلوب",
        passport: "جواز سفر",
        penalty_amount: "عقوبة الإخلال بالعقد",
        please_sign: "الرجاء التوقيع باسمك.",
        please_waiting: "شكرًا لك على تقديم ملف KYC. \nسيقوم فريقنا بمراجعة معلوماتك خلال 48 ساعة. \nيرجى التحلي بالصبر وانتظار نتائج التدقيق.",
        repay: "سداد الآن",
        repayment_check: "جاري تدقيق السداد",
        repayment_time: "تاريخ السداد",
        resign: "إعادة التوقيع",
        reviewed_at: "السماح بالوقت",
        select_day: "الرجاء تحديد تاريخ",
        sex: "جنس",
        sign: "توقيعه",
        start_loan: "ابدأ بالاستمتاع بخدمات الإقراض لدينا",
        to_repayment: "المضي قدما وسداد",
        total_profit: "إجمالي الفائدة",
        transfer_address: "عنوان النقل",
        upload_credit: "تحميل بيانات الاعتماد",
        verified: "تم التحقق منه",
        verify: "ابدأ عملية التحقق",
        agreement: "اتفاق",
        amount: "كمية",
        auth_reject: "رفض التدقيق",
        auth_success: "تمت الموافقة عليها عن طريق المراجعة",
        auth_waiting: "في انتظار التدقيق",
        birthday: "تاريخ الميلاد:",
        confirm_repay: "تأكيد السداد",
        confirm_repay_tip: "يرجى تأكيد معلومات السداد الخاصة بك",
        confirm_repayment: "تأكيد السداد",
        copy_address: "انسخ العنوان",
        country: "دولة",
        day: "يوم",
        day_rate: "سعر الفائدة اليومي",
        female: "أنثى",
        first_name: "اسم العائلة",
        free_day: "أيام بدون فوائد",
        hand_pic: "صورة الهوية المحمولة",
        id_card: "بطاقة تعريف"
    },
    micro: {
        "24h_volume": "حجم 24 ساعة",
        buy_down: "شراء أسفل",
        buy_up: "شراء ما يصل",
        calc_income: "الدخل المتوقع",
        calc_profit_rate: "معدل العائد المتوقع",
        close: "يغلق",
        close_time: "وقت مغلق",
        closed_position: "المواقف المغلقة",
        direction: "اتجاه",
        high: "عالي",
        in_transaction: "في المواقف",
        input_trade_num: "الرجاء إدخال الكمية",
        low: "قليل",
        open: "يفتح",
        open_time: "وقت مفتوح",
        predict_profit: "توقع الربح",
        profit: "ربح",
        profit_rate: "معدل الربح",
        select_trade_time: "حدد تاريخ انتهاء الصلاحية",
        statistics: "إحصائيات",
        trade_num: "كمية",
        trade_time: "مدة",
        trading_pairs: "أزواج التداول"
    },
    mining: {
        better1: "الإيداع والسحب في أي وقت",
        better2: "تصدر يوميا",
        better3: "دورة التعدين",
        better4: "إنزال جوي في أي وقت",
        coin_type: "عملة",
        day_profit: "نيسان المنتظر",
        doing: "في تَقَدم",
        expected_profit: "نيسان المنتظر",
        finished: "زيادة",
        input_lock_num: "الرجاء إدخال مبلغ القفل",
        interest: "اهتمام",
        machine_list: "قائمة آلات التعدين",
        machine_rent: "تأجير آلات التعدين",
        max_subscribe: "الحد الأقصى للاشتراك",
        mining: "الإدارة المالية",
        mining_time: "فترة التعدين",
        my_subscribe: "اشتراكي",
        name: "اسم",
        operate: "تعمل",
        pay: "يدفع",
        pay_penal_sum_redemption: "طلب الاسترداد المبكر للتعويضات المقطوعة",
        product_better: "مزايا المنتج",
        product_content: "التعدين السحابي هو استخدام USDT ليتم تكليفه بآلة تعدين الطاقة فائقة الحوسبة الخاصة بالمنصة لاستخراج الأرباح في مجمع التعدين الخاص بمنصة الذكاء الاصطناعي فائقة الذكاء.",
        product_desc: "وصف المنتج",
        profit_list: "قائمة الفوائد",
        redemption: "الخلاص الافتراضي",
        refunded: "ردها",
        refunding: "التقدم بطلب للحصول على استرداد",
        subscribe: "الاشتراك",
        subscribe_list: "قائمة الاشتراك",
        subscribe_num: "كمية الاشتراك",
        subscribe_time: "وقت الاشتراك",
        sum_profit: "إجمالي الإيرادات المقدرة",
        watch_profit_list: "عرض قائمة الفوائد"
    },
    transfer: {
        from: "من",
        history: "سجل النقل",
        input_number: "الرجاء إدخال كمية التحويل",
        number: "نقل الكمية",
        to: "ل"
    }
}
obj.Italy = {
    public: {
        name: "Nome",
        last_price: "Ultimo prezzo",
        market: "Tendenza",
        quotation: "Variazione 24H",
        no_data: "Nessun dato ancora",
        no_more: "No more",
        confirm: "conferma",
        use: "Disponibile",
        freeze: "Ferma",
        number: "Quantità",
        history: "Registra",
        other: "Altri",
        tip: "Prompt",
        copy_success: "Copiata con successo",
        upload_pic: "Caricamento certificato",
        submit: "Invia",
        status: "Status",
        set: "Imposta",
        chat: "Servizio online",
        copy: "Copia",
        delete: "elimina",
        confirm_del: "Sei sicuro di cancellare?",
        add: "Aggiungi",
        input_full: "Compilare",
        password_not_equal: "Inconsigenza della password",
        coming_soon: "Coming soon~",
        cancel: "Annulla",
        setting: "Impostazione",
        product_list: "Elenco prodotti",
        submit_order: "Invia ordine",
        all: "Tutto",
        clear: "Chiaro",
        close: "Chiusura",
        invite_tip: "Scansiona il modello del codice QR qui sopra o inserisci il codice di invito per confermare la registrazione.",
        my_assets: "I miei beni",
        please_input: "Per favore entra",
        record: "Documentazione",
        test: "Solo per testare",
        today: "Oggi",
        total_assets: "Conversione totale delle risorse dell'account"
    },
    user: {
        h_second: "secondo",
        h_timer: "conto alla rovescia",
        h_accept: "Accetta",
        h_welc: "Benvenuto in uso",
        announ_text: "Per motivi politici, i servizi non vengono forniti a Corea del Nord, Israele, Cina, Vanuatu e Cuba.",
        announ: "annuncio",
        com_email: "Email di reclamo",
        dh: "telefono",
        qh: "prefisso",
        qh_dh: "prefisso/telefono",
        user_center: "Il mio",
        login_email: "Inserisci la tua email",
        login_phone: "Accesso mobile",
        input_email: "Inserisci il tuo indirizzo email",
        input_phone: "Inserisci il tuo numero di cellulare",
        password: "Password",
        new_paw: "Nuova password",
        input_password: "Inserisci la tua password",
        re_input_pass: "Digita nuovamente la password",
        input_old_password: "Inserisci la tua vecchia password",
        new_user: "Nuovo utente?",
        join_us: "Unisciti ora",
        forgot_password: "Password dimenticata",
        login: "Login",
        area_code: "Codice della zona",
        register: "Registrati",
        register_email: "Inserisci la tua email",
        register_phone: "Registrazione mobile",
        can_use_asset: "Attività disponibili",
        logout: "Esci",
        confirm_logout: "Se recedere dal registro",
        logout_success: "Uscita riuscita",
        mock_login: "Non c'è bisogno di aprire un conto, crea un conto demo per fare trading ora!",
        account_detail: "Dettagli del conto",
        mock_account: "Conto di simulazione",
        invite_code: "Codice invito",
        input_invite_code: "Inserisci il codice dell'invito",
        copy_invite_link: "Copia link di invito",
        trade_account: "Conto di trading",
        only_true_account: "Si prega di registrarsi o accedere a un account vero e proprio hard",
        reset_mock_account: "Restituisce conto simulato",
        confirm_reset: "Indica se restituirlo",
        email: "Casella postale",
        welcome_login: "Benvenuto all'accesso",
        welcome_register: "Benvenuto per registrarsi",
        useful_balance: "Fondi disponibili",
        please_login: "Effettua il login"
    },
    forgot: {
        sms_code: "Codice di verifica",
        input_sms_code: "Inserisci il codice di verifica",
        send: "Invia",
        reset: "Ripristina password"
    },
    trade: {
        buy: "Compra",
        sell: "Vendi",
        last_price: "Prezzo di mercato",
        best_price: "Trading al miglior prezzo corrente",
        buy_price: "Prezzo",
        enter_price: "Inserisci il prezzo",
        trade_amount: "Dimensione del lotto di negoziazione",
        balance: "Saldo",
        buy_up: "andare lungo",
        buy_low: "Shorting",
        current_entrust: "Messa in servizio preliminare",
        type: "Tipo",
        time: "Data",
        price: "prezzo",
        trade_price: "Importo dell'operazione",
        operate: "Operazione",
        close_order: "Posizione di chiusura",
        high: "Alto",
        open: "Apri",
        low: "Basso",
        volume: "Volume totale",
        order: "Ordini",
        closed: "Chiuso",
        order_confirm: "Il tuo ordine è stato confermato",
        order_page: "Ordine pagina",
        no_mult: "Nessun multiplo",
        no_mult_config: "Nessuna leva configurata, impossibile effettuare un ordine temporaneamente"
    },
    order: {
        current_price: "Prezzo corrente",
        total_ol: "utile e perdita totale",
        holding: "Mantenimento della posizione",
        market_price: "Prezzo di mercato",
        un_deal_order: "Ordini pendenti",
        history: "Storia",
        hand_num: "Lotti",
        stop_loss: "Imposta perdita",
        stop_profit: "Imposta profitto",
        times: "Moltiplicatore",
        handle_fee: "Tassa di gestione",
        bond_fee: "Margine",
        balance: "Saldo",
        buy_in: "Compra",
        sell_out: "Vendi",
        trading: "Posizioni",
        dealing: "Ordini pendenti",
        profit: "Utile e perdite",
        total: "Valore netto",
        pay_rate: "Rapporto di pagamento anticipato",
        can_use: "Pagamento anticipato disponibile",
        trade_amount: "Lotti",
        unit: "Ogni foglio",
        page: "Foglio",
        hazard_rate: "Tasso di rischio",
        all_caution_money: "Margine attuale",
        detail: "Dettagli dell'ordine",
        close: "Posizione di chiusura",
        cancel: "Annulla ordine",
        calc_handle_fee: "Tassa di gestione stimata",
        calc_bond_fee: "Margine stimato",
        set_stop_price: "Salva",
        currency: "Coppie di transazioni",
        order_id: "Numero di prenotazione",
        order_type: "direzione",
        order_price: "Prezzo unitario inferiore",
        close_price: "Prezzo a buon mercato del magazzino",
        income: "profitto",
        confrim_close_order: "E' un magazzino economico?",
        open_time: "Orario aperto"
    },
    func: {
        charge_coin: "Deposito",
        withdraw_coin: "Ritiro",
        billing_detail: "Dettagli di fatturazione",
        real_auth: "Verifica del nome reale",
        invite_friend: "Invita amici",
        reset_password: "Cambia password",
        setting: "stabilimento",
        lang: "Lingua",
        wallet: "Portafoglio",
        buy_coin: "Acquista monete con carta bancaria",
        contract: "Contrarre",
        future: "Futuro",
        loan: "Prestito",
        more: "Di più",
        transfer: "Trasferire",
        video_desc: "Video"
    },
    financial: {
        financial_records: "Documenti finanziari",
        link_charge: "Ricarica sulla catena",
        bank_charge: "Filo telegrafico",
        charge_coin: "Monete",
        wallet_address: "Indirizzo portafoglio",
        copy_address: "Copia indirizzo",
        charge_amount: "Numero di monete",
        input_charge_amount: "Inserisci il numero di monete da addebitare",
        collect_coin_type: "Moneta di ricezione",
        coin: "Moneta digitale",
        bank: "Carta bancaria",
        select_network: "Seleziona rete",
        charge_num: "Importo di ricarica",
        input_charge_num: "Inserisci l'importo della ricarica",
        charge_history: "Registrazione dei depositi",
        uncheck: "Non controllato",
        isfinish: "Completato",
        isreject: "Respinto",
        unuseful: "Non valido"
    },
    bank: {
        swift_text: "SWIFT",
        coin_type: "Valuta beneficiario",
        name: "Nome della banca",
        address: "Indirizzo bancario",
        SWIFT: "SWIFT",
        username: "Beneficiario",
        account: "Conto beneficiario",
        remark: "Osservazione"
    },
    auth: {
        upload_idcard: "Si prega di caricare la parte anteriore e posteriore del passaporto / documento d'identità",
        front: "Anteriore",
        upload_front: "Carica la parte anteriore del passaporto/certificato",
        back: "Lato inverso",
        upload_back: "Carica il retro del passaporto/certificato",
        input_info: "Compila i tuoi dati personali",
        name: "Nome",
        input_name: "Inserisci il tuo nome",
        id_number: "Passaporto/numero d'identità",
        input_id_num: "Inserisci il tuo passaporto/numero d'identità",
        waiting: "Audit",
        finish: "Certificato"
    },
    withdraw: {
        amount: "Importo",
        symbol: "Valuta",
        withdraw_coin: "Invia il recesso",
        no_pay_way: "Non esiste un canale di pagamento per il conto in valuta francese.",
        calc_get: "Si prevede che",
        record: "Record di prelievo di monete",
        send_amount: "Numero di ricevute",
        withdraw_address: "Indirizzo per i prelievi di monete",
        unit: "Unità",
        select_withdraw_address: "Seleziona un indirizzo da chiamare"
    },
    wallet: {
        bind_bank_card: "Carta bancaria vincolata",
        bind_coin_address: "Indirizzo in valuta digitale vincolante",
        bind: "vincolante",
        save: "conservazione",
        not_bind: "Si prega di impostare un account di raccolta prima",
        change_account: "Conto di finanziamento",
        forex_account: "Conto contrattuale",
        micro_account: "Conto futuro"
    },
    follow: {
        apply_guide: "Istruzioni per l'applicazione",
        auto_follow: "Ogni volta che un esperto di trading apre una posizione su un prodotto, io aprirò automaticamente la posizione di conseguenza.",
        auto_open_positions: "Apertura automatica dei lotti",
        be_master: "Diventa un maestro",
        closed_follow_order: "Posizione chiusa in seguito all'ordine",
        commission_rate: "tasso di commissione",
        copy_profit: "Guadagno da nuovi ordini",
        cover_time: "Orario di chiusura",
        follow: "seguire",
        follow_master: "Segui il maestro",
        follow_now: "Segui ora",
        followed: "seguito",
        follower: "seguace",
        follower_num: "Numero di follower",
        follower_setting: "Impostazioni di follow-up",
        follower_sum: "Numero totale di follower",
        following_order: "Ordini successivi in ​​corso",
        history_order: "Ordini storici",
        i_agree: "Ho letto e sono d'accordo",
        lever: "multiplo",
        limit_price: "limite di prezzo",
        margin: "margine",
        master_trader: "Maestro del commercio",
        max_following: "massimo seguito",
        my_follower: "i miei seguaci",
        rate_of_return: "tasso di rendimento",
        size: "scala",
        start_ordering_now: "Inizia subito il tuo primo ordine",
        submit_apply: "presentare domanda",
        submit_multiple: "Ordina più",
        total_documentary_amount: "Importo totale dell'ordine",
        total_profit: "Entrate totali",
        total_revenue: "Entrate totali",
        unfollow: "Smetti di seguire",
        view_follow_earnings: "Visualizza il reddito seguente",
        will_pay_profit: "Proventi da saldare",
        be_trader: "diventare un commerciante",
        cancel_follow_tip: "Gli ordini aperti non seguiranno più l'ordine di chiusura, il che potrebbe comportare la perdita della migliore opportunità di chiusura. \nSei sicuro di voler annullare?",
        confirm_cancel_follow: "Annulla l'ordine successivo",
        max_follow_bond: "Margine successivo massimo per ordine",
        trader_list: "Elenco dei commercianti"
    },
    loan: {
        agreement: "Accordo",
        amount: "Quantità",
        auth_reject: "Rifiuto dell'audit",
        auth_success: "Approvato tramite revisione",
        auth_waiting: "Verifica in attesa",
        birthday: "Data di nascita:",
        confirm_repay: "Conferma di rimborso",
        confirm_repay_tip: "Si prega di confermare le informazioni di rimborso",
        confirm_repayment: "Conferma il rimborso",
        country: "Paese",
        day: "Giorno",
        day_rate: "Tasso di interesse giornaliero",
        female: "Femmina",
        first_name: "Cognome",
        free_day: "Giornate senza interessi",
        hand_pic: "Fototessera portatile",
        id_card: "ID",
        identify_card: "Certificati",
        input_amount: "Inserisci l'importo",
        input_country: "Inserisci il paese",
        input_first_name: "Per favore inserisci il cognome",
        input_last_name: "Inserisci un nome",
        input_mobile: "Inserisci il tuo numero di telefono",
        is_rejected: "Respinto",
        is_repay: "Riparato",
        last_name: "Nome",
        loan: "Prestito",
        loan_now: "Prendo in prestito adesso",
        loan_order: "Ordine di prestito",
        loaning: "Stai richiedendo un prestito",
        male: "Maschio",
        max: "Massimo",
        mobile: "Numero di telefono",
        need_repay: "Rimborso richiesto",
        passport: "Passaporto",
        penalty_amount: "Sanzione per violazione del contratto",
        please_sign: "Per favore firma con il tuo nome.",
        please_waiting: "Grazie per aver inviato il file KYC. \nIl nostro team controllerà le tue informazioni entro 48 ore. \nSi prega di pazientare e attendere i risultati dell'audit.",
        repay: "Rimborsare adesso",
        repayment_check: "Verifica del rimborso in corso",
        repayment_time: "Data di rimborso",
        resign: "Dimettersi",
        reviewed_at: "Concedetevi del tempo",
        select_day: "Seleziona una data",
        sex: "Genere",
        sign: "Autografo",
        start_loan: "Inizia a usufruire dei nostri servizi di prestito",
        to_repayment: "Vai avanti e ripaga",
        total_profit: "Interesse totale",
        transfer_address: "Indirizzo di trasferimento",
        upload_credit: "Carica le credenziali",
        verified: "Verificato",
        verify: "Avvia la verifica",
        copy_address: "Copia indirizzo",
        loan_time: "Durata del prestito"
    },
    micro: {
        "24h_volume": "Volume 24 ore",
        buy_down: "Compra giù",
        buy_up: "Acquista",
        calc_income: "Reddito atteso",
        calc_profit_rate: "Tasso di rendimento atteso",
        close: "Vicino",
        close_time: "Orario chiuso",
        closed_position: "Posizioni chiuse",
        direction: "Direzione",
        high: "Alto",
        in_transaction: "Nelle posizioni",
        input_trade_num: "Inserisci la quantità",
        low: "Basso",
        open: "Aprire",
        open_time: "Orario aperto",
        predict_profit: "Aspettatevi un profitto",
        profit: "Profitto",
        profit_rate: "Tasso di profitto",
        select_trade_time: "Seleziona la data di scadenza",
        statistics: "Statistiche",
        trade_num: "Quantità",
        trade_time: "Durata",
        trading_pairs: "Coppie di trading"
    },
    mining: {
        better1: "Deposita e ritira in qualsiasi momento",
        better2: "Emesso quotidianamente",
        better3: "Ciclo minerario",
        better4: "Lancio aereo in qualsiasi momento",
        coin_type: "Valuta",
        day_profit: "Atteso Nissan",
        doing: "in corso",
        expected_profit: "Atteso Nissan",
        finished: "Sopra",
        input_lock_num: "Inserisci l'importo del blocco",
        interest: "Interesse",
        machine_list: "Elenco delle macchine minerarie",
        machine_rent: "Noleggio macchine minerarie",
        max_subscribe: "Abbonamento massimo",
        mining: "Gestione finanziaria",
        mining_time: "Periodo minerario",
        my_subscribe: "Il mio abbonamento",
        name: "nome",
        operate: "operare",
        pay: "paga",
        pay_penal_sum_redemption: "Domanda di rimborso anticipato della penale",
        product_better: "Vantaggi del prodotto",
        product_content: "Il cloud mining consiste nell'utilizzare USDT per affidarlo alla macchina di supercalcolo power mining della piattaforma per estrarre i profitti nel pool minerario della piattaforma super intelligente AI.",
        product_desc: "descrizione del prodotto",
        profit_list: "Elenco dei vantaggi",
        redemption: "rimborso inadempiente",
        refunded: "rimborsato",
        refunding: "Richiesta di rimborso",
        subscribe: "Sottoscrizione",
        subscribe_list: "Elenco abbonamenti",
        subscribe_num: "Quantità di abbonamento",
        subscribe_time: "Tempo di abbonamento",
        sum_profit: "Entrate totali stimate",
        watch_profit_list: "Visualizza l'elenco dei vantaggi"
    },
    transfer: {
        from: "Da",
        history: "Registro del trasferimento",
        input_number: "Inserisci l'importo del trasferimento",
        number: "Quantità di trasferimento",
        to: "A"
    }
}
obj.tu = {
    public: {
        name: "İsim",
        last_price: "Son Ödül",
        market: "Trend",
        quotation: "24H Değiştirme",
        no_data: "Henüz veri yok",
        no_more: "Daha fazla yok.",
        confirm: "onaylama",
        use: "Mevcut",
        freeze: "Dock this window",
        number: "Kıymet",
        history: "Kaydet",
        other: "Başka",
        tip: "Sor",
        copy_success: "Başarılı kopyalandı",
        upload_pic: "Sertifikat Yükleniyor",
        submit: "Teslim et",
        status: "Durum",
        set: "Ayarla",
        chat: "Çevrimiçi Hizmeti",
        copy: "Kopiyalar",
        delete: "Sil",
        confirm_del: "Silecek misin?",
        add: "Ekle",
        input_full: "Lütfen tamamlayın.",
        password_not_equal: "Parola uyumsuz",
        coming_soon: "Yakında geliyorum",
        cancel: "Lütfen",
        setting: "Ayarlama",
        product_list: "Produkt Listesi",
        submit_order: "Sırasını yolla",
        all: "Tüm",
        clear: "Temizlemek",
        close: "Kapatma",
        invite_tip: "Kaydı onaylamak için yukarıdaki QR kod modelini tarayın veya davet kodunu girin.",
        my_assets: "Varlıklarım",
        please_input: "Lütfen girin",
        record: "Kayıt",
        test: "Sadece test için",
        today: "Bugün",
        total_assets: "Toplam hesap varlığı dönüşümü"
    },
    user: {
        h_second: "saniye",
        h_timer: "sayım",
        h_accept: "Kabul et",
        h_welc: "Kullanmaya hoş geldiniz.",
        announ_text: "Politik sebepleri yüzünden Kuzey Kore, İsrail, Çin, Vanuatu ve Kuba'ya hizmet verilmez.",
        announ: "duyuru",
        com_email: "Sıkıştırma e- postası",
        dh: "telefon",
        qh: "bölge kodu",
        qh_dh: "bölge kodu/telefonu",
        user_center: "Benim.",
        login_email: "E-postanızı girin",
        login_phone: "Mobil Giriş",
        input_email: "Lütfen e-posta adresinizi girin",
        input_phone: "Lütfen cep telefonunuzu girin.",
        password: "Parola",
        new_paw: "Yeni parola",
        input_password: "Lütfen parolanızı girin",
        re_input_pass: "Parola yeniden yaz",
        input_old_password: "Lütfen eski parolanızı girin",
        new_user: "Yeni Kullanıcı?",
        join_us: "Şimdi katılın",
        forgot_password: "Parola unut",
        login: "İçeri gir",
        area_code: "Bölge Kodu",
        register: "Kayıt",
        register_email: "E-postanızı girin",
        register_phone: "Mobil Kayıt",
        can_use_asset: "Available Assets",
        logout: "Çıkış",
        confirm_logout: "Kayıtlardan çekilmeyecek mi?",
        logout_success: "Başarılı çıkış",
        mock_login: "Bir hesap a çma gerek yok, şimdi ticaret için demo hesabı oluştur!",
        account_detail: "Hesap Ayrıntıları",
        mock_account: "Simülasyon Hesabı",
        invite_code: "Davet Kodu",
        input_invite_code: "Lütfen davet kodunu girin",
        copy_invite_link: "Davet Bağlantısını Kopiyala",
        trade_account: "Satış hesabı",
        only_true_account: "Lütfen gerçek zor bir hesaba kayıt veya girin",
        reset_mock_account: "Simüle hesabı geri verin",
        confirm_reset: "Döndürmek mi?",
        email: "E-posta",
        welcome_login: "İçeri girmenize hoş geldiniz",
        welcome_register: "Kayıtlara hoş geldiniz",
        useful_balance: "Mevcut fonlar",
        please_login: "Lütfen girin"
    },
    forgot: {
        sms_code: "Kontrol Kodu",
        input_sms_code: "Lütfen doğrulama kodunu girin",
        send: "Gönderin",
        reset: "Parolayı Sıfırla"
    },
    trade: {
        buy: "Alın.",
        sell: "Satın",
        last_price: "Pazar Ödülü",
        best_price: "En iyi fiyat satışı",
        buy_price: "Ödül",
        enter_price: "Lütfen fiyatı girin",
        trade_amount: "Trading lot size",
        balance: "Balans",
        buy_up: "Uzun git.",
        buy_low: "Kısayol",
        current_entrust: "Önceki Komisyon",
        type: "Türü",
        time: "Tarih",
        price: "fiyat",
        trade_price: "Transaksyon miktarı",
        operate: "Operasyon",
        close_order: "Yerini kapat",
        high: "Yüksek",
        open: "Aç",
        low: "Düşük",
        volume: "Toplam ses",
        order: "Emirler",
        closed: "Gizli",
        order_confirm: "Emriniz onaylandı.",
        order_page: "Sıra Sayfası",
        no_mult: "Çoklu yok",
        no_mult_config: "Hiçbir lever ayarlanmadı, sırayı geçici olarak yerleştiremedi"
    },
    order: {
        current_price: "Şimdiki fiyat",
        total_ol: "tamamen kazanç ve kaybı",
        holding: "Konum tutuyor",
        market_price: "Pazar Ödülü",
        un_deal_order: "Bekleyen Emirler",
        history: "Tarihi",
        hand_num: "Çok fazla",
        stop_loss: "Kaybı ayarla",
        stop_profit: "Profit ayarla",
        times: "Çoklucu",
        handle_fee: "Ödeme yönetimi",
        bond_fee: "Margin",
        balance: "Balans",
        buy_in: "Alın.",
        sell_out: "Satın",
        trading: "Konumlar",
        dealing: "Bekleyen Emirler",
        profit: "İşler ve Kaybetler",
        total: "Ağ değeri",
        pay_rate: "Ön ödeme Derisi",
        can_use: "Ön ödeme mevcut",
        trade_amount: "Çok fazla",
        unit: "Her çarşaf",
        page: "Tablo",
        hazard_rate: "Risk Rate",
        all_caution_money: "Şimdiki Margin",
        detail: "Sıra Ayrıntıları",
        close: "Yerini kapat",
        cancel: "Düzeni iptal et",
        calc_handle_fee: "Tahmin edilen Yönetim Beslemesi",
        calc_bond_fee: "Tahmin edilen Margin",
        set_stop_price: "Kaydet",
        currency: "Transaksyon çiftleri",
        order_id: "Koruma numarası",
        order_type: "yön",
        order_price: "Aşağıdaki birim fiyatı",
        close_price: "Peynir depo fiyatı",
        income: "kazanç",
        confrim_close_order: "Konum kapatılması",
        open_time: "Aç vakti"
    },
    func: {
        charge_coin: "Depozit",
        withdraw_coin: "Çıkarma",
        billing_detail: "Faturalama Ayrıntıları",
        real_auth: "Gerçek İsim Denetimi",
        invite_friend: "Arkadaşları davet et",
        reset_password: "Parola değiştir",
        setting: "kurum",
        lang: "Dil",
        wallet: "CüzdanComment",
        buy_coin: "Banka kartıyla para satın alın",
        contract: "Sözleşme",
        future: "Gelecek",
        loan: "Borç",
        more: "Daha",
        transfer: "Aktarım",
        video_desc: "Video"
    },
    financial: {
        financial_records: "Mali Kayıtlar",
        link_charge: "Zincirle yeniden yükleyin.",
        bank_charge: "telegraf kablo",
        charge_coin: "Coins",
        wallet_address: "Cüzdanın Adresi",
        copy_address: "Adresi kopyala",
        charge_amount: "Para sayısı",
        input_charge_amount: "Lütfen yüklenecek paranın sayısını girin",
        collect_coin_type: "Parayı alın",
        coin: "Dijital Valüt",
        bank: "Banka Kartı",
        select_network: "Ağ Seç",
        charge_num: "Tekrar yükle miktarı",
        input_charge_num: "Lütfen yeniden yükleme miktarını girin",
        charge_history: "Kayıt",
        uncheck: "Kontrol edilmemiş",
        isfinish: "Tamamlandı",
        isreject: "Red edildi",
        unuseful: "Keçersiz"
    },
    bank: {
        swift_text: "SWIFT",
        coin_type: "Fazi Vali",
        name: "Banka İsmi",
        address: "Banka Adresi",
        SWIFT: "SWIFT",
        username: "Payee",
        account: "Payee Hesabı",
        remark: "RemarkComment"
    },
    auth: {
        upload_idcard: "Lütfen pasaportunuz/kimliğinizin önünü ve arkasını yükleyin",
        front: "Ön",
        upload_front: "Pasaportunuz/sertifikanızın önünü yükleyin",
        back: "Ters taraf",
        upload_back: "Pasaportunuz/sertifikanızın tersi tarafını yükleyin",
        input_info: "Lütfen kişisel bilgilerinizi tamamlayın",
        name: "İsim",
        input_name: "Lütfen isminizi girin",
        id_number: "Pasaportu/Kimlik Numarası",
        input_id_num: "Lütfen pasaportunuzu/kimlik numarasını girin",
        waiting: "Seçme",
        finish: "Kullanılmış"
    },
    withdraw: {
        amount: "Kıymet",
        symbol: "Para",
        withdraw_coin: "Çıkarmayı yolla",
        no_pay_way: "Fransız para hesabı için ödeme kanalı yok.",
        calc_get: "Görünüşe göre",
        record: "Coin çekilme kayıtları",
        send_amount: "Gönderilen Sayısı",
        withdraw_address: "Para çekilmesi adresi",
        unit: "Birim",
        select_withdraw_address: "Lütfen aramak için bir adres seçin"
    },
    wallet: {
        bind_bank_card: "Bağlam banka kartı",
        bind_coin_address: "Dijital para adresini bağla",
        bind: "bağ",
        save: "koruması",
        not_bind: "Lütfen önce bir koleksiyon hesabını ayarlayın",
        change_account: "Finansman Hesabı",
        forex_account: "Sözleşme hesabı",
        micro_account: "Gelecek hesap"
    },
    follow: {
        apply_guide: "Uygulama talimatları",
        auto_follow: "Ne zaman bir ticaret uzmanı bir ürün üzerinde pozisyon açsa, ben de otomatik olarak buna göre pozisyon açacağım.",
        auto_open_positions: "Partilerin otomatik açılması",
        be_master: "Usta ol",
        closed_follow_order: "Siparişin ardından kapalı pozisyon",
        commission_rate: "komisyon oranı",
        copy_profit: "Yeni siparişlerden kar elde edin",
        cover_time: "Kapanış saati",
        follow: "takip etmek",
        follow_master: "Ustayı takip edin",
        follow_now: "Şimdi takip et",
        followed: "takip etti",
        follower: "takipçi",
        follower_num: "Takipçi sayısı",
        follower_setting: "Takip ayarları",
        follower_sum: "Toplam takipçi sayısı",
        following_order: "Takip siparişleri devam ediyor",
        history_order: "Tarihsel siparişler",
        i_agree: "okudum ve kabul ediyorum",
        lever: "çoklu",
        limit_price: "fiyat sınırı",
        margin: "marj",
        master_trader: "Ticaret ustası",
        max_following: "maksimum takip",
        my_follower: "benim takipçilerim",
        rate_of_return: "getiri oranı",
        size: "ölçek",
        start_ordering_now: "İlk siparişinize şimdi başlayın",
        submit_apply: "başvuruyu Gönder",
        submit_multiple: "Birden fazla sipariş verin",
        total_documentary_amount: "Toplam sipariş tutarı",
        total_profit: "Toplam gelir",
        total_revenue: "Toplam gelir",
        unfollow: "Takibi bırak",
        view_follow_earnings: "Aşağıdaki geliri görüntüle",
        will_pay_profit: "Gelirler ödenecek",
        be_trader: "tüccar olmak",
        cancel_follow_tip: "Açık emirler artık kapanış emrini takip etmeyecektir ve bu da en iyi kapanış fırsatının kaçırılmasına neden olabilir. \nİptal etmek istediğinizden emin misiniz?",
        confirm_cancel_follow: "Takip eden siparişi iptal et",
        max_follow_bond: "Sipariş başına maksimum takip marjı",
        trader_list: "Tüccar listesi"
    },
    loan: {
        agreement: "Anlaşma",
        amount: "Miktar",
        auth_reject: "Denetim reddi",
        auth_success: "İncelenerek onaylandı",
        auth_waiting: "Denetim bekleniyor",
        birthday: "Doğum Tarihi:",
        confirm_repay: "Geri Ödeme Onayı",
        confirm_repay_tip: "Lütfen geri ödeme bilgilerinizi onaylayın",
        confirm_repayment: "Geri ödemeyi onaylayın",
        copy_address: "Adresi kopyala",
        country: "Ülke",
        day: "Gün",
        day_rate: "Günlük faiz oranı",
        female: "Dişi",
        first_name: "Soyadı",
        free_day: "Faizsiz günler",
        hand_pic: "El kimlik fotoğrafı",
        id_card: "İD",
        identify_card: "Sertifikalar",
        input_amount: "Lütfen tutarı girin",
        input_country: "Lütfen ülkeyi girin",
        input_first_name: "Lütfen soyadınızı girin",
        input_last_name: "Lütfen bir ad girin",
        input_mobile: "Lütfen telefon numaranızı girin",
        is_rejected: "Reddedilmiş",
        is_repay: "Onarıldı",
        last_name: "İsim",
        loan: "Borç",
        loan_now: "Şimdi borçlanıyorum",
        loan_order: "Kredi siparişi",
        loan_time: "Kredi vadesi",
        loaning: "Kredi başvurusunda bulunuyorsunuz",
        male: "Erkek",
        max: "Maksimum",
        mobile: "Telefon numarası",
        need_repay: "Geri ödeme gerekli",
        passport: "Pasaport",
        penalty_amount: "Sözleşmenin ihlali cezası",
        please_sign: "Lütfen isminizi imzalayın.",
        please_waiting: "KYC dosyasını gönderdiğiniz için teşekkür ederiz. \nEkibimiz bilgilerinizi 48 saat içinde denetleyecektir. \nLütfen sabırlı olun ve denetim sonuçlarını bekleyin.",
        repay: "Şimdi geri öde",
        repayment_check: "Geri ödeme denetimi sürüyor",
        repayment_time: "Geri ödeme tarihi",
        resign: "İstifa etmek",
        reviewed_at: "Zamana izin ver",
        select_day: "Lütfen bir tarih seçin",
        sex: "Cinsiyet",
        sign: "İmza",
        start_loan: "Kredi hizmetlerimizden yararlanmaya başlayın",
        to_repayment: "Devam et ve borcunu öde",
        total_profit: "Toplam faiz",
        transfer_address: "Aktarım adresi",
        upload_credit: "Kimlik bilgilerini yükle",
        verified: "Doğrulandı",
        verify: "Doğrulamayı başlat"
    },
    micro: {
        "24h_volume": "24 Saatlik Hacim",
        buy_down: "Aşağı satın al",
        buy_up: "Satın al",
        calc_income: "Beklenen gelir",
        calc_profit_rate: "Beklenen getiri oranı",
        close: "Kapalı",
        close_time: "Kapalı zaman",
        closed_position: "Kapalı pozisyonlar",
        direction: "Yön",
        high: "Yüksek",
        in_transaction: "Pozisyonlarda",
        input_trade_num: "Lütfen miktarı girin",
        low: "Düşük",
        open: "Açık",
        open_time: "Açık zaman",
        predict_profit: "Kâr bekle",
        profit: "Kâr",
        profit_rate: "Kâr oranı",
        select_trade_time: "Son kullanma tarihini seçin",
        statistics: "İstatistikler",
        trade_num: "Miktar",
        trade_time: "Süre",
        trading_pairs: "Ticaret çiftleri"
    },
    mining: {
        better1: "İstediğiniz zaman para yatırın ve çekin",
        better2: "Günlük olarak verilir",
        better3: "Madencilik döngüsü",
        better4: "İstediğiniz zaman Airdrop",
        coin_type: "Para birimi",
        day_profit: "Beklenen Nissan",
        doing: "devam etmekte",
        expected_profit: "Beklenen Nissan",
        finished: "üzerinde",
        input_lock_num: "Lütfen kilit tutarını girin",
        interest: "Faiz",
        machine_list: "Madencilik makine listesi",
        machine_rent: "Madencilik makinesi kiralama",
        max_subscribe: "Maksimum abonelik",
        mining: "Finansal yönetim",
        mining_time: "Madencilik dönemi",
        my_subscribe: "Aboneliğim",
        name: "isim",
        operate: "işletmek",
        pay: "ödemek",
        pay_penal_sum_redemption: "Manevi tazminatın erken tahsili için başvuru",
        product_better: "Ürün avantajları",
        product_content: "Bulut madenciliği, yapay zeka süper akıllı platformunun madencilik havuzundaki karları çıkarmak için platformun süper bilgi işlem güç madenciliği makinesine emanet edilecek USDT'yi kullanmaktır.",
        product_desc: "Ürün Açıklaması",
        profit_list: "Fayda listesi",
        redemption: "varsayılan ödeme",
        refunded: "iade edildi",
        refunding: "Geri ödeme başvurusu",
        subscribe: "Abonelik",
        subscribe_list: "Abonelik listesi",
        subscribe_num: "Abonelik miktarı",
        subscribe_time: "Abonelik süresi",
        sum_profit: "Tahmini toplam gelir",
        watch_profit_list: "Avantaj listesini görüntüle"
    },
    transfer: {
        from: "İtibaren",
        history: "Kaydı aktar",
        input_number: "Lütfen transfer miktarını girin",
        number: "Transfer miktarı",
        to: "İle"
    }
}
obj.yd = {
    auth: {
        back: "sisi sebaliknya",
        finish: "diverifikasi",
        front: "depan",
        id_number: "Nomor paspor/ID",
        input_id_num: "Silakan masukkan nomor paspor/ID Anda",
        input_info: "Silakan lengkapi pesannya secara pribadi",
        input_name: "Silahkan masukan nama anda",
        name: "Nama",
        upload_back: "Unggah sisi belakang paspor/KTP Anda",
        upload_front: "Unggah bagian depan paspor/KTP Anda",
        upload_idcard: "Silakan unggah bagian depan dan belakang paspor/sertifikat Anda",
        waiting: "sedang ditinjau"
    },
    bank: {
        SWIFT: "cepat",
        account: "Akun penerima pembayaran",
        address: "Alamat bank",
        coin_type: "Mata uang penerimaan",
        name: "nama Bank",
        remark: "Komentar",
        swift_text: "cepat",
        username: "Penerima pembayaran"
    },
    financial: {
        bank: "kartu bank",
        bank_charge: "transfer rekening",
        charge_amount: "Kuantitas isi ulang",
        charge_coin: "isi ulang",
        charge_history: "Catatan setoran",
        charge_num: "Jumlah isi ulang",
        coin: "mata uang digital",
        collect_coin_type: "Mata uang penerimaan",
        copy_address: "Salin alamat",
        financial_records: "catatan keuangan",
        input_charge_amount: "Silakan masukkan jumlah isi ulang",
        input_charge_num: "Silakan masukkan jumlah isi ulang",
        isfinish: "lengkap",
        isreject: "ditolak",
        link_charge: "Isi ulang pada rantai",
        select_network: "Pilih jaringan",
        uncheck: "Tidak ditinjau",
        unuseful: "tidak sah",
        wallet_address: "alamat dompet"
    },
    forgot: {
        input_sms_code: "silakan masukkan kode verifikasi",
        reset: "mengatur ulang kata sandi",
        send: "mengantarkan",
        sms_code: "Kode verifikasi"
    },
    func: {
        billing_detail: "Detail penagihan",
        charge_coin: "Menyetorkan",
        invite_friend: "mengundang teman-teman",
        lang: "bahasa",
        real_auth: "Diverifikasi",
        reset_password: "ganti kata sandi",
        setting: "mempersiapkan",
        wallet: "dompet",
        withdraw_coin: "Tarik dana",
        buy_coin: "Beli koin dengan kartu bank",
        contract: "Kontrak",
        future: "Masa depan",
        loan: "Meminjamkan",
        more: "Lagi",
        transfer: "Transfer",
        video_desc: "Video"
    },
    order: {
        all_caution_money: "Margin saat ini",
        balance: "Keseimbangan",
        bond_fee: "batas",
        buy_in: "Membeli",
        calc_bond_fee: "Margin devisa",
        calc_handle_fee: "Biaya tambahan",
        can_use: "Pembayaran di muka tersedia",
        cancel: "Batalkan pesanan",
        close: "Tutup posisi",
        close_price: "Harga penutup",
        confrim_close_order: "Apakah akan menutup posisi",
        currency: "pasangan perdagangan",
        current_price: "harga sekarang",
        dealing: "pesanan tertunda",
        detail: "Detail pesanan",
        hand_num: "Banyak ukuran",
        handle_fee: "Biaya penanganan",
        hazard_rate: "tingkat risiko",
        history: "sejarah",
        holding: "Posisi",
        income: "penghasilan",
        market_price: "harga pasar",
        open_time: "Waktu pembukaan",
        order_id: "jumlah order",
        order_price: "Harga pesanan",
        order_type: "arah",
        page: "membuka",
        pay_rate: "Rasio pembayaran di muka",
        profit: "Laba rugi",
        sell_out: "menjual",
        set_stop_price: "Ubah take profit dan stop loss",
        stop_loss: "menghentikan kerugian",
        stop_profit: "Mengambil keuntungan",
        times: "banyak",
        total: "kekayaan bersih",
        total_ol: "Jumlah untung dan rugi",
        trade_amount: "Beli kuantitas",
        trading: "Buka posisi",
        un_deal_order: "pesanan tertunda",
        unit: "setiap"
    },
    public: {
        add: "Tambahkan",
        cancel: "Membatalkan",
        chat: "Hubungi Layanan Pelanggan",
        coming_soon: "Menantikan~",
        confirm: "mengonfirmasi",
        confirm_del: "konfirmasi untuk menghapus?",
        copy: "menyalin",
        copy_success: "Berhasil disalin",
        delete: "menghapus",
        freeze: "duduk",
        history: "Catatan",
        input_full: "Silakan isi secara lengkap",
        last_price: "Harga terbaru",
        market: "kecenderungan",
        name: "nama",
        no_data: "Tidak ada data",
        no_more: "tidak lagi",
        number: "kuantitas",
        other: "lainnya",
        password_not_equal: "Kebingungan kata sandi",
        product_list: "Daftar Produk",
        quotation: "Perubahan kutipan",
        set: "Merevisi",
        setting: "mempersiapkan",
        status: "negara",
        submit: "kirim",
        submit_order: "Memesan",
        tip: "petunjuk",
        upload_pic: "Unggah sumber daya",
        use: "Tersedia",
        all: "Semua",
        clear: "Jernih",
        close: "Penutup",
        invite_tip: "Pindai pola kode QR di atas atau masukkan kode undangan untuk mengonfirmasi pendaftaran.",
        my_assets: "Aset saya",
        please_input: "Silakan masuk",
        record: "Catatan",
        test: "Hanya untuk pengujian",
        today: "Hari ini",
        total_assets: "Konversi total aset akun"
    },
    trade: {
        balance: "Keseimbangan",
        best_price: "Bertransaksi dengan harga terbaik saat ini",
        buy: "Membeli",
        buy_low: "pendek",
        buy_price: "harga",
        buy_up: "Duoduo",
        close_order: "Tutup posisi",
        closed: "Pasar ditutup",
        current_entrust: "Pesanan saat ini",
        enter_price: "Silakan masukkan harga",
        high: "tinggi",
        last_price: "harga pasar",
        low: "Rendah",
        no_mult: "Belum ada kelipatannya",
        no_mult_config: "Leverage tidak dikonfigurasi dan pesanan tidak dapat dilakukan untuk sementara.",
        open: "membuka",
        operate: "beroperasi",
        order: "Memesan",
        order_confirm: "Pesanan Anda telah dikonfirmasi",
        order_page: "Halaman pesanan",
        price: "harga satuan",
        sell: "menjual",
        time: "waktu",
        trade_amount: "Banyak perdagangan",
        trade_price: "Volume transaksi",
        type: "jenis",
        volume: "ringkasan"
    },
    user: {
        account_detail: "Detail akun",
        announ: "pengumuman",
        announ_text: "Karena alasan kebijakan, layanan tidak disediakan ke Korea Utara, Israel, Tiongkok, Vanuatu, dan Kuba.",
        area_code: "daerah",
        can_use_asset: "Aset yang tersedia",
        com_email: "Email pengaduan",
        confirm_logout: "Apakah akan logout",
        confirm_reset: "Setel ulang atau tidak",
        copy_invite_link: "Salin tautan undangan",
        dh: "Telepon",
        email: "Surat",
        forgot_password: "lupa kata sandinya",
        h_accept: "menerima",
        h_second: "Kedua",
        h_timer: "Hitung mundur",
        h_welc: "selamat datang",
        input_email: "Masukkan email Anda",
        input_invite_code: "Silakan masukkan kode undangan",
        input_old_password: "Silakan masukkan kata sandi lama",
        input_password: "Silakan masukkan kata sandi",
        input_phone: "Masukkan nomor telepon anda",
        invite_code: "Kode undangan",
        join_us: "Bergabung sekarang",
        login: "Gabung",
        login_email: "Masuk Email",
        login_phone: "Masuk dengan telepon",
        logout: "keluar",
        logout_success: "keluar dengan sukses",
        mock_account: "Akun demo",
        mock_login: "Tidak perlu membuka akun, buat akun demo dan mulai trading sekarang!",
        new_paw: "kata sandi baru",
        new_user: "pengguna baru?",
        only_true_account: "Silakan mendaftar atau masuk ke akun nyata",
        password: "kata sandi",
        please_login: "silakan masuk",
        qh: "daerah",
        qh_dh: "Kode area/telepon",
        re_input_pass: "Masukkan kata sandi lagi",
        register: "daftar",
        register_email: "registrasi email",
        register_phone: "Daftarkan telepon Anda",
        reset_mock_account: "Setel ulang akun demo",
        trade_account: "akun transaksi",
        useful_balance: "Dana yang tersedia",
        user_center: "Pusat Pribadi",
        welcome_login: "Silakan masuk",
        welcome_register: "Selamat mendaftar"
    },
    wallet: {
        bind: "mengikat",
        bind_bank_card: "Ikat kartu bank",
        bind_coin_address: "Ikat alamat mata uang digital",
        not_bind: "Harap siapkan akun pembayaran terlebih dahulu",
        save: "menyimpan",
        change_account: "Akun Pendanaan",
        forex_account: "Akun kontrak",
        micro_account: "Akun masa depan"
    },
    withdraw: {
        amount: "kuantitas",
        calc_get: "Perkiraan kuantitas kedatangan",
        no_pay_way: "Saat ini tidak ada saluran pembayaran untuk rekening mata uang resmi ini",
        record: "Catatan penarikan koin",
        select_withdraw_address: "Silakan pilih alamat mata uang",
        send_amount: "Kuantitas kedatangan",
        symbol: "mata uang",
        unit: "satuan",
        withdraw_address: "Alamat penarikan",
        withdraw_coin: "Tarik koin"
    },
    follow: {
        apply_guide: "Instruksi aplikasi",
        auto_follow: "Setiap kali seorang ahli trading membuka posisi pada suatu produk, saya secara otomatis akan membuka posisi tersebut.",
        auto_open_positions: "Pembukaan lot secara otomatis",
        be_master: "Menjadi seorang master",
        closed_follow_order: "Posisi tertutup mengikuti perintah",
        commission_rate: "tingkat komisi",
        copy_profit: "Untung dari pesanan baru",
        cover_time: "Waktu tutup",
        follow: "mengikuti",
        follow_master: "Ikuti tuannya",
        follow_now: "Ikuti sekarang",
        followed: "diikuti",
        follower: "pengikut",
        follower_num: "Jumlah pengikut",
        follower_setting: "Pengaturan tindak lanjut",
        follower_sum: "Jumlah total pengikut",
        following_order: "Perintah tindak lanjut sedang diproses",
        history_order: "Perintah sejarah",
        i_agree: "Saya telah membaca dan setuju",
        lever: "banyak",
        limit_price: "batas harga",
        margin: "batas",
        master_trader: "Ahli perdagangan",
        max_following: "tindak lanjut yang maksimal",
        my_follower: "pengikut saya",
        rate_of_return: "tingkat pengembalian",
        size: "skala",
        start_ordering_now: "Mulai pesanan pertama Anda sekarang",
        submit_apply: "mengajukan permohonan",
        submit_multiple: "Pesan banyak",
        total_documentary_amount: "Jumlah total pesanan",
        total_profit: "Total pendapatan",
        total_revenue: "Total pendapatan",
        unfollow: "Berhenti mengikuti",
        view_follow_earnings: "Lihat pendapatan berikut",
        will_pay_profit: "Hasil yang harus diselesaikan",
        be_trader: "menjadi seorang pedagang",
        cancel_follow_tip: "Pesanan terbuka tidak lagi mengikuti pesanan penutupan, yang dapat mengakibatkan hilangnya peluang penutupan terbaik. \nApakah Anda yakin ingin membatalkan?",
        confirm_cancel_follow: "Batalkan pesanan berikut",
        max_follow_bond: "Margin berikut maksimum per pesanan",
        trader_list: "Daftar pedagang"
    },
    loan: {
        agreement: "Perjanjian",
        amount: "Jumlah",
        auth_reject: "Penolakan audit",
        auth_success: "Disetujui melalui peninjauan",
        auth_waiting: "Audit tertunda",
        birthday: "Tanggal lahir:",
        confirm_repay: "Konfirmasi Pelunasan",
        confirm_repay_tip: "Harap konfirmasi informasi pembayaran Anda",
        confirm_repayment: "Konfirmasikan pembayaran",
        copy_address: "Salin alamat",
        country: "Negara",
        day: "Hari",
        day_rate: "Suku bunga harian",
        female: "Perempuan",
        first_name: "Nama belakang",
        free_day: "Hari bebas bunga",
        hand_pic: "Foto ID genggam",
        id_card: "PENGENAL",
        identify_card: "Sertifikat",
        input_amount: "Silakan masukkan jumlahnya",
        input_country: "Silakan masukkan negaranya",
        input_first_name: "Silakan masukkan nama belakang",
        input_last_name: "Silakan masukkan nama",
        input_mobile: "Silakan masukkan nomor telepon Anda",
        is_rejected: "Ditolak",
        is_repay: "Diperbaiki",
        last_name: "Nama",
        loan: "Meminjamkan",
        loan_now: "Pinjam sekarang",
        loan_order: "Pesanan pinjaman",
        loan_time: "Jangka waktu pinjaman",
        loaning: "Anda mengajukan pinjaman",
        male: "Pria",
        max: "Maksimum",
        mobile: "Nomor telepon",
        need_repay: "Diperlukan pembayaran kembali",
        passport: "Paspor",
        penalty_amount: "Hukuman atas pelanggaran kontrak",
        please_sign: "Silakan tandatangani nama Anda.",
        please_waiting: "Terima kasih telah mengirimkan file KYC. \nTim kami akan mengaudit informasi Anda dalam waktu 48 jam. \nMohon bersabar dan menunggu hasil auditnya.",
        repay: "Bayar sekarang",
        repayment_check: "Audit pembayaran kembali sedang berlangsung",
        repayment_time: "Tanggal pembayaran",
        resign: "Berhenti",
        reviewed_at: "Berikan waktu",
        select_day: "Silakan pilih tanggal",
        sex: "Jenis kelamin",
        sign: "Tanda tangan",
        start_loan: "Mulailah menikmati layanan pinjaman kami",
        to_repayment: "Silakan dan bayar kembali",
        total_profit: "Jumlah bunga",
        transfer_address: "Alamat pemindahan",
        upload_credit: "Unggah kredensial",
        verified: "Terverifikasi",
        verify: "Mulai verifikasi"
    },
    micro: {
        "24h_volume": "Volume 24 jam",
        buy_down: "Beli turun",
        buy_up: "Memborong",
        calc_income: "Pendapatan yang diharapkan",
        calc_profit_rate: "Tingkat pengembalian yang diharapkan",
        close: "Menutup",
        close_time: "Waktu tertutup",
        closed_position: "Posisi tertutup",
        direction: "Arah",
        high: "Tinggi",
        in_transaction: "Dalam posisi",
        input_trade_num: "Silakan masukkan kuantitas",
        low: "Rendah",
        open: "Membuka",
        open_time: "Waktu terbuka",
        predict_profit: "Harapkan keuntungan",
        profit: "Laba",
        profit_rate: "Tingkat keuntungan",
        select_trade_time: "Pilih tanggal kedaluwarsa",
        statistics: "Statistik",
        trade_num: "Kuantitas",
        trade_time: "Lamanya",
        trading_pairs: "Pasangan perdagangan"
    },
    mining: {
        better1: "Setor dan tarik kapan saja",
        better2: "Dikeluarkan setiap hari",
        better3: "Siklus penambangan",
        better4: "Jatuhkan udara kapan saja",
        coin_type: "Mata uang",
        day_profit: "Nissan yang diharapkan",
        doing: "sedang berlangsung",
        expected_profit: "Nissan yang diharapkan",
        finished: "lebih",
        input_lock_num: "Silakan masukkan jumlah kunci",
        interest: "Minat",
        machine_list: "Daftar mesin penambangan",
        machine_rent: "Penyewaan mesin pertambangan",
        max_subscribe: "Langganan maksimal",
        mining: "Manajemen keuangan",
        mining_time: "Periode penambangan",
        my_subscribe: "Langganan saya",
        name: "nama",
        operate: "beroperasi",
        pay: "membayar",
        pay_penal_sum_redemption: "Permohonan untuk penebusan awal kerusakan yang dilikuidasi",
        product_better: "Keunggulan produk",
        product_content: "Penambangan awan adalah dengan menggunakan USDT untuk dipercayakan ke mesin penambangan kekuatan komputasi super platform untuk menambang keuntungan di kumpulan penambangan platform super-cerdas AI.",
        product_desc: "deskripsi produk",
        profit_list: "Daftar manfaat",
        redemption: "penebusan default",
        refunded: "dikembalikan",
        refunding: "Mengajukan permohonan pengembalian dana",
        subscribe: "Berlangganan",
        subscribe_list: "Daftar langganan",
        subscribe_num: "Kuantitas berlangganan",
        subscribe_time: "Waktu berlangganan",
        sum_profit: "Perkiraan total pendapatan",
        watch_profit_list: "Lihat daftar manfaat"
    },
    transfer: {
        from: "Dari",
        history: "Catatan transfer",
        input_number: "Silakan masukkan jumlah transfer",
        number: "Kuantitas transfer",
        to: "Ke"
    }
}
obj.md = {
    auth: {
        back: "ပြောင်းပြန်ဘက်",
        finish: "စိစစ်ပြီး",
        front: "ရှေ့",
        id_number: "နိုင်ငံကူးလက်မှတ်/ ID နံပါတ်",
        input_id_num: "ကျေးဇူးပြု၍ သင်၏ နိုင်ငံကူးလက်မှတ်/ ID နံပါတ်ကို ထည့်ပါ။",
        input_info: "ကျေးဇူးပြု၍ စာကို ကိုယ်တိုင်ကိုယ်ကျ ဖြည့်သွင်းပါ။",
        input_name: "ကျေးဇူးပြု၍ သင့်အမည်ကို ထည့်ပါ။",
        name: "နာမည်",
        upload_back: "သင့်ပတ်စပို့/ ID ၏ နောက်ဘက်ခြမ်းကို အပ်လုဒ်လုပ်ပါ။",
        upload_front: "သင့်ပတ်စပို့/ ID ၏ ရှေ့တွင် အပ်လုဒ်လုပ်ပါ။",
        upload_idcard: "ကျေးဇူးပြု၍ သင့်ပတ်စ်ပို့/လက်မှတ်၏ ရှေ့နှင့်နောက်ကို အပ်လုဒ်လုပ်ပါ။",
        waiting: "သုံးသပ်ချက်အောက်တွင်"
    },
    bank: {
        SWIFT: "မြန်သည်။",
        account: "ငွေလက်ခံသူအကောင့်",
        address: "ဘဏ်လိပ်စာ",
        bank_name: "ဘဏ်ခွဲအမည်",
        coin_type: "ငွေလက်ခံဖြတ်ပိုင်း",
        name: "ဘဏ်အမည်",
        remark: "မှတ်ချက်",
        swift_text: "မြန်သည်။",
        username: "ငွေလက်ခံသူ"
    },
    financial: {
        bank: "ဘဏ်ကဒ်",
        bank_charge: "ငွေလွှဲခြင်း",
        charge_amount: "ပမာဏကို ပြန်ဖြည့်ပါ။",
        charge_coin: "ငွေဖြည့်",
        charge_history: "အပ်ငွေမှတ်တမ်း",
        charge_num: "အားပြန်သွင်းသည့်ပမာဏ",
        coin: "ဒစ်ဂျစ်တယ်ငွေကြေး",
        collect_coin_type: "ငွေလက်ခံဖြတ်ပိုင်း",
        copy_address: "လိပ်စာကို ကူးယူပါ။",
        financial_records: "ဘဏ္ဍာရေးမှတ်တမ်းများ",
        input_charge_amount: "ကျေးဇူးပြု၍ အားပြန်သွင်းသည့်ပမာဏကို ထည့်ပါ။",
        input_charge_num: "ကျေးဇူးပြု၍ အားပြန်သွင်းသည့်ပမာဏကို ထည့်ပါ။",
        isfinish: "ပြီးပါပြီ။",
        isreject: "ငြင်းပယ်ခဲ့သည်။",
        link_charge: "ကြိုးပေါ်တွင် အားပြန်သွင်းပါ။",
        select_network: "ကွန်ရက်ကို ရွေးပါ။",
        uncheck: "မသုံးသပ်ပါ။",
        unuseful: "မမှန်ပါ။",
        wallet_address: "ပိုက်ဆံအိတ်လိပ်စာ"
    },
    forgot: {
        input_sms_code: "ကျေးဇူးပြု၍ အတည်ပြုကုဒ်ကို ထည့်ပါ။",
        reset: "လျှို့ဝှတ်နံပါတ်အားမူလအတိုင်းပြန်လုပ်သည်",
        send: "ပို့ဆောင်",
        sms_code: "အတည်ပြုရန်ကုတ်"
    },
    func: {
        billing_detail: "ငွေတောင်းခံမှုအသေးစိတ်",
        charge_coin: "အပ်ငွေ",
        invite_friend: "သူငယ်ချင်းများကိုဖိတ်ကြားသည်",
        lang: "ဘာသာစကား",
        real_auth: "စိစစ်ပြီး",
        reset_password: "စကားဝှက်ကိုပြောင်းရန်",
        setting: "တည်ဆောက်သည်",
        wallet: "ပိုက်ဆံအိတ်",
        withdraw_coin: "ရန်ပုံငွေများထုတ်ယူ"
    },
    order: {
        all_caution_money: "လက်ရှိအနားသတ်",
        balance: "လက်ကျန်",
        bond_fee: "အနားသတ်",
        buy_in: "ဝယ်",
        calc_bond_fee: "နိုင်ငံခြားငွေလဲလှယ်နှုန်း",
        calc_handle_fee: "အပိုကြေး",
        can_use: "ကြိုတင်ငွေပေးချေနိုင်ပါသည်။",
        cancel: "အော်ဒါဖျက်သိမ်းသည်",
        close: "အနီးကပ်အနေအထား",
        close_price: "အပိတ်ဈေး",
        confrim_close_order: "ရာထူးပိတ်မှာလား။",
        currency: "ကုန်သွယ်မှုစုံတွဲ",
        current_price: "လက်ရှိစျေးနှုန်း",
        dealing: "ဆိုင်းငံ့ထားသောအမိန့်",
        detail: "အော်ဒါအသေးစိတ်",
        hand_num: "အများကြီးအရွယ်အစား",
        handle_fee: "ကိုင်တွယ်ခ",
        hazard_rate: "အန္တရာယ်နှုန်း",
        history: "သမိုင်း",
        holding: "ရာထူး",
        income: "ဝင်ငွေ",
        market_price: "ဈေးကွက်ပေါက်ဈေး",
        open_time: "ဖွင့်ချိန်",
        order_id: "အော်ဒါနံပါတ်",
        order_price: "အော်ဒါစျေးနှုန်း",
        order_type: "ဦးတည်ချက်",
        page: "ဖွင့်သည်။",
        pay_rate: "ကြိုတင်ငွေပေးချေမှုအချိုး",
        profit: "အရှုံးအမြတ်",
        sell_out: "ရောင်း",
        set_stop_price: "အမြတ်ယူ၍ အရှုံးကို ရပ်တန့်ကာ ပြင်ဆင်ပါ။",
        stop_loss: "ဆုံးရှုံးမှုရပ်တန့်",
        stop_profit: "အမြတ်ယူပါ။",
        times: "မျိုးစုံ",
        total: "အသားတင်တန်တယ်။",
        total_ol: "စုစုပေါင်းအရှုံးအမြတ်",
        trade_amount: "ပမာဏကိုဝယ်ပါ။",
        trading: "ရာထူးတစ်ခုဖွင့်ပါ။",
        un_deal_order: "ဆိုင်းငံ့ထားသောအမိန့်",
        unit: "တစ်ခုစီ"
    },
    public: {
        tocust: "အခု ဆက်သွယ်ပါ",
        add: "ထည့်သည်",
        cancel: "မလုပ်တော့",
        chat: "ဖောက်သည်ဝန်ဆောင်မှုကို ဆက်သွယ်ပါ။",
        coming_soon: "စောင့်မျှော်နေပါတယ်~",
        confirm: "အတည်ပြုပါ။",
        confirm_del: "ဖျက်ရန် အတည်ပြုမလား။",
        copy: "ကော်ပီ",
        copy_success: "အောင်မြင်စွာ ကူးယူထားပါသည်။",
        delete: "ဖျက်ပါ။",
        freeze: "ထိုင်",
        history: "မှတ်တမ်း",
        input_full: "အပြည့်အစုံဖြည့်ပါ။",
        last_price: "နောက်ဆုံးစျေးနှုန်း",
        market: "လမ်းကြောင်းသစ်",
        name: "နာမည်",
        no_data: "ဒေတာမရှိပါ။",
        no_more: "မရှိတော့ပါ",
        number: "ပမာဏ",
        other: "အခြား",
        password_not_equal: "စကားဝှက်ရှုပ်ထွေးခြင်း။",
        product_list: "ကုန်ပစ္စည်းစာရင်း",
        quotation: "ကိုးကားပြောင်းလဲခြင်း။",
        set: "ပြန်လည်ပြင်ဆင်ပါ။",
        setting: "တည်ဆောက်သည်",
        status: "ပြည်နယ်",
        submit: "တင်ပြပါ။",
        submit_order: "အော်ဒါတင်ပါ။",
        tip: "သဲလွန်စ",
        upload_pic: "အရင်းအမြစ်များကို တင်ပါ။",
        use: "ရရှိနိုင်ပါသည်။"
    },
    trade: {
        balance: "လက်ကျန်",
        best_price: "လက်ရှိပေါက်ဈေးဖြင့် အရောင်းအ၀ယ်လုပ်ပါ။",
        buy: "ဝယ်",
        buy_low: "တိုတို",
        buy_price: "စျေးနှုန်း",
        buy_up: "ရှည်သွားလိုက်",
        close_order: "အနီးကပ်အနေအထား",
        closed: "ဈေးပိတ်တယ်။",
        current_entrust: "လက်ရှိအော်ဒါ",
        enter_price: "ကျေးဇူးပြု၍ စျေးနှုန်းထည့်ပါ။",
        high: "မြင့်မားသော",
        last_price: "ဈေးကွက်ပေါက်ဈေး",
        low: "နိမ့်သည်။",
        no_mult: "အဆမတန်သေးပါ။",
        no_mult_config: "Leverage ကို မသတ်မှတ်ထားဘဲ မှာကြားမှုများကို ယာယီထား၍မရပါ။",
        open: "ဖွင့်သည်။",
        operate: "လည်ပတ်",
        order: "အော်",
        order_confirm: "သင့်မှာယူမှုကို အတည်ပြုပြီးပါပြီ။",
        order_page: "အော်ဒါစာမျက်နှာ",
        price: "တစ်ခုချင်းစျေးနှုန်း",
        sell: "ရောင်း",
        time: "အချိန်",
        trade_amount: "အရောင်းအဝယ်တွေအများကြီး",
        trade_price: "ငွေပေးငွေယူပမာဏ",
        type: "အမျိုးအစား",
        volume: "အနှစ်ချုပ်"
    },
    user: {
        account_detail: "အကောင့်အသေးစိတ်",
        announ: "ကြေငြာချက်",
        announ_text: "မူဝါဒအကြောင်းများကြောင့်၊ မြောက်ကိုရီးယား၊ အစ္စရေး၊ တရုတ်၊ ဗာနူအာတူနှင့် ကျူးဘားတို့အား ဝန်ဆောင်မှုများ မပေးဆောင်ပါ။",
        area_code: "ဧရိယာ",
        can_use_asset: "ရနိုင်သောပစ္စည်းများ",
        com_email: "တိုင်ကြားစာ အီးမေးလ်",
        confirm_logout: "ထွက်မလား။",
        confirm_reset: "ပြန်လည်သတ်မှတ်သည်ဖြစ်စေ မပြုလုပ်ပါ။",
        copy_invite_link: "ဖိတ်ကြားချက်လင့်ခ်ကို ကူးယူပါ။",
        dh: "တယ်လီဖုန်း",
        email: "မေးလ်",
        forgot_password: "စကားဝှက်ကိုမေ့",
        h_accept: "လက်ခံ",
        h_second: "ဒုတိယ",
        h_timer: "နှစ်သစ်",
        h_welc: "ကြိုဆိုပါတယ်။",
        input_email: "သင့်အီးမေးလ်ကို ထည့်ပါ။",
        input_invite_code: "ကျေးဇူးပြု၍ ဖိတ်ကြားချက်ကုဒ်ကို ထည့်ပါ။",
        input_old_password: "စကားဝှက်ဟောင်းကို ထည့်ပါ။",
        input_password: "စကားဝှက်ထည့်ပါ။",
        input_phone: "ကျေးဇူးပြု၍ သင့်ဖုန်းနံပါတ်ကို ထည့်ပါ။",
        invite_code: "ဖိတ်စာကုဒ်",
        join_us: "ယခုချိတ်ဆက်ပါ။",
        login: "လော့ဂ်အင်",
        login_email: "အီးမေးလ် အကောင့်ဝင်ပါ။",
        login_phone: "ဖုန်းဖြင့်ဝင်ရောက်ပါ။",
        logout: "ဆိုင်းအောက်",
        logout_success: "အောင်မြင်စွာ ထွက်လိုက်ပါ။",
        mock_account: "ဒီမိုအကောင့်",
        mock_login: "အကောင့်ဖွင့်ရန်မလိုအပ်ပါ၊ သရုပ်ပြအကောင့်တစ်ခုဖန်တီးပြီး အရောင်းအဝယ်စတင်ပါ။",
        new_paw: "စကားဝှက်အသစ်",
        new_user: "အသုံးပြုသူအသစ်လား။",
        only_true_account: "ကျေးဇူးပြု၍ စာရင်းသွင်းပါ သို့မဟုတ် အကောင့်အစစ်သို့ ဝင်ရောက်ပါ။",
        password: "စကားဝှက်",
        please_login: "ကျေးဇူးပြု၍ ဝင်ရောက်ပါ။",
        qh: "ဧရိယာ",
        qh_dh: "ဧရိယာကုဒ်/ဖုန်း",
        re_input_pass: "စကားဝှက်ကို ထပ်ထည့်ပါ။",
        register: "မှတ်ပုံတင်",
        register_email: "အီးမေးလ်မှတ်ပုံတင်ခြင်း။",
        register_phone: "သင့်ဖုန်းကို မှတ်ပုံတင်ပါ။",
        reset_mock_account: "သရုပ်ပြအကောင့်ကို ပြန်လည်သတ်မှတ်ပါ။",
        trade_account: "ငွေပေးငွေယူအကောင့်",
        useful_balance: "ရနိုင်သောရန်ပုံငွေများ",
        user_center: "ကိုယ်ပိုင်စင်တာ",
        welcome_login: "ကျေးဇူးပြု၍ ဝင်ရောက်ပါ။",
        welcome_register: "စာရင်းသွင်းရန်ကြိုဆိုပါသည်။"
    },
    wallet: {
        bind: "ချည်နှောင်ခြင်း။",
        bind_bank_card: "ဘဏ်ကတ်ကို ချိတ်ပါ။",
        bind_coin_address: "ဒစ်ဂျစ်တယ်ငွေကြေးလိပ်စာကို စည်းပါ။",
        not_bind: "ကျေးဇူးပြု၍ ငွေပေးချေမှုအကောင့်ကို ဦးစွာသတ်မှတ်ပါ။",
        save: "ကယ်တင်ပါ။"
    },
    withdraw: {
        amount: "ပမာဏ",
        calc_get: "ခန့်မှန်းခြေ ရောက်ရှိလာသည့် ပမာဏ",
        no_pay_way: "လောလောဆယ်တွင် ဤတရားဝင်ငွေကြေးအကောင့်အတွက် ငွေပေးချေမှုလမ်းကြောင်းမရှိပါ။",
        record: "အကြွေစေ့ထုတ်ယူမှုမှတ်တမ်း",
        select_withdraw_address: "ငွေကြေးလိပ်စာကို ရွေးပါ။",
        send_amount: "ဆိုက်ရောက်အရေအတွက်",
        symbol: "ငွေကြေး",
        unit: "ယူနစ်",
        withdraw_address: "ငွေထုတ်လိပ်စာ",
        withdraw_coin: "ငွေဒင်္ဂါးများကိုထုတ်ယူပါ။"
    }
}
obj.lm = {
    auth: {
        back: "विपरीत पक्ष",
        finish: "प्रमाणित",
        front: "सामने",
        id_number: "पासपोर्ट/आईडी नंबर",
        input_id_num: "कृपया अपना पासपोर्ट/आईडी नंबर दर्ज करें",
        input_info: "कृपया अपनी व्यक्तिगत जानकारी पूरी करें",
        input_name: "कृपया अपना नाम दर्ज करें",
        name: "नाम",
        upload_back: "अपने पासपोर्ट/प्रमाणपत्र का पिछला भाग अपलोड करें",
        upload_front: "अपने पासपोर्ट/प्रमाणपत्र का अगला भाग अपलोड करें",
        upload_idcard: "कृपया अपने पासपोर्ट/आईडी का अगला और पिछला भाग अपलोड करें",
        waiting: "अंकेक्षण"
    },
    bank: {
        SWIFT: "तीव्र",
        account: "आदाता खाता",
        address: "बैंक पता",
        bank_name: "शाखा का नाम",
        coin_type: "लाभार्थी मुद्रा",
        name: "बैंक का नाम",
        remark: "टिप्पणी",
        swift_text: "तीव्र",
        username: "आदाता"
    },
    financial: {
        bank: "बैंक कार्ड",
        bank_charge: "टेलीग्राफ तार",
        charge_amount: "सिक्कों की संख्या",
        charge_coin: "सिक्के",
        charge_history: "जमा रिकार्ड",
        charge_num: "पुनर्भरण राशि",
        coin: "डिजिटल मुद्रा",
        collect_coin_type: "रसीद मुद्रा",
        copy_address: "पता कॉपी करें",
        financial_records: "वित्तीय रिकॉर्ड",
        input_charge_amount: "कृपया चार्ज किए जाने वाले सिक्कों की संख्या दर्ज करें",
        input_charge_num: "कृपया रिचार्ज राशि दर्ज करें",
        isfinish: "पुरा होना।",
        isreject: "अस्वीकार कर दिया",
        link_charge: "चेन पर रिचार्ज करें",
        select_network: "नेटवर्क चुनें",
        uncheck: "अनियंत्रित",
        unuseful: "अमान्य",
        wallet_address: "बटुआ पता"
    },
    forgot: {
        input_sms_code: "कृपया सत्यापन कोड दर्ज करें",
        reset: "पासवर्ड रीसेट",
        send: "भेजना",
        sms_code: "सत्यापन कोड"
    },
    func: {
        billing_detail: "बिलिंग विवरण",
        charge_coin: "जमा",
        invite_friend: "मित्रों को आमंत्रित करें",
        lang: "भाषा",
        real_auth: "वास्तविक नाम सत्यापन",
        reset_password: "पासवर्ड बदलें",
        setting: "स्थापना",
        wallet: "बटुआ",
        withdraw_coin: "निकासी"
    },
    order: {
        all_caution_money: "वर्तमान मार्जिन",
        balance: "संतुलन",
        bond_fee: "अंतर",
        buy_in: "खरीदना",
        calc_bond_fee: "अनुमानित मार्जिन",
        calc_handle_fee: "अनुमानित हैंडलिंग शुल्क",
        can_use: "पूर्वभुगतान उपलब्ध है",
        cancel: "आदेश रद्द",
        close: "बंद स्थिति",
        close_price: "सस्ते गोदाम मूल्य",
        confrim_close_order: "क्या पोजीशन बंद करनी है",
        currency: "लेन-देन जोड़े",
        current_price: "मौजूदा कीमत",
        dealing: "लंबित ऑर्डर",
        detail: "ऑर्डर का विवरण",
        hand_num: "बहुत",
        handle_fee: "संचालन शुल्क",
        hazard_rate: "जोखिम दर",
        history: "इतिहास",
        holding: "पद धारण",
        income: "लाभ",
        market_price: "बाजार कीमत",
        open_time: "खुलने का समय",
        order_id: "आरक्षण संख्या",
        order_price: "कम इकाई मूल्य",
        order_type: "दिशा",
        page: "बहुत",
        pay_rate: "पूर्वभुगतान अनुपात",
        profit: "लाभ और हानि",
        sell_out: "बेचना",
        set_stop_price: "बचाना",
        stop_loss: "हानि निर्धारित करें",
        stop_profit: "लाभ लेने के",
        times: "गुणक",
        total: "शुद्ध मूल्य",
        total_ol: "कुल लाभ और हानि",
        trade_amount: "बहुत",
        trading: "स्थितियां",
        un_deal_order: "लंबित ऑर्डर",
        unit: "प्रत्येक बहुत"
    },
    public: {
        tocust: "अब संपर्क",
        add: "जोड़ना",
        cancel: "रद्द करना",
        chat: "ऑनलाइन सेवा",
        coming_soon: "जल्द ही आ रहा है~",
        confirm: "इसकी सूचना देने वाला",
        confirm_del: "क्या वाकई हटाना है?",
        copy: "प्रतिलिपि",
        copy_success: "सफलतापूर्वक कॉपी किया गया",
        delete: "मिटाना",
        freeze: "जमाना",
        history: "अभिलेख",
        input_full: "कृपया पूर्ण करें",
        last_price: "अंतिम मूल्य",
        market: "रुझान",
        name: "नाम",
        no_data: "अभी तक कोई डेटा नहीं",
        no_more: "अब और नहीं",
        number: "मात्रा",
        other: "अन्य",
        password_not_equal: "पासवर्ड असंगति",
        product_list: "उत्पादों की सूची",
        quotation: "24H परिवर्तन",
        set: "तय करना",
        setting: "सेटिंग",
        status: "स्थिति",
        submit: "जमा करना",
        submit_order: "आदेश प्रस्तुत",
        tip: "तत्पर",
        upload_pic: "प्रमाणपत्र अपलोड करना",
        use: "उपलब्ध"
    },
    trade: {
        balance: "संतुलन",
        best_price: "सर्वोत्तम मौजूदा कीमत पर व्यापार",
        buy: "खरीदना",
        buy_low: "लघुकरण",
        buy_price: "कीमत",
        buy_up: "लंबे तक जाओ",
        close_order: "बंद स्थिति",
        closed: "बंद किया हुआ",
        current_entrust: "पूर्व कमीशनिंग",
        enter_price: "कृपया कीमत दर्ज करें",
        high: "उच्च",
        last_price: "बाजार कीमत",
        low: "कम",
        no_mult: "कोई एकाधिक नहीं",
        no_mult_config: "कोई लीवर कॉन्फ़िगर नहीं किया गया, अस्थायी रूप से ऑर्डर देने में असमर्थ",
        open: "खुला",
        operate: "संचालन",
        order: "आदेश",
        order_confirm: "आपके ऑर्डर की पुष्टि हो गई है",
        order_page: "ऑर्डर पेज",
        price: "कीमत",
        sell: "बेचना",
        time: "तारीख",
        trade_amount: "ट्रेडिंग लॉट का आकार",
        trade_price: "सोदा राशि",
        type: "प्रकार",
        volume: "कुल मात्रा"
    },
    user: {
        account_detail: "खाता विवरण",
        announ: "घोषणा",
        announ_text: "नीतिगत कारणों से, उत्तर कोरिया, इज़राइल, चीन, वानुअतु और क्यूबा को सेवाएँ प्रदान नहीं की जाती हैं।",
        area_code: "एरिया कोड",
        can_use_asset: "उपलब्ध संपत्ति",
        com_email: "शिकायत ईमेल",
        confirm_logout: "क्या रजिस्टर से हटना है",
        confirm_reset: "क्या इसे वापस करना है",
        copy_invite_link: "आमंत्रण लिंक कॉपी करें",
        dh: "टेलीफ़ोन",
        email: "ईमेल",
        forgot_password: "पासवर्ड भूल गए",
        h_accept: "स्वीकार करना",
        h_second: "दूसरा",
        h_timer: "उलटी गिनती",
        h_welc: "उपयोग में आपका स्वागत है",
        input_email: "कृपया अपना ईमेल एड्रेस इंटर करें",
        input_invite_code: "कृपया आमंत्रण कोड दर्ज करें",
        input_old_password: "कृपया अपना पुराना पासवर्ड दर्ज करें",
        input_password: "अपना पासवर्ड दर्ज करें",
        input_phone: "कृपया अपना सेल फ़ोन नंबर दर्ज करें",
        invite_code: "आमंत्रण संकेत",
        join_us: "अब शामिल हों",
        login: "लॉग इन करें",
        login_email: "अपना ईमेल दर्ज करें",
        login_phone: "मोबाइल लॉगिन",
        logout: "लॉग आउट",
        logout_success: "सफल निकास",
        mock_account: "सिमुलेशन खाता",
        mock_login: "खाता खोलने की कोई आवश्यकता नहीं है, अभी व्यापार करने के लिए एक डेमो खाता बनाएं!",
        new_paw: "नया पासवर्ड",
        new_user: "नए उपयोगकर्ता?",
        only_true_account: "कृपया वास्तविक हार्ड खाते में पंजीकरण करें या लॉग इन करें",
        password: "पासवर्ड",
        please_login: "कृपया लॉगिन करें",
        qh: "एरिया कोड",
        qh_dh: "क्षेत्र कोड/टेलीफोन",
        re_input_pass: "पासवर्ड दोबारा टाइप करें",
        register: "पंजीकरण करवाना",
        register_email: "अपना ईमेल दर्ज करें",
        register_phone: "मोबाइल पंजीकरण",
        reset_mock_account: "सिम्युलेटेड खाता लौटाएं",
        trade_account: "ट्रेडिंग खाते",
        useful_balance: "उपलब्ध कोष",
        user_center: "मेरा",
        welcome_login: "लॉगिन करने के लिए आपका स्वागत है",
        welcome_register: "पंजीकरण करने के लिए आपका स्वागत है"
    },
    wallet: {
        bind: "बंधन",
        bind_bank_card: "बैंक कार्ड बांधें",
        bind_coin_address: "डिजिटल मुद्रा पते को बाइंड करें",
        not_bind: "कृपया पहले एक संग्रहण खाता स्थापित करें",
        save: "संरक्षण"
    },
    withdraw: {
        amount: "मात्रा",
        calc_get: "यह उम्मीद है कि",
        no_pay_way: "फ़्रेंच मुद्रा खाते के लिए कोई भुगतान चैनल नहीं है।",
        record: "सिक्का निकासी रिकॉर्ड",
        select_withdraw_address: "कृपया कॉल करने के लिए एक पता चुनें",
        send_amount: "प्राप्तियों की संख्या",
        symbol: "मुद्रा",
        unit: "इकाई",
        withdraw_address: "सिक्के निकालने का पता",
        withdraw_coin: "निकासी जमा करें"
    }
}
obj.jk = {
    auth: {
        front: "přední",
        input_info: "Vyplňte prosím zprávu osobně",
        input_name: "zadejte své jméno",
        name: "název",
        upload_back: "Nahrajte zadní stranu pasu/občanského průkazu",
        upload_front: "Nahrajte přední stranu pasu/občanského průkazu",
        upload_idcard: "Nahrajte prosím přední a zadní stranu pasu/certifikátu",
        waiting: "pod kontrolou"
    },
    bank: {
        SWIFT: "rychle",
        account: "Účet příjemce platby",
        address: "adresa banky",
        bank_name: "",
        coin_type: "Měna příjmu",
        name: "jméno banky",
        remark: "Poznámka",
        swift_text: "rychle",
        username: "Příjemce platby"
    },
    financial: {
        bank: "bankovní karta",
        bank_charge: "drátový převod",
        charge_amount: "Množství nabití",
        charge_coin: "dolít",
        charge_history: "Záznam o vkladu",
        charge_num: "Částka dobití",
        coin: "digitální měna",
        collect_coin_type: "Měna příjmu",
        copy_address: "Zkopírujte adresu",
        financial_records: "finanční záznamy",
        input_charge_amount: "Zadejte částku dobití",
        input_charge_num: "Zadejte částku dobití",
        isfinish: "dokončeno",
        isreject: "odmítl",
        link_charge: "Dobíjejte na řetězu",
        select_network: "Vyberte síť",
        uncheck: "Nezkontrolováno",
        unuseful: "neplatný",
        wallet_address: "adresa peněženky"
    },
    forgot: {
        input_sms_code: "zadejte prosím ověřovací kód",
        reset: "obnovit heslo",
        send: "dodat",
        sms_code: "Ověřovací kód"
    },
    func: {
        billing_detail: "Fakturační údaje",
        charge_coin: "Vklad",
        invite_friend: "pozvat přátele",
        lang: "Jazyk",
        real_auth: "Ověřeno",
        reset_password: "změnit heslo",
        setting: "založit",
        wallet: "peněženka",
        withdraw_coin: "Vybrat finanční prostředky"
    },
    order: {
        all_caution_money: "Aktuální marže",
        balance: "Zůstatek",
        bond_fee: "okraj",
        buy_in: "Koupit",
        calc_bond_fee: "Devizová marže",
        calc_handle_fee: "Dodatečný poplatek",
        can_use: "Možnost platby předem",
        cancel: "Zrušit objednávku",
        close: "Zavřená poloha",
        close_price: "Závěrečná cena",
        confrim_close_order: "Zda uzavřít pozici",
        currency: "obchodní pár",
        current_price: "aktuální cena",
        dealing: "čekající objednávka",
        detail: "Podrobnosti o objednávce",
        hand_num: "Velikost pozemku",
        handle_fee: "manipulační poplatek",
        hazard_rate: "míra rizika",
        history: "Dějiny",
        holding: "Pozice",
        income: "příjem",
        market_price: "obchodní cena",
        open_time: "Otevírací doba",
        order_id: "číslo objednávky",
        order_price: "Cena objednávky",
        order_type: "směr",
        page: "OTEVŘENO",
        pay_rate: "Poměr záloh",
        profit: "Zisk a ztráta",
        sell_out: "prodat",
        set_stop_price: "Upravte take profit a stop loss",
        stop_loss: "zastavit ztrátu",
        stop_profit: "Vezměte si zisk",
        times: "násobek",
        total: "čisté jmění",
        total_ol: "Celkový zisk a ztráta",
        trade_amount: "Koupit množství",
        trading: "Otevřete pozici",
        un_deal_order: "čekající objednávka",
        unit: "každý"
    },
    public: {
        tocust: "Kontaktujte ihned",
        add: "Přidat do",
        cancel: "zrušení",
        chat: "Kontaktujte zákaznický servis",
        coming_soon: "Těším se ~",
        confirm: "potvrdit",
        confirm_del: "potvrdit smazání?",
        copy: "kopírovat",
        copy_success: "Úspěšně zkopírováno",
        delete: "vymazat",
        freeze: "sedět",
        history: "Záznam",
        input_full: "Vyplňte prosím kompletní",
        last_price: "Nejnovější cena",
        market: "trend",
        name: "název",
        no_data: "Žádná data",
        no_more: "už ne",
        number: "Množství",
        other: "jiný",
        password_not_equal: "Záměna hesla",
        product_list: "Seznam produktů",
        quotation: "Změna nabídky",
        set: "Revidovat",
        setting: "založit",
        status: "Stát",
        submit: "Předložit",
        submit_order: "Objednat",
        upload_pic: "Nahrajte zdroje"
    },
    trade: {
        balance: "Zůstatek",
        buy: "Koupit",
        buy_low: "krátký",
        buy_price: "cena",
        buy_up: "Duoduo",
        close_order: "Zavřená poloha",
        closed: "Trh uzavřen",
        current_entrust: "Aktuální pořadí",
        enter_price: "Zadejte prosím cenu",
        high: "vysoký",
        last_price: "obchodní cena",
        low: "Nízký",
        no_mult: "Zatím žádné násobky",
        no_mult_config: "Pákový efekt není nakonfigurován a objednávky nelze dočasně zadávat.",
        open: "OTEVŘENO",
        operate: "fungovat",
        order: "Objednat",
        order_confirm: "Vaše objednávka byla potvrzena",
        order_page: "Stránka objednávky",
        price: "jednotková cena",
        sell: "prodat",
        time: "čas",
        trade_amount: "Obchodní losy",
        trade_price: "Objem transakcí",
        type: "typ",
        volume: "souhrn"
    },
    user: {
        account_detail: "Detaily účtu",
        announ: "oznámení",
        announ_text: "Z politických důvodů nejsou služby poskytovány Severní Koreji, Izraeli, Číně, Vanuatu a Kubě.",
        area_code: "plocha",
        can_use_asset: "Dostupná aktiva",
        com_email: "Reklamační email",
        confirm_logout: "Zda se odhlásit",
        confirm_reset: "Resetovat nebo ne",
        copy_invite_link: "Zkopírujte odkaz na pozvánku",
        dh: "Telefon",
        email: "Pošta",
        forgot_password: "zapomenout heslo",
        h_accept: "akceptovat",
        h_second: "Druhý",
        h_timer: "Odpočítávání",
        h_welc: "Vítejte",
        input_email: "Zadejte prosím svůj email",
        input_invite_code: "Zadejte prosím kód pozvánky",
        input_old_password: "Zadejte staré heslo",
        input_password: "Prosím vložte heslo",
        input_phone: "zadejte prosím své telefonní číslo",
        invite_code: "Kód pozvánky",
        join_us: "Přidej se teď",
        login: "Přihlásit se",
        login_email: "Přihlášení e-mailem",
        login_phone: "Přihlaste se pomocí telefonu",
        logout: "odhlásit se",
        logout_success: "úspěšně ukončit",
        mock_account: "Demo účet",
        mock_login: "Není třeba zakládat účet, vytvořit demo účet a začít obchodovat hned!",
        new_paw: "nové heslo",
        new_user: "nový uživatel?",
        only_true_account: "Zaregistrujte se nebo se přihlaste ke skutečnému účtu",
        password: "Heslo",
        please_login: "prosím přihlašte se",
        qh: "plocha",
        qh_dh: "Předčíslí/telefon",
        re_input_pass: "Zadejte heslo znovu",
        register: "Registrovat",
        register_email: "emailová registrace",
        register_phone: "Zaregistrujte svůj telefon",
        reset_mock_account: "Resetovat demo účet",
        trade_account: "transakční účet",
        useful_balance: "Dostupné prostředky",
        user_center: "Osobní centrum",
        welcome_login: "Přihlaste se prosím",
        welcome_register: "Vítejte v registraci"
    },
    wallet: {
        bind: "vazba",
        bind_bank_card: "Svažte bankovní kartu",
        bind_coin_address: "Svažte adresu digitální měny",
        not_bind: "Nejprve si prosím nastavte platební účet",
        save: "Uložit"
    },
    withdraw: {
        amount: "Množství",
        calc_get: "Odhadované množství při příjezdu",
        no_pay_way: "Pro tento účet v legální měně v současné době neexistuje žádný platební kanál",
        record: "Záznam o výběru mincí",
        select_withdraw_address: "Vyberte adresu měny",
        send_amount: "Příjezdové množství",
        symbol: "měna",
        unit: "jednotka",
        withdraw_address: "Adresa pro výběr",
        withdraw_coin: "Vytáhněte mince"
    }
}
export default obj;

